export const Learnsets: {[k: string]: ModdedLearnsetData} = {
	missingno: {
		learnset: {
			blizzard: ["1L1"],
			bubblebeam: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			earthquake: ["1L1"],
			fissure: ["1L1"],
			fly: ["1L1"],
			icebeam: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			psychic: ["1L1"],
			rage: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			seismictoss: ["1L1"],
			skyattack: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			teleport: ["1L1"],
			thunder: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			watergun: ["1L1"],
		},
	},
	bulbasaur: {
		learnset: {
			acidspray: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			frenzyplant: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			ingrain: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			petaldance: ["1L1"],
			poisonpowder: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			razorleaf: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			skullbash: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			vinewhip: ["1L1"],
			weatherball: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 1, shiny: 1, ivs: {def: 31}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 5, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 5, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 5},
		],
	},
	ivysaur: {
		learnset: {
			acidspray: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			poisonpowder: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			vinewhip: ["1L1"],
			weatherball: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	venusaur: {
		learnset: {
			acidspray: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			frenzyplant: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			poisonjab: ["1L1"],
			poisonpowder: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			vinewhip: ["1L1"],
			weatherball: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 100, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	charmander: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bellydrum: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blastburn: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			howl: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 40, gender: "M", nature: "Mild", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 40, gender: "M", nature: "Naive", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 40, gender: "M", nature: "Naughty", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 4, level: 40, gender: "M", nature: "Hardy", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 1, shiny: 1, ivs: {spe: 31}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 5, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 5, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 5},
		],
	},
	charmeleon: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
	},
	charizard: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bellydrum: ["1L1"],
			bide: ["1L1"],
			blastburn: ["1L1"],
			blazekick: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			fissure: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			holdhands: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			skullbash: ["1L1"],
			skydrop: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 36, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 36, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 36, shiny: true, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 36, gender: "M", nature: "Serious", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 40, nature: "Jolly", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 40, gender: "M", nature: "Jolly", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 40, gender: "M", nature: "Adamant", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 50, gender: "M", nature: "Adamant", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 9, level: 50, nature: "Adamant", ivs: {hp: 20, atk: 31, def: 20, spa: 20, spd: 20, spe: 31}, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	squirtle: {
		learnset: {
			aquajet: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			falseswipe: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			lifedew: ["1L1"],
			liquidation: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shellsmash: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			waterspout: ["1L1"],
			wavecrash: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			withdraw: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 1, shiny: 1, ivs: {hp: 31}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 5, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 5, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 5},
		],
	},
	wartortle: {
		learnset: {
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shellsmash: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			withdraw: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	blastoise: {
		learnset: {
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			falseswipe: ["1L1"],
			fissure: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shellsmash: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			withdraw: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 100, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	caterpie: {
		learnset: {
			bugbite: ["1L1"],
			electroweb: ["1L1"],
			snore: ["1L1"],
			stringshot: ["1L1"],
			tackle: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 3},
			{generation: 2, level: 3},
			{generation: 3, level: 3},
		],
	},
	metapod: {
		learnset: {
			bugbite: ["1L1"],
			electroweb: ["1L1"],
			harden: ["1L1"],
			irondefense: ["1L1"],
			stringshot: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 4},
			{generation: 2, level: 4},
			{generation: 3, level: 4},
			{generation: 4, level: 3},
			{generation: 6, level: 4},
			{generation: 7, level: 3},
		],
	},
	butterfree: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			morningsun: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			ominouswind: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psywave: ["1L1"],
			quiverdance: ["1L1"],
			rage: ["1L1"],
			ragepowder: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			teleport: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			whirlwind: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 30, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 7},
			{generation: 4, level: 6},
			{generation: 7, level: 9},
		],
	},
	weedle: {
		learnset: {
			bugbite: ["1L1"],
			electroweb: ["1L1"],
			poisonsting: ["1L1"],
			stringshot: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 3},
			{generation: 2, level: 3},
			{generation: 3, level: 3},
		],
	},
	kakuna: {
		learnset: {
			bugbite: ["1L1"],
			electroweb: ["1L1"],
			harden: ["1L1"],
			irondefense: ["1L1"],
			stringshot: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 4},
			{generation: 2, level: 4},
			{generation: 3, level: 4},
			{generation: 4, level: 3},
			{generation: 6, level: 4},
			{generation: 7, level: 3},
		],
	},
	beedrill: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fellstinger: ["1L1"],
			flash: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			silverwind: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			twineedle: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 30, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 7},
			{generation: 4, level: 6},
		],
	},
	pidgey: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			feintattack: ["1L1"],
			fly: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gust: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 2},
			{generation: 2, level: 2},
			{generation: 3, level: 2},
		],
	},
	pidgeotto: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gust: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 30, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 9},
			{generation: 2, level: 7},
			{generation: 3, level: 7},
			{generation: 4, level: 7},
		],
	},
	pidgeot: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			laserfocus: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 61, gender: "M", nature: "Naughty", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 7, level: 29},
		],
	},
	rattata: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			flamewheel: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperfang: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			mefirst: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			watergun: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 2},
			{generation: 2, level: 2},
			{generation: 3, level: 2},
		],
	},
	rattataalola: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperfang: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			mefirst: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quash: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			stockpile: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			switcheroo: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	raticate: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hyperfang: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			watergun: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 34, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 15},
			{generation: 2, level: 6},
			{generation: 4, level: 13},
		],
	},
	raticatealola: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bulkup: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hyperfang: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quash: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 7, level: 17},
		],
	},
	raticatealolatotem: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bulkup: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hyperfang: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quash: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 20, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	spearow: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			drillrun: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			featherdance: ["1L1"],
			feintattack: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 22, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 3},
			{generation: 2, level: 2},
			{generation: 3, level: 3},
		],
	},
	fearow: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			drillrun: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 19},
			{generation: 2, level: 7},
			{generation: 4, level: 7},
		],
	},
	ekans: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			belch: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			fissure: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			glare: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonfang: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			skittersmack: ["1L1"],
			skullbash: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			switcheroo: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			wrap: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 14, gender: "F", nature: "Docile", ivs: {hp: 26, atk: 28, def: 6, spa: 14, spd: 30, spe: 11}, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 1, level: 6},
			{generation: 2, level: 4},
		],
	},
	arbok: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			fissure: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			glare: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			infestation: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			skittersmack: ["1L1"],
			skullbash: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			wrap: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 33, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 10},
			{generation: 4, level: 10},
		],
	},
	pichu: {
		learnset: {
			attract: ["1L1"],
			bestow: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nuzzle: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			volttackle: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
			{generation: 4, level: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 30, shiny: true, gender: "M", nature: "Jolly", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 9, level: 30, shiny: true, gender: "M", nature: "Jolly", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	pichuspikyeared: {
		learnset: {
			attract: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			volttackle: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 30, gender: "F", nature: "Naughty", moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	pikachu: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			bestow: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			happyhour: ["1L1"],
			headbutt: ["1L1"],
			heartstamp: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			holdhands: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nuzzle: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sing: ["1L1"],
			skullbash: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			volttackle: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
			yawn: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 10, gender: "F", nature: "Hardy", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, gender: "M", nature: "Hardy", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 20, gender: "F", nature: "Bashful", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 20, gender: "M", nature: "Jolly", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 40, gender: "M", nature: "Modest", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 20, gender: "F", nature: "Bashful", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 40, gender: "M", nature: "Mild", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 20, gender: "F", nature: "Bashful", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 30, gender: "M", nature: "Naughty", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, gender: "M", nature: "Relaxed", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 20, gender: "M", nature: "Docile", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, gender: "M", nature: "Naughty", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 20, gender: "M", nature: "Bashful", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 30, gender: "F", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 100, shiny: 1, gender: "F", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, shiny: 1, gender: "F", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, gender: "F", nature: "Timid", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 100, gender: "M", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, gender: "M", nature: "Brave", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 22, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, gender: "F", moves: ["1L1"], pokeball: "healball"},
			{generation: 6, level: 36, shiny: true, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, gender: "F", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, gender: "M", nature: "Naughty", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, perfectIVs: 2, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 99, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "healball"},
			{generation: 7, level: 10, nature: "Jolly", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 40, shiny: 1, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 7, level: 5, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 5, gender: "M", nature: "Serious", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 21, gender: "M", nature: "Brave", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 25, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 9, level: 5, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 9, level: 100, gender: "M", nature: "Quiet", perfectIVs: 6, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 9, level: 25, gender: "M", ivs: {hp: 25, atk: 25, def: 25, spa: 25, spd: 25, spe: 25}, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 3},
			{generation: 2, level: 4},
			{generation: 3, level: 3},
		],
	},
	pikachucosplay: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			brickbreak: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			nuzzle: ["1L1"],
			playnice: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			tailwhip: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 20, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	pikachurockstar: {
		learnset: {
			meteormash: ["1L1"],
		},
		eventOnly: false,
	},
	pikachubelle: {
		learnset: {
			iciclecrash: ["1L1"],
		},
		eventOnly: false,
	},
	pikachupopstar: {
		learnset: {
			drainingkiss: ["1L1"],
		},
		eventOnly: false,
	},
	pikachuphd: {
		learnset: {
			electricterrain: ["1L1"],
		},
		eventOnly: false,
	},
	pikachulibre: {
		learnset: {
			flyingpress: ["1L1"],
		},
		eventOnly: false,
	},
	pikachuoriginal: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nastyplot: ["1L1"],
			nuzzle: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			volttackle: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 1, nature: "Hardy", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 8, level: 25, nature: "Hardy", isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	pikachuhoenn: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nastyplot: ["1L1"],
			nuzzle: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			volttackle: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 6, nature: "Hardy", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 8, level: 25, nature: "Hardy", isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	pikachusinnoh: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nastyplot: ["1L1"],
			nuzzle: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			volttackle: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 10, nature: "Hardy", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 8, level: 25, nature: "Hardy", isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	pikachuunova: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nastyplot: ["1L1"],
			nuzzle: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			volttackle: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 14, nature: "Hardy", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 8, level: 25, nature: "Hardy", isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	pikachukalos: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nastyplot: ["1L1"],
			nuzzle: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			volttackle: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 17, nature: "Hardy", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 8, level: 25, nature: "Hardy", isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	pikachualola: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nastyplot: ["1L1"],
			nuzzle: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			volttackle: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 20, nature: "Hardy", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 8, level: 25, nature: "Hardy", isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	pikachupartner: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nastyplot: ["1L1"],
			nuzzle: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			volttackle: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 21, shiny: 1, nature: "Hardy", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 8, level: 25, nature: "Hardy", isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	pikachustarter: {
		learnset: {
			agility: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			dig: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			facade: ["1L1"],
			floatyfall: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			payday: ["1L1"],
			pikapapow: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			seismictoss: ["1L1"],
			slam: ["1L1"],
			splishysplash: ["1L1"],
			substitute: ["1L1"],
			tailwhip: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			zippyzap: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 5, perfectIVs: 6, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	pikachuworld: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nastyplot: ["1L1"],
			nuzzle: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			volttackle: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 25, nature: "Hardy", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 8, level: 80, nature: "Hardy", ivs: {hp: 31, atk: 30, def: 30, spa: 31, spd: 30, spe: 31}, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	raichu: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nuzzle: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			speedswap: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	raichualola: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nastyplot: ["1L1"],
			nuzzle: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psyshock: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seismictoss: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			speedswap: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	sandshrew: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			lowkick: ["1L1"],
			magnitude: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 12, gender: "M", nature: "Docile", ivs: {hp: 4, atk: 23, def: 8, spa: 31, spd: 1, spe: 25}, moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 1, level: 6},
		],
	},
	sandshrewalola: {
		learnset: {
			aerialace: ["1L1"],
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			iceball: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			lowkick: ["1L1"],
			metalclaw: ["1L1"],
			mirrorcoat: ["1L1"],
			mist: ["1L1"],
			nightslash: ["1L1"],
			poisonjab: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 10, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	sandslash: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fissure: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			lowkick: ["1L1"],
			magnitude: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 10},
			{generation: 4, level: 10},
		],
	},
	sandslashalola: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			iceball: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			lowkick: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			mist: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	nidoranf: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flatter: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			icebeam: ["1L1"],
			irontail: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poisonfang: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterpulse: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 2},
		],
	},
	nidorina: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flatter: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			horndrill: ["1L1"],
			icebeam: ["1L1"],
			irontail: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poisonfang: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 15, pokeball: "safariball"},
		],
	},
	nidoqueen: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drillrun: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			horndrill: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			payday: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uproar: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 41, perfectIVs: 2, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	nidoranm: {
		learnset: {
			amnesia: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flatter: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hornattack: ["1L1"],
			horndrill: ["1L1"],
			icebeam: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterpulse: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 2},
		],
	},
	nidorino: {
		learnset: {
			amnesia: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flatter: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hornattack: ["1L1"],
			horndrill: ["1L1"],
			icebeam: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 15, pokeball: "safariball"},
		],
	},
	nidoking: {
		learnset: {
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drillrun: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			hornattack: ["1L1"],
			horndrill: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			megahorn: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			payday: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uproar: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 68, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	cleffa: {
		learnset: {
			afteryou: ["1L1"],
			alluringvoice: ["1L1"],
			amnesia: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mistyterrain: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			softboiled: ["1L1"],
			solarbeam: ["1L1"],
			splash: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wish: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	clefairy: {
		learnset: {
			afteryou: ["1L1"],
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bestow: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			cosmicpower: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			meteorbeam: ["1L1"],
			meteormash: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			minimize: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sing: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			softboiled: ["1L1"],
			solarbeam: ["1L1"],
			splash: ["1L1"],
			spotlight: ["1L1"],
			stealthrock: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			wakeupslap: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 50, gender: "F", shiny: true, nature: "Bold", isHidden: true, ivs: {hp: 31, atk: 0, def: 31, spa: 31, spd: 31, spe: 31}, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 15, gender: "M", nature: "Modest", abilities: ["1L1"], moves: ["1L1"], pokeball: "moonball"},
		],
		encounters: [
			{generation: 1, level: 8},
		],
	},
	clefable: {
		learnset: {
			afteryou: ["1L1"],
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			cosmicpower: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			meteorbeam: ["1L1"],
			meteormash: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			minimize: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sing: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			softboiled: ["1L1"],
			solarbeam: ["1L1"],
			splash: ["1L1"],
			spotlight: ["1L1"],
			stealthrock: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	vulpix: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flail: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			grudge: ["1L1"],
			headbutt: ["1L1"],
			healingwish: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			irontail: ["1L1"],
			memento: ["1L1"],
			mimic: ["1L1"],
			mysticalfire: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailslap: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 18, gender: "F", nature: "Quirky", ivs: {hp: 15, atk: 6, def: 3, spa: 25, spd: 13, spe: 22}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 18, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 18},
		],
	},
	vulpixalola: {
		learnset: {
			agility: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			auroraveil: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			flail: ["1L1"],
			foulplay: ["1L1"],
			freezedry: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			grudge: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			iceshard: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			mist: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			nastyplot: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			powdersnow: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			sheercold: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailslap: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 10, gender: "F", nature: "Modest", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	ninetales: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grudge: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			mimic: ["1L1"],
			mysticalfire: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailslap: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, gender: "M", nature: "Bold", ivs: {def: 31}, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	ninetalesalola: {
		learnset: {
			agility: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			foulplay: ["1L1"],
			freezedry: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grudge: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			iceshard: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			mist: ["1L1"],
			mistyterrain: ["1L1"],
			nastyplot: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			powdersnow: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sheercold: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailslap: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			weatherball: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	igglybuff: {
		learnset: {
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mistyterrain: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			perishsong: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
		],
	},
	jigglypuff: {
		learnset: {
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sing: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			steelroller: ["1L1"],
			stockpile: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			triattack: ["1L1"],
			uproar: ["1L1"],
			wakeupslap: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 3},
			{generation: 2, level: 3},
			{generation: 3, level: 3},
		],
	},
	wigglytuff: {
		learnset: {
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			minimize: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sing: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			steelroller: ["1L1"],
			stockpile: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			triattack: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 22},
		],
	},
	zubat: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gust: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			leechlife: ["1L1"],
			meanlook: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			payback: ["1L1"],
			pluck: ["1L1"],
			poisonfang: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 6},
			{generation: 2, level: 2},
		],
	},
	golbat: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			leechlife: ["1L1"],
			meanlook: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			payback: ["1L1"],
			pluck: ["1L1"],
			poisonfang: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 13},
			{generation: 3, level: 5},
			{generation: 4, level: 10},
			{generation: 6, level: 19, maxEggMoves: 1},
			{generation: 7, level: 20},
		],
	},
	crobat: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crosspoison: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			haze: ["1L1"],
			heatwave: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			leechlife: ["1L1"],
			meanlook: ["1L1"],
			mimic: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			payback: ["1L1"],
			pluck: ["1L1"],
			poisonfang: ["1L1"],
			protect: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			wingattack: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 30, gender: "M", nature: "Timid", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 64, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	oddish: {
		learnset: {
			absorb: ["1L1"],
			acid: ["1L1"],
			acidspray: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			ingrain: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			petaldance: ["1L1"],
			poisonpowder: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strengthsap: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 26, gender: "M", nature: "Quirky", ivs: {hp: 23, atk: 24, def: 20, spa: 21, spd: 9, spe: 16}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 1, level: 12},
		],
	},
	gloom: {
		learnset: {
			absorb: ["1L1"],
			acid: ["1L1"],
			acidspray: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			leafstorm: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 2, level: 14},
			{generation: 4, level: 14},
			{generation: 6, level: 18, maxEggMoves: 1},
		],
	},
	vileplume: {
		learnset: {
			absorb: ["1L1"],
			acid: ["1L1"],
			acidspray: ["1L1"],
			afteryou: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			corrosivegas: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			leafstorm: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	bellossom: {
		learnset: {
			absorb: ["1L1"],
			acid: ["1L1"],
			acidspray: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			laserfocus: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			playrough: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			quiverdance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	paras: {
		learnset: {
			absorb: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			agility: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crosspoison: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fellstinger: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			megadrain: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poisonpowder: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			ragepowder: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spore: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			venoshock: ["1L1"],
			wideguard: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 28, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 8},
		],
	},
	parasect: {
		learnset: {
			absorb: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crosspoison: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poisonpowder: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			ragepowder: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spore: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			venoshock: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 13},
			{generation: 2, level: 5},
		],
	},
	venonat: {
		learnset: {
			acidspray: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			morningsun: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			poisonfang: ["1L1"],
			poisonpowder: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			ragepowder: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venoshock: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 13},
		],
	},
	venomoth: {
		learnset: {
			acidspray: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			poisonfang: ["1L1"],
			poisonpowder: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psywave: ["1L1"],
			quiverdance: ["1L1"],
			rage: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			whirlwind: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 32, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 30},
			{generation: 2, level: 10},
			{generation: 4, level: 8},
			{generation: 6, level: 30},
		],
	},
	diglett: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			finalgambit: ["1L1"],
			fissure: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			magnitude: ["1L1"],
			memento: ["1L1"],
			mimic: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 15},
			{generation: 2, level: 2},
		],
	},
	diglettalola: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			finalgambit: ["1L1"],
			fissure: ["1L1"],
			flashcannon: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			magnitude: ["1L1"],
			memento: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 10, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	dugtrio: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			magnitude: ["1L1"],
			mimic: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 40, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 15},
			{generation: 2, level: 5},
			{generation: 4, level: 19},
		],
	},
	dugtrioalola: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			flashcannon: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			magnitude: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nightslash: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
		},
	},
	meowth: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			amnesia: ["1L1"],
			assist: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			happyhour: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lastresort: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightslash: ["1L1"],
			odorsleuth: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			petaldance: ["1L1"],
			playrough: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sing: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 22, moves: ["1L1"]},
			{generation: 4, level: 21, gender: "F", nature: "Jolly", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 10, gender: "M", nature: "Jolly", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 15, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 20, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 10},
			{generation: 3, level: 3, gender: "M", nature: "Naive", ivs: {hp: 4, atk: 5, def: 4, spa: 5, spd: 4, spe: 4}, abilities: ["1L1"], pokeball: "pokeball"},
		],
	},
	meowthalola: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			amnesia: ["1L1"],
			assist: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			flail: ["1L1"],
			flatter: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lastresort: ["1L1"],
			metalclaw: ["1L1"],
			nastyplot: ["1L1"],
			nightslash: ["1L1"],
			partingshot: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
		},
	},
	meowthgalar: {
		learnset: {
			aerialace: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			charm: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			falseswipe: ["1L1"],
			flail: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			helpinghand: ["1L1"],
			honeclaws: ["1L1"],
			hypervoice: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			metronome: ["1L1"],
			nastyplot: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 15, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	persian: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lastresort: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightslash: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 18},
			{generation: 4, level: 19},
		],
	},
	persianalola: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lastresort: ["1L1"],
			metalclaw: ["1L1"],
			nastyplot: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
		},
	},
	perrserker: {
		learnset: {
			aerialace: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			falseswipe: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			metronome: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	psyduck: {
		learnset: {
			aerialace: ["1L1"],
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			crosschop: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			futuresight: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			payday: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			signalbeam: ["1L1"],
			simplebeam: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			vacuumwave: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			worryseed: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 27, gender: "M", nature: "Lax", ivs: {hp: 31, atk: 16, def: 12, spa: 29, spd: 31, spe: 14}, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
		],
		encounters: [
			{generation: 1, level: 15},
		],
	},
	golduck: {
		learnset: {
			aerialace: ["1L1"],
			amnesia: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			mefirst: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			payday: ["1L1"],
			powergem: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			vacuumwave: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			worryseed: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 33, moves: ["1L1"]},
			{generation: 7, level: 50, gender: "M", nature: "Timid", ivs: {hp: 31, atk: 30, def: 31, spa: 31, spd: 31, spe: 31}, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 15},
			{generation: 2, level: 10},
			{generation: 3, level: 25, pokeball: "safariball"},
			{generation: 4, level: 10},
		],
	},
	mankey: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crosschop: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			karatechop: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			meditate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			poisonjab: ["1L1"],
			powertrip: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smellingsalts: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 3},
			{generation: 3, level: 2},
		],
	},
	primeape: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crosschop: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			karatechop: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			ragefist: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 34, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 15},
			{generation: 4, level: 15},
		],
	},
	annihilape: {
		learnset: {
			acrobatics: ["1L1"],
			assurance: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			counter: ["1L1"],
			crosschop: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			drainpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metronome: ["1L1"],
			nightshade: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			phantomforce: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			ragefist: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowpunch: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
		},
	},
	growlithe: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			burnup: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonrage: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			morningsun: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rage: ["1L1"],
			ragingfury: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 32, gender: "F", nature: "Quiet", ivs: {hp: 11, atk: 24, def: 28, spa: 1, spd: 20, spe: 2}, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 28, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 15},
		],
	},
	growlithehisui: {
		learnset: {
			agility: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			closecombat: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			headsmash: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			howl: ["1L1"],
			leer: ["1L1"],
			morningsun: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 15, isHidden: true, nature: "Jolly", ivs: {hp: 31, atk: 31, def: 20, spa: 20, spd: 20, spe: 31}, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	arcanine: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			burnup: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rage: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			teleport: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 9, level: 50, shiny: true, gender: "F", nature: "Adamant", abilities: ["1L1"], ivs: {hp: 31, atk: 31, def: 31, spa: 8, spd: 31, spe: 31}, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	arcaninehisui: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			dragonpulse: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			gigaimpact: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			ragingfury: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snarl: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	poliwag: {
		learnset: {
			amnesia: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hypnosis: ["1L1"],
			iceball: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mist: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			wakeupslap: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 1, level: 5},
			{generation: 2, level: 3},
		],
	},
	poliwhirl: {
		learnset: {
			amnesia: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			wakeupslap: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 15},
			{generation: 2, level: 10},
			{generation: 3, level: 20},
			{generation: 4, level: 10},
			{generation: 7, level: 24},
			{generation: 7, level: 22, gender: "F", nature: "Naughty", abilities: ["1L1"], pokeball: "pokeball"},
		],
	},
	poliwrath: {
		learnset: {
			amnesia: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bellydrum: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			circlethrow: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			darkestlariat: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 42, moves: ["1L1"]},
		],
	},
	politoed: {
		learnset: {
			amnesia: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			perishsong: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, gender: "M", nature: "Calm", ivs: {hp: 31, atk: 13, def: 31, spa: 5, spd: 31, spe: 5}, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	abra: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			powerswap: ["1L1"],
			powertrick: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 6},
		],
	},
	kadabra: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			kinesis: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			miracleeye: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 15},
			{generation: 4, level: 15},
			{generation: 7, level: 11, pokeball: "pokeball"},
		],
	},
	alakazam: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			kinesis: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			miracleeye: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			storedpower: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	machop: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletpunch: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crosschop: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			incinerate: ["1L1"],
			karatechop: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			meditate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			powertrick: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickguard: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollingkick: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smellingsalts: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			vacuumwave: ["1L1"],
			vitalthrow: ["1L1"],
			wakeupslap: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 15},
		],
	},
	machoke: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crosschop: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			incinerate: ["1L1"],
			karatechop: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			vacuumwave: ["1L1"],
			vitalthrow: ["1L1"],
			wakeupslap: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 30, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 2, level: 14},
			{generation: 4, level: 14},
		],
	},
	machamp: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crosschop: ["1L1"],
			crosspoison: ["1L1"],
			curse: ["1L1"],
			darkestlariat: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			incinerate: ["1L1"],
			karatechop: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickguard: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			vacuumwave: ["1L1"],
			vitalthrow: ["1L1"],
			wakeupslap: ["1L1"],
			wideguard: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 38, gender: "M", nature: "Quiet", ivs: {hp: 9, atk: 23, def: 25, spa: 20, spd: 15, spe: 10}, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 50, shiny: true, gender: "M", nature: "Adamant", ivs: {hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31}, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 39, gender: "M", nature: "Hardy", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 34, gender: "F", nature: "Brave", ivs: {atk: 31}, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 16},
			{generation: 2, level: 5},
		],
	},
	bellsprout: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			ingrain: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poisonjab: ["1L1"],
			poisonpowder: ["1L1"],
			pounce: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strengthsap: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			vinewhip: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 1, level: 12},
			{generation: 2, level: 3},
		],
	},
	weepinbell: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			morningsun: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poisonjab: ["1L1"],
			poisonpowder: ["1L1"],
			pounce: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			vinewhip: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 32, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 12},
			{generation: 4, level: 10},
		],
	},
	victreebel: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leaftornado: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poisonjab: ["1L1"],
			poisonpowder: ["1L1"],
			pounce: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			vinewhip: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
			wrap: ["1L1"],
		},
	},
	tentacool: {
		learnset: {
			acid: ["1L1"],
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			acupressure: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			barrier: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			constrict: ["1L1"],
			crosspoison: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			magiccoat: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 5},
		],
	},
	tentacruel: {
		learnset: {
			acid: ["1L1"],
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			constrict: ["1L1"],
			corrosivegas: ["1L1"],
			crosspoison: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			magiccoat: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			reflecttype: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			skittersmack: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 20},
			{generation: 2, level: 20},
			{generation: 3, level: 20},
			{generation: 4, level: 15},
			{generation: 6, level: 21, maxEggMoves: 1},
		],
	},
	geodude: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			magnitude: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			wideguard: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 7},
			{generation: 2, level: 2},
		],
	},
	geodudealola: {
		learnset: {
			attract: ["1L1"],
			autotomize: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			irondefense: ["1L1"],
			magnetrise: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			wideguard: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	graveler: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			magnitude: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 23},
			{generation: 4, level: 16, pokeball: "safariball"},
			{generation: 6, level: 24},
		],
	},
	graveleralola: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			electricterrain: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gyroball: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			irondefense: ["1L1"],
			magnetrise: ["1L1"],
			metronome: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	golem: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			magnitude: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steamroller: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
		},
	},
	golemalola: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			electricterrain: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			magnetrise: ["1L1"],
			megapunch: ["1L1"],
			meteorbeam: ["1L1"],
			metronome: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			stealthrock: ["1L1"],
			steamroller: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	ponyta: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			horndrill: ["1L1"],
			hypnosis: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			irontail: ["1L1"],
			lowkick: ["1L1"],
			mimic: ["1L1"],
			morningsun: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stomp: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 28},
		],
	},
	ponytagalar: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			futuresight: ["1L1"],
			growl: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			highhorsepower: ["1L1"],
			horndrill: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			lowkick: ["1L1"],
			morningsun: ["1L1"],
			mysticalfire: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			thrash: ["1L1"],
			wildcharge: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 15, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	rapidash: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			horndrill: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			irontail: ["1L1"],
			lowkick: ["1L1"],
			megahorn: ["1L1"],
			mimic: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stomp: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 40, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 14, gender: "M"},
			{generation: 3, level: 37},
		],
	},
	rapidashgalar: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			drillrun: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			lowkick: ["1L1"],
			magicroom: ["1L1"],
			megahorn: ["1L1"],
			mistyterrain: ["1L1"],
			mysticalfire: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			throatchop: ["1L1"],
			trickroom: ["1L1"],
			wildcharge: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	slowpoke: {
		learnset: {
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			belch: ["1L1"],
			bellydrum: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			magiccoat: ["1L1"],
			mefirst: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stomp: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			yawn: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 31, gender: "F", nature: "Naive", ivs: {hp: 17, atk: 11, def: 19, spa: 20, spd: 5, spe: 10}, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 30, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 15},
		],
	},
	slowpokegalar: {
		learnset: {
			acid: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			belch: ["1L1"],
			bellydrum: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chillingwater: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			dive: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			foulplay: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			mudshot: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stomp: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	slowbro: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stomp: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			withdraw: ["1L1"],
			wonderroom: ["1L1"],
			yawn: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 100, nature: "Quiet", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 15},
			{generation: 1, level: 23},
			{generation: 2, level: 20},
			{generation: 3, level: 32},
			{generation: 4, level: 15},
			{generation: 5, level: 35},
			{generation: 7, level: 15},
		],
	},
	slowbrogalar: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chillingwater: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			drainpunch: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			nastyplot: ["1L1"],
			payday: ["1L1"],
			poisonjab: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			shellsidearm: ["1L1"],
			skillswap: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			withdraw: ["1L1"],
			wonderroom: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	slowking: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			chillyreception: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragontail: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			payday: ["1L1"],
			powergem: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			trumpcard: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			yawn: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	slowkinggalar: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chillingwater: ["1L1"],
			chillyreception: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			dive: ["1L1"],
			drainpunch: ["1L1"],
			earthquake: ["1L1"],
			eeriespell: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			nastyplot: ["1L1"],
			payday: ["1L1"],
			poisonjab: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	magnemite: {
		learnset: {
			bide: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magnetbomb: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			mimic: ["1L1"],
			mirrorshot: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			sonicboom: ["1L1"],
			spark: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 16},
		],
	},
	magneton: {
		learnset: {
			bide: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magnetbomb: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			mimic: ["1L1"],
			mirrorshot: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			sonicboom: ["1L1"],
			spark: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 30, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 5},
			{generation: 3, level: 26},
			{generation: 4, level: 17, pokeball: "safariball"},
		],
	},
	magnezone: {
		learnset: {
			allyswitch: ["1L1"],
			barrier: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			hardpress: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magnetbomb: ["1L1"],
			magneticflux: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			mirrorcoat: ["1L1"],
			mirrorshot: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			sonicboom: ["1L1"],
			spark: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	farfetchd: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			brutalswing: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			featherdance: ["1L1"],
			feint: ["1L1"],
			finalgambit: ["1L1"],
			firstimpression: ["1L1"],
			flail: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gust: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			leafblade: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			razorleaf: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			simplebeam: ["1L1"],
			skullbash: ["1L1"],
			skyattack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarblade: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			trumpcard: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 36, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 3},
			{generation: 3, level: 3, gender: "M", nature: "Adamant", ivs: {hp: 20, atk: 25, def: 21, spa: 24, spd: 15, spe: 20}, abilities: ["1L1"], pokeball: "pokeball"},
		],
	},
	farfetchdgalar: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			closecombat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			finalgambit: ["1L1"],
			flail: ["1L1"],
			focusenergy: ["1L1"],
			furycutter: ["1L1"],
			helpinghand: ["1L1"],
			knockoff: ["1L1"],
			leafblade: ["1L1"],
			leer: ["1L1"],
			nightslash: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			simplebeam: ["1L1"],
			skyattack: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarblade: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swordsdance: ["1L1"],
			throatchop: ["1L1"],
			workup: ["1L1"],
		},
	},
	sirfetchd: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			firstimpression: ["1L1"],
			focusenergy: ["1L1"],
			furycutter: ["1L1"],
			grassyglide: ["1L1"],
			helpinghand: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			leafblade: ["1L1"],
			leer: ["1L1"],
			meteorassault: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarblade: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swordsdance: ["1L1"],
			throatchop: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 80, gender: "M", nature: "Brave", abilities: ["1L1"], ivs: {hp: 30, atk: 31, def: 31, spa: 30, spd: 30, spe: 31}, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	doduo: {
		learnset: {
			acrobatics: ["1L1"],
			acupressure: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			feintattack: ["1L1"],
			flail: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			jumpkick: ["1L1"],
			knockoff: ["1L1"],
			lowkick: ["1L1"],
			lunge: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			uproar: ["1L1"],
			whirlwind: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 18},
			{generation: 2, level: 4},
		],
	},
	dodrio: {
		learnset: {
			acrobatics: ["1L1"],
			acupressure: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			drillrun: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			jumpkick: ["1L1"],
			knockoff: ["1L1"],
			lowkick: ["1L1"],
			lunge: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			triattack: ["1L1"],
			uproar: ["1L1"],
			whirlwind: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 34, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 29},
			{generation: 2, level: 10, gender: "F"},
			{generation: 2, level: 30},
			{generation: 3, level: 29, pokeball: "safariball"},
			{generation: 4, level: 15, gender: "F", nature: "Impish", ivs: {hp: 20, atk: 20, def: 20, spa: 15, spd: 15, spe: 15}, abilities: ["1L1"], pokeball: "pokeball"},
		],
	},
	seel: {
		learnset: {
			aquajet: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			avalanche: ["1L1"],
			belch: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			disable: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			horndrill: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lick: ["1L1"],
			megahorn: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			naturalgift: ["1L1"],
			payday: ["1L1"],
			peck: ["1L1"],
			perishsong: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 23, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 22},
		],
	},
	dewgong: {
		learnset: {
			alluringvoice: ["1L1"],
			aquajet: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			horndrill: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			megahorn: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			naturalgift: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 15},
			{generation: 2, level: 5},
			{generation: 3, level: 32},
			{generation: 5, level: 30},
			{generation: 6, level: 30, maxEggMoves: 1},
		],
	},
	grimer: {
		learnset: {
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gunkshot: ["1L1"],
			harden: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			infestation: ["1L1"],
			lick: ["1L1"],
			meanlook: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			minimize: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shadowpunch: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			venoshock: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 23, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 23},
		],
	},
	grimeralola: {
		learnset: {
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			meanlook: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			metronome: ["1L1"],
			minimize: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisonfang: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			venoshock: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 10, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	muk: {
		learnset: {
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			harden: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lunge: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			minimize: ["1L1"],
			moonblast: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 25},
			{generation: 2, level: 5},
			{generation: 3, level: 32},
			{generation: 4, level: 15},
			{generation: 5, level: 5},
			{generation: 5, level: 35, isHidden: true},
			{generation: 6, level: 30},
		],
	},
	mukalola: {
		learnset: {
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bite: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			harden: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			metronome: ["1L1"],
			minimize: ["1L1"],
			moonblast: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisonfang: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	shellder: {
		learnset: {
			aquaring: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			avalanche: ["1L1"],
			barrier: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			clamp: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			leer: ["1L1"],
			lifedew: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			razorshell: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shellsmash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			triattack: ["1L1"],
			twineedle: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			withdraw: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 24, gender: "F", nature: "Brave", ivs: {hp: 5, atk: 19, def: 18, spa: 5, spd: 11, spe: 13}, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 29, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 10},
		],
	},
	cloyster: {
		learnset: {
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			avalanche: ["1L1"],
			barrier: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			clamp: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shellsmash: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikecannon: ["1L1"],
			spikes: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			triattack: ["1L1"],
			twineedle: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			withdraw: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 30, gender: "M", nature: "Naughty", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	gastly: {
		learnset: {
			acidspray: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			corrosivegas: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grudge: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			lick: ["1L1"],
			meanlook: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			perishsong: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflecttype: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 18},
		],
	},
	haunter: {
		learnset: {
			acidspray: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			corrosivegas: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			destinybond: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			lick: ["1L1"],
			meanlook: ["1L1"],
			megadrain: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowpunch: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 30, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 20},
			{generation: 2, level: 15},
			{generation: 3, level: 20},
			{generation: 4, level: 16},
		],
	},
	gengar: {
		learnset: {
			acidspray: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			corrosivegas: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lick: ["1L1"],
			meanlook: ["1L1"],
			megadrain: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			perishsong: ["1L1"],
			phantomforce: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			poltergeist: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflecttype: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowpunch: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 23, gender: "F", nature: "Hardy", ivs: {hp: 19, atk: 14, def: 0, spa: 14, spd: 17, spe: 27}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 25, nature: "Timid", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 25, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 25, shiny: true, moves: ["1L1"], pokeball: "duskball"},
			{generation: 6, level: 50, shiny: true, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 80, gender: "M", nature: "Naughty", abilities: ["1L1"], ivs: {hp: 30, atk: 30, def: 30, spa: 31, spd: 31, spe: 31}, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	onix: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			skullbash: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			wideguard: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 13},
		],
	},
	steelix: {
		learnset: {
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			bind: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			magnetrise: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			psychup: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
		},
	},
	drowzee: {
		learnset: {
			allyswitch: ["1L1"],
			assist: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			bellydrum: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			guardswap: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meditate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			poisongas: ["1L1"],
			pound: ["1L1"],
			powersplit: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wakeupslap: ["1L1"],
			wish: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 1, level: 9},
		],
	},
	hypno: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meditate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			poisongas: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			synchronoise: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wakeupslap: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 34, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 16},
			{generation: 4, level: 16},
		],
	},
	krabby: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			crabhammer: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			guillotine: ["1L1"],
			hail: ["1L1"],
			hammerarm: ["1L1"],
			harden: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			slam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			visegrip: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 10},
		],
	},
	kingler: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crabhammer: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			guillotine: ["1L1"],
			hail: ["1L1"],
			hammerarm: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			visegrip: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wideguard: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 15},
			{generation: 3, level: 25},
			{generation: 4, level: 22},
		],
	},
	voltorb: {
		learnset: {
			agility: ["1L1"],
			bide: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			sonicboom: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 19, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 14},
			{generation: 1, level: 40},
		],
	},
	voltorbhisui: {
		learnset: {
			agility: ["1L1"],
			bulletseed: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			foulplay: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			gyroball: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			rollout: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	electrode: {
		learnset: {
			agility: ["1L1"],
			bide: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magneticflux: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			sonicboom: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			supercellslam: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 3},
			{generation: 2, level: 23},
			{generation: 3, level: 3, nature: "Hasty", ivs: {hp: 19, atk: 16, def: 18, spa: 25, spd: 25, spe: 19}, abilities: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 23},
		],
	},
	electrodehisui: {
		learnset: {
			agility: ["1L1"],
			bulletseed: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			chloroblast: ["1L1"],
			curse: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			foulplay: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			gyroball: ["1L1"],
			hyperbeam: ["1L1"],
			leafstorm: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			rollout: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			supercellslam: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	exeggcute: {
		learnset: {
			absorb: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			barrage: ["1L1"],
			bestow: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			eggbomb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			ingrain: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			moonlight: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			nightmare: ["1L1"],
			poisonpowder: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			skillswap: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wish: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 1, level: 20},
		],
	},
	exeggutor: {
		learnset: {
			absorb: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			barrage: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonhammer: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dreameater: ["1L1"],
			earthquake: ["1L1"],
			eggbomb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			explosion: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			nightmare: ["1L1"],
			outrage: ["1L1"],
			powerswap: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			woodhammer: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 46, moves: ["1L1"]},
		],
	},
	exeggutoralola: {
		learnset: {
			absorb: ["1L1"],
			attract: ["1L1"],
			barrage: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			celebrate: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonhammer: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dreameater: ["1L1"],
			earthquake: ["1L1"],
			eggbomb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			flamethrower: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			powerswap: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			woodhammer: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, gender: "M", nature: "Modest", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	cubone: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			boneclub: ["1L1"],
			bonemerang: ["1L1"],
			bonerush: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			perishsong: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 16},
		],
	},
	marowak: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			boneclub: ["1L1"],
			bonemerang: ["1L1"],
			bonerush: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			sing: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 44, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 24},
			{generation: 2, level: 12},
			{generation: 4, level: 14},
		],
	},
	marowakalola: {
		learnset: {
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			boneclub: ["1L1"],
			bonemerang: ["1L1"],
			bonerush: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			confide: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudslap: ["1L1"],
			outrage: ["1L1"],
			painsplit: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowbone: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwhip: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	marowakalolatotem: {
		learnset: {
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			boneclub: ["1L1"],
			bonemerang: ["1L1"],
			bonerush: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			outrage: ["1L1"],
			painsplit: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			shadowball: ["1L1"],
			shadowbone: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tailwhip: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 25, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	tyrogue: {
		learnset: {
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletpunch: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			feint: ["1L1"],
			focusenergy: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			laserfocus: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			machpunch: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			workup: ["1L1"],
		},
	},
	hitmonlee: {
		learnset: {
			attract: ["1L1"],
			aurasphere: ["1L1"],
			axekick: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			blazekick: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			feint: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			jumpkick: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			lunge: ["1L1"],
			meditate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollingkick: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			wideguard: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 38, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 30},
		],
	},
	hitmonchan: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletpunch: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			cometpunch: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			dizzypunch: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			feint: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			machpunch: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickguard: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			skullbash: ["1L1"],
			skyuppercut: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 38, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 30},
		],
	},
	hitmontop: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			feint: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icespinner: ["1L1"],
			laserfocus: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			rollingkick: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			triplekick: ["1L1"],
			twister: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			wideguard: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 55, gender: "M", nature: "Adamant", abilities: ["1L1"], moves: ["1L1"]},
		],
	},
	lickitung: {
		learnset: {
			acid: ["1L1"],
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bellydrum: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragontail: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lick: ["1L1"],
			magnitude: ["1L1"],
			mefirst: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			poweruppunch: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smellingsalts: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelroller: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terrainpulse: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 38, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 15},
		],
	},
	lickilicky: {
		learnset: {
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dragontail: ["1L1"],
			dreameater: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lick: ["1L1"],
			mefirst: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelroller: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			terrainpulse: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	koffing: {
		learnset: {
			acidspray: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			corrosivegas: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			grudge: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			incinerate: ["1L1"],
			infestation: ["1L1"],
			memento: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisongas: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uproar: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			willowisp: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 30},
		],
	},
	weezing: {
		learnset: {
			acidspray: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			corrosivegas: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			infestation: ["1L1"],
			memento: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisongas: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uproar: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			willowisp: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 16},
			{generation: 3, level: 32},
			{generation: 4, level: 15, pokeball: "safariball"},
		],
	},
	weezinggalar: {
		learnset: {
			acidspray: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			clearsmog: ["1L1"],
			corrosivegas: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			destinybond: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			haze: ["1L1"],
			heatwave: ["1L1"],
			hyperbeam: ["1L1"],
			memento: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			poisongas: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strangesteam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uproar: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	rhyhorn: {
		learnset: {
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			guardsplit: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hornattack: ["1L1"],
			horndrill: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			magnitude: ["1L1"],
			megahorn: ["1L1"],
			metalburst: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 20},
		],
	},
	rhydon: {
		learnset: {
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drillrun: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hornattack: ["1L1"],
			horndrill: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			megahorn: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			whirlpool: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 46, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 15},
			{generation: 2, level: 10},
			{generation: 4, level: 41},
			{generation: 6, level: 30},
		],
	},
	rhyperior: {
		learnset: {
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hornattack: ["1L1"],
			horndrill: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			megahorn: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			meteorbeam: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rockwrecker: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	happiny: {
		learnset: {
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			defensecurl: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			metronome: ["1L1"],
			minimize: ["1L1"],
			mudbomb: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			pound: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	chansey: {
		learnset: {
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bestow: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			eggbomb: ["1L1"],
			electricterrain: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			minimize: ["1L1"],
			mudbomb: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sing: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			softboiled: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			triattack: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 39, moves: ["1L1"]},
			{generation: 8, level: 7, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 7},
		],
	},
	blissey: {
		learnset: {
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bestow: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			eggbomb: ["1L1"],
			electricterrain: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			minimize: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sing: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			softboiled: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, isHidden: true, moves: ["1L1"]},
		],
	},
	tangela: {
		learnset: {
			absorb: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			constrict: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			ingrain: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			morningsun: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			painsplit: ["1L1"],
			poisonpowder: ["1L1"],
			powerswap: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rage: ["1L1"],
			ragepowder: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			slam: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			vinewhip: ["1L1"],
			wakeupslap: ["1L1"],
			worryseed: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 30, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 13},
		],
	},
	tangrowth: {
		learnset: {
			absorb: ["1L1"],
			aerialace: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			ingrain: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			megadrain: ["1L1"],
			morningsun: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poisonpowder: ["1L1"],
			powerswap: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shockwave: ["1L1"],
			slam: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			vinewhip: ["1L1"],
			worryseed: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, gender: "M", nature: "Brave", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	kangaskhan: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			circlethrow: ["1L1"],
			cometpunch: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			dizzypunch: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sing: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stomp: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terrainpulse: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trumpcard: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 35, abilities: ["1L1"], moves: ["1L1"]},
			{generation: 6, level: 50, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 25},
		],
	},
	horsea: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			disable: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flashcannon: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			naturalgift: ["1L1"],
			octazooka: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 1, shiny: true, moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 1, level: 5},
		],
	},
	seadra: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			disable: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 45, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 1, level: 20},
			{generation: 2, level: 20},
			{generation: 3, level: 25},
			{generation: 4, level: 15},
		],
	},
	kingdra: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			breakingswipe: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 50, gender: "M", nature: "Timid", ivs: {hp: 31, atk: 17, def: 8, spa: 31, spd: 11, spe: 31}, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	goldeen: {
		learnset: {
			acupressure: ["1L1"],
			agility: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hornattack: ["1L1"],
			horndrill: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			megahorn: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 5},
		],
	},
	seaking: {
		learnset: {
			agility: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hornattack: ["1L1"],
			horndrill: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			megahorn: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 23},
			{generation: 2, level: 10},
			{generation: 3, level: 20},
			{generation: 4, level: 10},
			{generation: 6, level: 26, maxEggMoves: 1},
			{generation: 7, level: 10},
		],
	},
	staryu: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			camouflage: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			cosmicpower: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			mimic: ["1L1"],
			minimize: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			reflecttype: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			teleport: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 18, nature: "Timid", ivs: {hp: 10, atk: 3, def: 22, spa: 24, spd: 3, spe: 18}, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 1, level: 5},
		],
	},
	starmie: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			cosmicpower: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			minimize: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spotlight: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 41, moves: ["1L1"]},
		],
	},
	mimejr: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			batonpass: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			healingwish: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meditate: ["1L1"],
			mimic: ["1L1"],
			mistyterrain: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			pound: ["1L1"],
			powersplit: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			teeterdance: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wakeupslap: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	mrmime: {
		learnset: {
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meditate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mistyterrain: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			payback: ["1L1"],
			pound: ["1L1"],
			powersplit: ["1L1"],
			powerswap: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			quickguard: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			teeterdance: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wakeupslap: ["1L1"],
			wideguard: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 42, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 6},
		],
	},
	mrmimegalar: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			copycat: ["1L1"],
			dazzlinggleam: ["1L1"],
			doublekick: ["1L1"],
			drainpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			freezedry: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			guardswap: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			magicroom: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			mistyterrain: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			pound: ["1L1"],
			powersplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			taunt: ["1L1"],
			teeterdance: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 15, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	mrrime: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confusion: ["1L1"],
			copycat: ["1L1"],
			dazzlinggleam: ["1L1"],
			doublekick: ["1L1"],
			drainpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			freezedry: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			guardswap: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			magicroom: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			mistyterrain: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			pound: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			taunt: ["1L1"],
			teeterdance: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	scyther: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crosspoison: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			mimic: ["1L1"],
			morningsun: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			ominouswind: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			wingattack: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 40, abilities: ["1L1"], moves: ["1L1"]},
			{generation: 5, level: 30, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 15},
			{generation: 1, level: 25},
		],
	},
	scizor: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulletpunch: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crosspoison: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			ominouswind: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			steelwing: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			venoshock: ["1L1"],
			wingattack: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, gender: "M", nature: "Adamant", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 100, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 50, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 25, nature: "Adamant", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 25, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	kleavor: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			batonpass: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			closecombat: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			focusenergy: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			stealthrock: ["1L1"],
			stoneaxe: ["1L1"],
			stoneedge: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	smoochum: {
		learnset: {
			attract: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			hail: ["1L1"],
			healbell: ["1L1"],
			heartstamp: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			lick: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meanlook: ["1L1"],
			meditate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			miracleeye: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			payback: ["1L1"],
			perishsong: ["1L1"],
			pound: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			sing: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			sweetscent: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wakeupslap: ["1L1"],
			waterpulse: ["1L1"],
			wish: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	jynx: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			heartstamp: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			lick: ["1L1"],
			lightscreen: ["1L1"],
			lovelykiss: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meanlook: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			payback: ["1L1"],
			perishsong: ["1L1"],
			pound: ["1L1"],
			powdersnow: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			sing: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			sweetscent: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			wakeupslap: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wonderroom: ["1L1"],
			wringout: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 15},
			{generation: 2, level: 10},
			{generation: 3, level: 20, nature: "Mild", ivs: {hp: 18, atk: 17, def: 18, spa: 22, spd: 25, spe: 21}, abilities: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 22},
			{generation: 7, level: 9},
		],
	},
	elekid: {
		learnset: {
			attract: ["1L1"],
			barrier: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crosschop: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			karatechop: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			magnetrise: ["1L1"],
			meditate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalsound: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rollingkick: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			supercellslam: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 20, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	electabuzz: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crosschop: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalsound: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psywave: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			supercellslam: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 43, moves: ["1L1"]},
			{generation: 4, level: 30, gender: "M", nature: "Naughty", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 30, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 30, gender: "M", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 33},
			{generation: 2, level: 15},
			{generation: 4, level: 15},
			{generation: 7, level: 25},
		],
	},
	electivire: {
		learnset: {
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crosschop: ["1L1"],
			darkestlariat: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			iondeluge: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalsound: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			supercellslam: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, gender: "M", nature: "Adamant", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, gender: "M", nature: "Serious", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	magby: {
		learnset: {
			acidspray: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			belch: ["1L1"],
			bellydrum: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crosschop: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			karatechop: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			machpunch: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			poisonjab: ["1L1"],
			powerswap: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			sleeptalk: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	magmar: {
		learnset: {
			acidspray: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crosschop: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			poisonjab: ["1L1"],
			powerswap: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			teleport: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 36, moves: ["1L1"]},
			{generation: 4, level: 30, gender: "M", nature: "Quiet", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 30, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 30, gender: "M", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 34},
			{generation: 2, level: 14},
			{generation: 4, level: 14},
			{generation: 7, level: 16},
		],
	},
	magmortar: {
		learnset: {
			acidspray: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			poisonjab: ["1L1"],
			powerswap: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, gender: "F", nature: "Modest", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, gender: "M", nature: "Hardy", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	pinsir: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			guillotine: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			mefirst: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			stormthrow: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			visegrip: ["1L1"],
			vitalthrow: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 35, abilities: ["1L1"], moves: ["1L1"]},
			{generation: 6, level: 50, gender: "F", nature: "Adamant", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, nature: "Jolly", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 15},
			{generation: 1, level: 20},
		],
	},
	tauros: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hornattack: ["1L1"],
			horndrill: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			megahorn: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			ragingbull: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 25, nature: "Docile", ivs: {hp: 14, atk: 19, def: 12, spa: 17, spd: 5, spe: 26}, abilities: ["1L1"], moves: ["1L1"], pokeball: "safariball"},
			{generation: 3, level: 10, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 46, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 21},
		],
	},
	taurospaldeacombat: {
		learnset: {
			assurance: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			drillrun: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			lashout: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			ragingbull: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	taurospaldeablaze: {
		learnset: {
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			drillrun: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			lashout: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			ragingbull: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	taurospaldeaaqua: {
		learnset: {
			aquajet: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			drillrun: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			highhorsepower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			lashout: ["1L1"],
			liquidation: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			ragingbull: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			trailblaze: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			whirlpool: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	magikarp: {
		learnset: {
			bounce: ["1L1"],
			celebrate: ["1L1"],
			flail: ["1L1"],
			happyhour: ["1L1"],
			hydropump: ["1L1"],
			splash: ["1L1"],
			tackle: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 5, gender: "M", nature: "Relaxed", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 6, gender: "F", nature: "Rash", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 7, gender: "F", nature: "Hardy", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 5, gender: "F", nature: "Lonely", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 4, gender: "M", nature: "Modest", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 99, shiny: true, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 1, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 19, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 5},
		],
	},
	gyarados: {
		learnset: {
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			splash: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 20, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 15},
			{generation: 2, level: 15},
			{generation: 3, level: 5},
			{generation: 4, level: 10},
			{generation: 5, level: 1},
			{generation: 7, level: 10},
		],
	},
	lapras: {
		learnset: {
			alluringvoice: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dreameater: ["1L1"],
			drillrun: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			foresight: ["1L1"],
			freezedry: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			horndrill: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			iceshard: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lifedew: ["1L1"],
			liquidation: ["1L1"],
			megahorn: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			outrage: ["1L1"],
			perishsong: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			sheercold: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sing: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			solarbeam: ["1L1"],
			sparklingaria: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 44, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 15},
		],
	},
	ditto: {
		learnset: {
			transform: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 10, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 12},
			{generation: 2, level: 10},
			{generation: 3, level: 23},
			{generation: 4, level: 10},
			{generation: 5, level: 45},
			{generation: 6, level: 30},
			{generation: 7, level: 25},
		],
	},
	eevee: {
		learnset: {
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flail: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sing: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trumpcard: ["1L1"],
			weatherball: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 10, gender: "F", nature: "Lonely", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, shiny: true, gender: "M", nature: "Hardy", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, gender: "F", nature: "Hardy", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 15, shiny: true, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 10, nature: "Jolly", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 5, gender: "M", nature: "Docile", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 25},
		],
	},
	eeveestarter: {
		learnset: {
			baddybad: ["1L1"],
			bite: ["1L1"],
			bouncybubble: ["1L1"],
			buzzybuzz: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			facade: ["1L1"],
			freezyfrost: ["1L1"],
			glitzyglow: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			irontail: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			sandattack: ["1L1"],
			sappyseed: ["1L1"],
			shadowball: ["1L1"],
			sizzlyslide: ["1L1"],
			sparklyswirl: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			toxic: ["1L1"],
			veeveevolley: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 5, perfectIVs: 6, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	vaporeon: {
		learnset: {
			acidarmor: ["1L1"],
			alluringvoice: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, gender: "F", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	jolteon: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payday: ["1L1"],
			pinmissile: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			voltswitch: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, gender: "F", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	flareon: {
		learnset: {
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smog: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, gender: "F", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	espeon: {
		learnset: {
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mimic: ["1L1"],
			morningsun: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			payday: ["1L1"],
			powergem: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicfangs: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			weatherball: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, gender: "F", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	umbreon: {
		learnset: {
			alluringvoice: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			focusenergy: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			meanlook: ["1L1"],
			mimic: ["1L1"],
			moonlight: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			weatherball: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, gender: "F", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	leafeon: {
		learnset: {
			aerialace: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			weatherball: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, gender: "F", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	glaceon: {
		learnset: {
			alluringvoice: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			babydolleyes: ["1L1"],
			barrier: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			focusenergy: ["1L1"],
			freezedry: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iceshard: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			mirrorcoat: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, gender: "F", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	porygon: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			barrier: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			conversion: ["1L1"],
			conversion2: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			eerieimpulse: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sharpen: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			speedswap: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, isHidden: true, moves: ["1L1"]},
			{generation: 8, level: 25, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 1, level: 18},
		],
	},
	porygon2: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			blizzard: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			conversion: ["1L1"],
			conversion2: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			eerieimpulse: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			speedswap: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 50, nature: "Sassy", abilities: ["1L1"], ivs: {hp: 31, atk: 0, spe: 0}, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	porygonz: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			blizzard: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			conversion: ["1L1"],
			conversion2: ["1L1"],
			darkpulse: ["1L1"],
			defensecurl: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			eerieimpulse: ["1L1"],
			electroweb: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			speedswap: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	omanyte: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hornattack: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			reflecttype: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shellsmash: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spikecannon: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			withdraw: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 30},
		],
	},
	omastar: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hornattack: ["1L1"],
			horndrill: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			naturalgift: ["1L1"],
			pinmissile: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shellsmash: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spikecannon: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			withdraw: ["1L1"],
		},
	},
	kabuto: {
		learnset: {
			absorb: ["1L1"],
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			aquajet: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			megadrain: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 30},
		],
	},
	kabutops: {
		learnset: {
			absorb: ["1L1"],
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crosspoison: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			megadrain: ["1L1"],
			megakick: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wringout: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	aerodactyl: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			flamethrower: ["1L1"],
			fly: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			whirlwind: ["1L1"],
			wideguard: ["1L1"],
			wingattack: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 30},
		],
	},
	munchlax: {
		learnset: {
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bellydrum: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			happyhour: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			holdback: ["1L1"],
			hydropump: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			lastresort: ["1L1"],
			lick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			payday: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stockpile: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			whirlwind: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 5, moves: ["1L1"]},
			{generation: 4, level: 5, gender: "F", nature: "Relaxed", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 5, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 9, level: 1, shiny: true, gender: "M", isHidden: true, nature: "Impish", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	snorlax: {
		learnset: {
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bellydrum: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkestlariat: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hammerarm: ["1L1"],
			harden: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			lastresort: ["1L1"],
			lick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			payday: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psywave: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelroller: ["1L1"],
			stockpile: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			whirlwind: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 43, moves: ["1L1"]},
			{generation: 7, level: 30, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 1, level: 30},
		],
	},
	articuno: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			ancientpower: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bravebird: ["1L1"],
			bubblebeam: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			freezedry: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mirrorcoat: ["1L1"],
			mist: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlwind: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 50, moves: ["1L1"]},
			{generation: 4, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 70, moves: ["1L1"]},
			{generation: 6, level: 70, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 50},
		],
		eventOnly: false,
	},
	articunogalar: {
		learnset: {
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			bravebird: ["1L1"],
			calmmind: ["1L1"],
			confusion: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fly: ["1L1"],
			freezingglare: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			guardswap: ["1L1"],
			gust: ["1L1"],
			helpinghand: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			mindreader: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychocut: ["1L1"],
			psychoshift: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uturn: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 70, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	zapdos: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			ancientpower: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bravebird: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magneticflux: ["1L1"],
			metalsound: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			weatherball: ["1L1"],
			whirlwind: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 50, moves: ["1L1"]},
			{generation: 4, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 70, moves: ["1L1"]},
			{generation: 6, level: 70, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 50},
		],
		eventOnly: false,
	},
	zapdosgalar: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			blazekick: ["1L1"],
			bounce: ["1L1"],
			bravebird: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			counter: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunderouskick: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 70, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	moltres: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			ancientpower: ["1L1"],
			bide: ["1L1"],
			bravebird: ["1L1"],
			burningjealousy: ["1L1"],
			burnup: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			morningsun: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			overheat: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			weatherball: ["1L1"],
			whirlwind: ["1L1"],
			willowisp: ["1L1"],
			wingattack: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 50, moves: ["1L1"]},
			{generation: 4, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 70, moves: ["1L1"]},
			{generation: 6, level: 70, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 50},
		],
		eventOnly: false,
	},
	moltresgalar: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			agility: ["1L1"],
			airslash: ["1L1"],
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			bravebird: ["1L1"],
			darkpulse: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fierywrath: ["1L1"],
			fly: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			uturn: ["1L1"],
			wingattack: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 70, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	dratini: {
		learnset: {
			agility: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wrap: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 10},
		],
	},
	dragonair: {
		learnset: {
			agility: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			horndrill: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wrap: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 1, level: 15},
			{generation: 2, level: 10},
			{generation: 3, level: 25, pokeball: "safariball"},
			{generation: 4, level: 15},
			{generation: 7, level: 10},
		],
	},
	dragonite: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			horndrill: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			outrage: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			skydrop: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			steelwing: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wingattack: ["1L1"],
			wrap: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 55, moves: ["1L1"]},
			{generation: 4, level: 50, gender: "M", nature: "Mild", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 100, gender: "M", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 55, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 55, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 50, gender: "M", nature: "Brave", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 55, gender: "M", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 62, gender: "M", ivs: {hp: 31, def: 31, spa: 31, spd: 31}, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 80, gender: "F", nature: "Jolly", abilities: ["1L1"], ivs: {hp: 30, atk: 31, def: 30, spa: 30, spd: 31, spe: 31}, moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 5, level: 50},
			{generation: 7, level: 10},
		],
	},
	mewtwo: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			aurasphere: ["1L1"],
			avalanche: ["1L1"],
			barrier: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			disable: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			electroball: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mefirst: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			miracleeye: ["1L1"],
			mist: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			payday: ["1L1"],
			poisonjab: ["1L1"],
			powergem: ["1L1"],
			powerswap: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psystrike: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			speedswap: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 70, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 100, nature: "Timid", ivs: {spa: 31, spe: 31}, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 70, moves: ["1L1"]},
			{generation: 6, level: 100, shiny: true, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 9, level: 100, nature: "Modest", perfectIVs: 6, isHidden: true, moves: ["1L1"]},
		],
		encounters: [
			{generation: 1, level: 70},
		],
		eventOnly: false,
	},
	mew: {
		learnset: {
			acidspray: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			barrier: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			blastburn: ["1L1"],
			blazekick: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bravebird: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			corrosivegas: ["1L1"],
			cosmicpower: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crosspoison: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkestlariat: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			drillrun: ["1L1"],
			dualchop: ["1L1"],
			dualwingbeat: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			eggbomb: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			falseswipe: ["1L1"],
			featherdance: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			fissure: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frenzyplant: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			futuresight: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			hardpress: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			horndrill: ["1L1"],
			hurricane: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			lastresort: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leechlife: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			magnetrise: ["1L1"],
			mefirst: ["1L1"],
			megadrain: ["1L1"],
			megahorn: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			petalblizzard: ["1L1"],
			phantomforce: ["1L1"],
			pinmissile: ["1L1"],
			playrough: ["1L1"],
			pluck: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			pollenpuff: ["1L1"],
			poltergeist: ["1L1"],
			pounce: ["1L1"],
			pound: ["1L1"],
			powergem: ["1L1"],
			powerswap: ["1L1"],
			poweruppunch: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicfangs: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			quash: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			razorwind: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			reflecttype: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			skullbash: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			softboiled: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			speedswap: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			steelwing: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tailslap: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			transform: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			tripleaxel: ["1L1"],
			twister: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			voltswitch: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			whirlwind: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 5, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 5, perfectIVs: 5, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 9, level: 5, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	chikorita: {
		learnset: {
			ancientpower: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			frenzyplant: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			ingrain: ["1L1"],
			irontail: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poisonpowder: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			vinewhip: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 5, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	bayleef: {
		learnset: {
			ancientpower: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poisonpowder: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	meganium: {
		learnset: {
			ancientpower: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			frenzyplant: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			poisonpowder: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			weatherball: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	cyndaquil: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			blastburn: ["1L1"],
			bodyslam: ["1L1"],
			burningjealousy: ["1L1"],
			burnup: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			eruption: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			overheat: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 5, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	quilava: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			burningjealousy: ["1L1"],
			burnup: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			eruption: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			overheat: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	typhlosion: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			blastburn: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			burnup: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			eruption: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			overheat: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 50, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	typhlosionhisui: {
		learnset: {
			aerialace: ["1L1"],
			blastburn: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			eruption: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			heatwave: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			infernalparade: ["1L1"],
			inferno: ["1L1"],
			ironhead: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			nightshade: ["1L1"],
			overheat: ["1L1"],
			playrough: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rollout: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	totodile: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dynamicpunch: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flail: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 5, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	croconaw: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dynamicpunch: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
	},
	feraligatr: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	sentret: {
		learnset: {
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			assist: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			mefirst: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			tidyup: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 2},
		],
	},
	furret: {
		learnset: {
			agility: ["1L1"],
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			mefirst: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 6},
			{generation: 4, level: 6},
		],
	},
	hoothoot: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			fly: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			magiccoat: ["1L1"],
			meanlook: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			moonblast: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 2, level: 2},
		],
	},
	noctowl: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			flash: ["1L1"],
			fly: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			laserfocus: ["1L1"],
			magiccoat: ["1L1"],
			mimic: ["1L1"],
			moonblast: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 7},
			{generation: 4, level: 5},
			{generation: 7, level: 19},
		],
	},
	ledyba: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			cometpunch: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			dizzypunch: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			machpunch: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			silverwind: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 3},
		],
	},
	ledian: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			cometpunch: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			machpunch: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			silverwind: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 7},
			{generation: 4, level: 5},
		],
	},
	spinarak: {
		learnset: {
			absorb: ["1L1"],
			acidspray: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			crosspoison: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			megahorn: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			nightslash: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			pursuit: ["1L1"],
			ragepowder: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowsneak: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			sonicboom: ["1L1"],
			spiderweb: ["1L1"],
			spite: ["1L1"],
			stickyweb: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			toxicthread: ["1L1"],
			trailblaze: ["1L1"],
			twineedle: ["1L1"],
			venoshock: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 14, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 3},
		],
	},
	ariados: {
		learnset: {
			absorb: ["1L1"],
			acidspray: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			crosspoison: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fellstinger: ["1L1"],
			flash: ["1L1"],
			focusenergy: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowsneak: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spiderweb: ["1L1"],
			spite: ["1L1"],
			stickyweb: ["1L1"],
			stompingtantrum: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			toxicthread: ["1L1"],
			trailblaze: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 65, gender: "M", nature: "Hardy", abilities: ["1L1"], ivs: {hp: 20, atk: 20, def: 20, spa: 20, spd: 20, spe: 20}, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 7},
			{generation: 4, level: 5},
			{generation: 6, level: 19, maxEggMoves: 1},
		],
	},
	chinchou: {
		learnset: {
			agility: ["1L1"],
			amnesia: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			discharge: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			healbell: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			iondeluge: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	lanturn: {
		learnset: {
			agility: ["1L1"],
			amnesia: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			discharge: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			healbell: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			iondeluge: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			spitup: ["1L1"],
			spotlight: ["1L1"],
			stockpile: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 20},
			{generation: 6, level: 26, maxEggMoves: 1},
			{generation: 7, level: 10},
		],
	},
	togepi: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bestow: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			followme: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			lastresort: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			morningsun: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			peck: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			softboiled: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			telekinesis: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 20, gender: "F", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 25, moves: ["1L1"]},
		],
	},
	togetic: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			aircutter: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bestow: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			lastresort: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			softboiled: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			telekinesis: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	togekiss: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			playrough: ["1L1"],
			pluck: ["1L1"],
			pound: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			telekinesis: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
		],
	},
	natu: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			cosmicpower: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			guardswap: ["1L1"],
			haze: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			imprison: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mefirst: ["1L1"],
			mimic: ["1L1"],
			miracleeye: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			simplebeam: ["1L1"],
			skillswap: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			tailwind: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			wish: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 22, moves: ["1L1"]},
		],
	},
	xatu: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			cosmicpower: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fly: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			guardswap: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mefirst: ["1L1"],
			mimic: ["1L1"],
			miracleeye: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			wish: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 15},
			{generation: 4, level: 16, gender: "M", nature: "Modest", ivs: {hp: 15, atk: 20, def: 15, spa: 20, spd: 20, spe: 20}, abilities: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 24, maxEggMoves: 1},
			{generation: 7, level: 21},
		],
	},
	mareep: {
		learnset: {
			afteryou: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			cottonguard: ["1L1"],
			cottonspore: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flatter: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			holdback: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandattack: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 37, gender: "F", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 17, moves: ["1L1"]},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	flaaffy: {
		learnset: {
			afteryou: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			cottonguard: ["1L1"],
			cottonspore: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			powergem: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 7, level: 11, pokeball: "pokeball"},
		],
	},
	ampharos: {
		learnset: {
			afteryou: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			cottonguard: ["1L1"],
			cottonspore: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragoncheer: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			iondeluge: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			magneticflux: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			powergem: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	azurill: {
		learnset: {
			alluringvoice: ["1L1"],
			aquajet: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brutalswing: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			camouflage: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			perishsong: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			sing: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
	},
	marill: {
		learnset: {
			alluringvoice: ["1L1"],
			amnesia: ["1L1"],
			aquajet: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			camouflage: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			perishsong: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			sing: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			steelroller: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
	},
	azumarill: {
		learnset: {
			alluringvoice: ["1L1"],
			amnesia: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			steelroller: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 5},
			{generation: 6, level: 16, maxEggMoves: 1},
		],
	},
	bonsly: {
		learnset: {
			afteryou: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			flail: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			lowkick: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
		},
	},
	sudowoodo: {
		learnset: {
			afteryou: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hammerarm: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			powergem: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			woodhammer: ["1L1"],
		},
	},
	hoppip: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			amnesia: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bounce: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cottonguard: ["1L1"],
			cottonspore: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			payday: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			ragepowder: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			silverwind: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			splash: ["1L1"],
			strengthsap: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			switcheroo: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			worryseed: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 3},
		],
	},
	skiploom: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bounce: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			cottonspore: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			ragepowder: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			silverwind: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			splash: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			worryseed: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 12},
		],
	},
	jumpluff: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bounce: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			cottonspore: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			ragepowder: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			silverwind: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			splash: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 27, gender: "M", isHidden: true, moves: ["1L1"]},
		],
	},
	aipom: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tailslap: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	ambipom: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualchop: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metronome: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
		},
	},
	sunkern: {
		learnset: {
			absorb: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			ingrain: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			morningsun: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	sunflora: {
		learnset: {
			absorb: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flowershield: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ingrain: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	yanma: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			sonicboom: ["1L1"],
			steelwing: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
		},
	},
	yanmega: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			flash: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			ominouswind: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			sonicboom: ["1L1"],
			steelwing: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
		},
	},
	wooper: {
		learnset: {
			acidspray: ["1L1"],
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			eerieimpulse: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			guardswap: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			yawn: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 4},
		],
	},
	wooperpaldea: {
		learnset: {
			acidspray: ["1L1"],
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hydropump: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			mist: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			spikes: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swallow: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			yawn: ["1L1"],
		},
	},
	quagsire: {
		learnset: {
			acidspray: ["1L1"],
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			eerieimpulse: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			guardswap: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			yawn: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 15},
			{generation: 4, level: 10},
		],
	},
	clodsire: {
		learnset: {
			acidspray: ["1L1"],
			amnesia: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			megahorn: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	murkrow: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			feintattack: ["1L1"],
			flatter: ["1L1"],
			fly: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			haze: ["1L1"],
			heatwave: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			lashout: ["1L1"],
			meanlook: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			perishsong: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			quash: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	honchkrow: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			comeuppance: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			haze: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			lashout: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			nightslash: ["1L1"],
			ominouswind: ["1L1"],
			payback: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wingattack: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 65, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	misdreavus: {
		learnset: {
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			destinybond: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			grudge: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			inferno: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meanlook: ["1L1"],
			mefirst: ["1L1"],
			memento: ["1L1"],
			mimic: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			perishsong: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	mismagius: {
		learnset: {
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mysticalfire: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	unown: {
		learnset: {
			hiddenpower: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 5},
			{generation: 3, level: 25},
			{generation: 4, level: 5},
			{generation: 6, level: 32},
		],
	},
	wynaut: {
		learnset: {
			amnesia: ["1L1"],
			charm: ["1L1"],
			counter: ["1L1"],
			destinybond: ["1L1"],
			encore: ["1L1"],
			mirrorcoat: ["1L1"],
			safeguard: ["1L1"],
			splash: ["1L1"],
			tickle: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
		],
	},
	wobbuffet: {
		learnset: {
			amnesia: ["1L1"],
			charm: ["1L1"],
			counter: ["1L1"],
			destinybond: ["1L1"],
			encore: ["1L1"],
			mirrorcoat: ["1L1"],
			safeguard: ["1L1"],
			splash: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 10, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 15, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 2, level: 5},
			{generation: 4, level: 3},
		],
	},
	girafarig: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			foresight: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			magiccoat: ["1L1"],
			meanlook: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			odorsleuth: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicfangs: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			twinbeam: ["1L1"],
			uproar: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	pineco: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icespinner: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			powertrick: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venoshock: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 20, moves: ["1L1"]},
		],
	},
	forretress: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icespinner: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			mimic: ["1L1"],
			mirrorshot: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venoshock: ["1L1"],
			voltswitch: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	dunsparce: {
		learnset: {
			agility: ["1L1"],
			airslash: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonrush: ["1L1"],
			dreameater: ["1L1"],
			drillrun: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			glare: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hyperdrill: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			lunge: ["1L1"],
			magiccoat: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trumpcard: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			yawn: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	dudunsparce: {
		learnset: {
			agility: ["1L1"],
			airslash: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			boomburst: ["1L1"],
			breakingswipe: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chillingwater: ["1L1"],
			coil: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			drillrun: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			gigaimpact: ["1L1"],
			glare: ["1L1"],
			gyroball: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hyperdrill: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			lunge: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			outrage: ["1L1"],
			painsplit: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			roost: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			shadowball: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			wildcharge: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	gligar: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crabhammer: ["1L1"],
			crosspoison: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			firefang: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			guillotine: ["1L1"],
			gunkshot: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			icefang: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lunge: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			powertrick: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			skittersmack: ["1L1"],
			skyuppercut: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			wingattack: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	gliscor: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crabhammer: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			firefang: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			guillotine: ["1L1"],
			gunkshot: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lunge: ["1L1"],
			metalclaw: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			skittersmack: ["1L1"],
			skyattack: ["1L1"],
			skyuppercut: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	snubbull: {
		learnset: {
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			incinerate: ["1L1"],
			lashout: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smellingsalts: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	granbull: {
		learnset: {
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			lastresort: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 15},
		],
	},
	qwilfish: {
		learnset: {
			acidspray: ["1L1"],
			acupressure: ["1L1"],
			agility: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			barbbarrage: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			destinybond: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fellstinger: ["1L1"],
			flail: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			minimize: ["1L1"],
			mudshot: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			spitup: ["1L1"],
			steelroller: ["1L1"],
			stockpile: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	qwilfishhisui: {
		learnset: {
			acidspray: ["1L1"],
			acupressure: ["1L1"],
			agility: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			astonish: ["1L1"],
			barbbarrage: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			chillingwater: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			doubleedge: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fellstinger: ["1L1"],
			flail: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			haze: ["1L1"],
			hex: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			lashout: ["1L1"],
			liquidation: ["1L1"],
			minimize: ["1L1"],
			mudshot: ["1L1"],
			painsplit: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	overqwil: {
		learnset: {
			acidspray: ["1L1"],
			acupressure: ["1L1"],
			agility: ["1L1"],
			barbbarrage: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			chillingwater: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			doubleedge: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fellstinger: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			haze: ["1L1"],
			hex: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			lashout: ["1L1"],
			liquidation: ["1L1"],
			minimize: ["1L1"],
			mudshot: ["1L1"],
			painsplit: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smartstrike: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	shuckle: {
		learnset: {
			acid: ["1L1"],
			acupressure: ["1L1"],
			afteryou: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			guardsplit: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			powersplit: ["1L1"],
			powertrick: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			shellsmash: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelroller: ["1L1"],
			stickyweb: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			toxic: ["1L1"],
			venoshock: ["1L1"],
			withdraw: ["1L1"],
			wrap: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 20, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	heracross: {
		learnset: {
			aerialace: ["1L1"],
			armthrust: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hornattack: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lunge: ["1L1"],
			megahorn: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			pinmissile: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			venoshock: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, gender: "F", nature: "Adamant", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, nature: "Adamant", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	sneasel: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			assist: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			upperhand: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	sneaselhisui: {
		learnset: {
			acidspray: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			counter: ["1L1"],
			dig: ["1L1"],
			doublehit: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			honeclaws: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metalclaw: ["1L1"],
			nastyplot: ["1L1"],
			nightslash: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			vacuumwave: ["1L1"],
			venoshock: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	weavile: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			upperhand: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 30, gender: "M", nature: "Jolly", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 48, gender: "M", perfectIVs: 2, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	sneasler: {
		learnset: {
			acidspray: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			dig: ["1L1"],
			direclaw: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metalclaw: ["1L1"],
			nastyplot: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			venoshock: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	teddiursa: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			babydolleyes: ["1L1"],
			bellydrum: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chipaway: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crosschop: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hypervoice: ["1L1"],
			icepunch: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 11, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 2},
		],
	},
	ursaring: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icepunch: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 25},
		],
	},
	ursaluna: {
		learnset: {
			aerialace: ["1L1"],
			avalanche: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			drainpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hammerarm: ["1L1"],
			hardpress: ["1L1"],
			headlongrush: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icepunch: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			metalclaw: ["1L1"],
			metronome: ["1L1"],
			payback: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
		},
	},
	ursalunabloodmoon: {
		learnset: {
			avalanche: ["1L1"],
			bellydrum: ["1L1"],
			bloodmoon: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			counter: ["1L1"],
			crosschop: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hammerarm: ["1L1"],
			harden: ["1L1"],
			hardpress: ["1L1"],
			headlongrush: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icepunch: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			metalclaw: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			mudshot: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			playnice: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 70, nature: "Hardy", perfectIVs: 3, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	slugma: {
		learnset: {
			acidarmor: ["1L1"],
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			frustration: ["1L1"],
			guardswap: ["1L1"],
			harden: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			lavaplume: ["1L1"],
			lightscreen: ["1L1"],
			memento: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			willowisp: ["1L1"],
			yawn: ["1L1"],
		},
	},
	magcargo: {
		learnset: {
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			lavaplume: ["1L1"],
			lightscreen: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shellsmash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smog: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			willowisp: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 38, moves: ["1L1"]},
		],
		encounters: [
			{generation: 3, level: 25},
			{generation: 6, level: 30},
		],
	},
	swinub: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			freezedry: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iceshard: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			lightscreen: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 22, abilities: ["1L1"], moves: ["1L1"]},
		],
	},
	piloswine: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hornattack: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iceshard: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			lightscreen: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			peck: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	mamoswine: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			hardpress: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iceshard: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			mist: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			peck: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 34, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: true, gender: "M", nature: "Adamant", isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	corsola: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			camouflage: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			ingrain: ["1L1"],
			irondefense: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			mist: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spikecannon: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
			{generation: 7, level: 50, gender: "F", nature: "Serious", abilities: ["1L1"], moves: ["1L1"], pokeball: "ultraball"},
		],
	},
	corsolagalar: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			destinybond: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gigadrain: ["1L1"],
			grudge: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			haze: ["1L1"],
			headsmash: ["1L1"],
			hex: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			meteorbeam: ["1L1"],
			mirrorcoat: ["1L1"],
			naturepower: ["1L1"],
			nightshade: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strengthsap: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			tackle: ["1L1"],
			throatchop: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 15, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	cursola: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grudge: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			hex: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			meteorbeam: ["1L1"],
			mirrorcoat: ["1L1"],
			nightshade: ["1L1"],
			perishsong: ["1L1"],
			pinmissile: ["1L1"],
			poltergeist: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			revenge: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strengthsap: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			tackle: ["1L1"],
			throatchop: ["1L1"],
			whirlpool: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	remoraid: {
		learnset: {
			acidspray: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			lockon: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			octazooka: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			waterspout: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	octillery: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			liquidation: ["1L1"],
			lockon: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			octazooka: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, gender: "F", nature: "Serious", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 4, level: 19},
			{generation: 7, level: 10},
		],
	},
	delibird: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			batonpass: ["1L1"],
			bestow: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bravebird: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			destinybond: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			drillrun: ["1L1"],
			dualwingbeat: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			featherdance: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			freezedry: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			happyhour: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			iceball: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			memento: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			pluck: ["1L1"],
			poweruppunch: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			signalbeam: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			splash: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 10, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	mantyke: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			amnesia: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			mirrorcoat: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			wideguard: ["1L1"],
			wingattack: ["1L1"],
		},
	},
	mantine: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			amnesia: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			signalbeam: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			splash: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			wideguard: ["1L1"],
			wingattack: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	skarmory: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			bodypress: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			drillrun: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			guardswap: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			ominouswind: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	houndour: {
		learnset: {
			attract: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			comeuppance: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			odorsleuth: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			punishment: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smog: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 17, moves: ["1L1"]},
		],
	},
	houndoom: {
		learnset: {
			attract: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			comeuppance: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			odorsleuth: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smog: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, nature: "Timid", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 4, level: 20},
		],
	},
	phanpy: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hypervoice: ["1L1"],
			iceshard: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			watergun: ["1L1"],
		},
		encounters: [
			{generation: 2, level: 2},
		],
	},
	donphan: {
		learnset: {
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hornattack: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			icespinner: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			magnitude: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			playrough: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 24, maxEggMoves: 1},
		],
	},
	stantler: {
		learnset: {
			agility: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			jumpkick: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magicroom: ["1L1"],
			mefirst: ["1L1"],
			megahorn: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshieldbash: ["1L1"],
			psyshock: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stomp: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	wyrdeer: {
		learnset: {
			agility: ["1L1"],
			astonish: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			megahorn: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psyshieldbash: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			roleplay: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stomp: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wildcharge: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	smeargle: {
		learnset: {
			captivate: ["1L1"],
			falseswipe: ["1L1"],
			flamethrower: ["1L1"],
			furyswipes: ["1L1"],
			meanlook: ["1L1"],
			odorsleuth: ["1L1"],
			seismictoss: ["1L1"],
			sketch: ["1L1"],
			sleeptalk: ["1L1"],
			spore: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 50, gender: "F", nature: "Jolly", ivs: {atk: 31, spe: 31}, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 40, gender: "M", nature: "Jolly", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	miltank: {
		learnset: {
			afteryou: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dizzypunch: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			heartstamp: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			milkdrink: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			steelroller: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			tackle: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			wakeupslap: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 20, perfectIVs: 3, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	raikou: {
		learnset: {
			agility: ["1L1"],
			aurasphere: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quash: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			voltswitch: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 30, shiny: true, nature: "Rash", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 40},
			{generation: 3, level: 40},
		],
		eventOnly: false,
	},
	entei: {
		learnset: {
			agility: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			eruption: ["1L1"],
			extrasensory: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sacredfire: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 30, shiny: true, nature: "Adamant", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 40},
			{generation: 3, level: 40},
		],
		eventOnly: false,
	},
	suicune: {
		learnset: {
			agility: ["1L1"],
			airslash: ["1L1"],
			aquaring: ["1L1"],
			aurorabeam: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			mist: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 30, shiny: true, nature: "Relaxed", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 40},
			{generation: 3, level: 40},
		],
		eventOnly: false,
	},
	larvitar: {
		learnset: {
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragondance: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 20, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 5, shiny: true, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	pupitar: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragondance: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
		},
	},
	tyranitar: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			powergem: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 100, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 55, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, nature: "Jolly", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 55, shiny: true, nature: "Adamant", ivs: {hp: 31, atk: 31, def: 31, spa: 14, spd: 31, spe: 0}, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 5, level: 50},
		],
	},
	lugia: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aeroblast: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			flash: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			ominouswind: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychoboost: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			punishment: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			whirlwind: ["1L1"],
			wonderroom: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 50, moves: ["1L1"]},
			{generation: 4, level: 45, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 5, isHidden: true, moves: ["1L1"], pokeball: "dreamball"},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, nature: "Timid", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 100, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 40},
		],
		eventOnly: false,
	},
	hooh: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			ancientpower: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			bulldoze: ["1L1"],
			burnup: ["1L1"],
			calmmind: ["1L1"],
			celebrate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			ominouswind: ["1L1"],
			overheat: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sacredfire: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			weatherball: ["1L1"],
			whirlwind: ["1L1"],
			willowisp: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 45, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 5, isHidden: true, moves: ["1L1"], pokeball: "dreamball"},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		encounters: [
			{generation: 2, level: 40},
		],
		eventOnly: false,
	},
	celebi: {
		learnset: {
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			healbell: ["1L1"],
			healblock: ["1L1"],
			healingwish: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			holdback: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			nightmare: ["1L1"],
			perishsong: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stealthrock: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			telekinesis: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			wonderroom: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 30, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "luxuryball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 30, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 60, shiny: true, nature: "Quirky", moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 2, level: 30},
		],
		eventOnly: false,
	},
	treecko: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			crushclaw: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragontail: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			slam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
		],
	},
	grovyle: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragontail: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			leafage: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	sceptile: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crosspoison: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frenzyplant: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leafage: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			outrage: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaleshot: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shedtail: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	torchic: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			feint: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			lastresort: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			overheat: ["1L1"],
			peck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smellingsalts: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 10, gender: "M", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	combusken: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			blazekick: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			lastresort: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			skyuppercut: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
	},
	blaziken: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			blastburn: ["1L1"],
			blazekick: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bravebird: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			skyuppercut: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 50, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	mudkip: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			barrier: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			iceball: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wideguard: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
		],
	},
	marshtomp: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandtomb: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			sleeptalk: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
	},
	swampert: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			darkestlariat: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			hammerarm: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandtomb: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			sleeptalk: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	poochyena: {
		learnset: {
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			mefirst: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			poisonfang: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, abilities: ["1L1"], moves: ["1L1"]},
		],
		encounters: [
			{generation: 3, level: 2},
		],
	},
	mightyena: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 64, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	zigzagoon: {
		learnset: {
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			bellydrum: ["1L1"],
			bestow: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			pinmissile: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			simplebeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailslap: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: true, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: 1, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
		],
		encounters: [
			{generation: 3, level: 2},
		],
	},
	zigzagoongalar: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			counter: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fling: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			mudshot: ["1L1"],
			partingshot: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			protect: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			trick: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
	},
	linoone: {
		learnset: {
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			bellydrum: ["1L1"],
			bestow: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			pinmissile: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tackle: ["1L1"],
			tailslap: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 4, level: 3},
			{generation: 6, level: 17, maxEggMoves: 1},
		],
	},
	linoonegalar: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			counter: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fling: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			mudshot: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			trick: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
	},
	obstagoon: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			closecombat: ["1L1"],
			counter: ["1L1"],
			crosschop: ["1L1"],
			crosspoison: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudshot: ["1L1"],
			nightslash: ["1L1"],
			obstruct: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			trick: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	wurmple: {
		learnset: {
			bugbite: ["1L1"],
			electroweb: ["1L1"],
			poisonsting: ["1L1"],
			snore: ["1L1"],
			stringshot: ["1L1"],
			tackle: ["1L1"],
		},
		encounters: [
			{generation: 3, level: 2},
		],
	},
	silcoon: {
		learnset: {
			bugbite: ["1L1"],
			electroweb: ["1L1"],
			harden: ["1L1"],
			irondefense: ["1L1"],
			stringshot: ["1L1"],
		},
		encounters: [
			{generation: 3, level: 5},
			{generation: 4, level: 5},
			{generation: 6, level: 2, maxEggMoves: 1},
		],
	},
	beautifly: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			laserfocus: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			morningsun: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			quiverdance: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			whirlwind: ["1L1"],
		},
	},
	cascoon: {
		learnset: {
			bugbite: ["1L1"],
			electroweb: ["1L1"],
			harden: ["1L1"],
			irondefense: ["1L1"],
			stringshot: ["1L1"],
		},
		encounters: [
			{generation: 3, level: 5},
			{generation: 4, level: 5},
			{generation: 6, level: 2, maxEggMoves: 1},
		],
	},
	dustox: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			mimic: ["1L1"],
			moonlight: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			poisonpowder: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			quiverdance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			whirlwind: ["1L1"],
		},
	},
	lotad: {
		learnset: {
			absorb: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 3, level: 3},
		],
	},
	lombre: {
		learnset: {
			absorb: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 13, maxEggMoves: 1},
		],
	},
	ludicolo: {
		learnset: {
			absorb: ["1L1"],
			amnesia: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, shiny: 1, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 30, gender: "M", nature: "Calm", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	seedot: {
		learnset: {
			absorb: ["1L1"],
			amnesia: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 17, moves: ["1L1"]},
		],
		encounters: [
			{generation: 3, level: 3},
		],
	},
	nuzleaf: {
		learnset: {
			absorb: ["1L1"],
			aircutter: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defensecurl: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			megakick: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			pound: ["1L1"],
			powerswap: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 13, maxEggMoves: 1},
		],
	},
	shiftry: {
		learnset: {
			absorb: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defensecurl: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leaftornado: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			megakick: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			ominouswind: ["1L1"],
			payback: ["1L1"],
			petalblizzard: ["1L1"],
			pound: ["1L1"],
			powerswap: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			silverwind: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			twister: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			weatherball: ["1L1"],
			whirlwind: ["1L1"],
			willowisp: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	taillow: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			boomburst: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
		],
		encounters: [
			{generation: 3, level: 4},
		],
	},
	swellow: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			laserfocus: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 43, moves: ["1L1"]},
		],
		encounters: [
			{generation: 4, level: 20},
		],
	},
	wingull: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bravebird: ["1L1"],
			brine: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			gust: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			wideguard: ["1L1"],
			wingattack: ["1L1"],
		},
		encounters: [
			{generation: 3, level: 2},
		],
	},
	pelipper: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			brine: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			payback: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shockwave: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			spitup: ["1L1"],
			steelwing: ["1L1"],
			stockpile: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wingattack: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 15},
			{generation: 6, level: 18, maxEggMoves: 1},
		],
	},
	ralts: {
		learnset: {
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			grudge: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meanlook: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			memento: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mistyterrain: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sing: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			wish: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 20, moves: ["1L1"]},
			{generation: 6, level: 1, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 3, level: 4},
		],
	},
	kirlia: {
		learnset: {
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mistyterrain: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			tripleaxel: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 6},
		],
	},
	gardevoir: {
		learnset: {
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			tripleaxel: ["1L1"],
			vacuumwave: ["1L1"],
			willowisp: ["1L1"],
			wish: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, shiny: 1, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, shiny: true, gender: "F", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	gallade: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			airslash: ["1L1"],
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			aquacutter: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leafblade: ["1L1"],
			leer: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mistyterrain: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			nightslash: ["1L1"],
			painsplit: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sacredsword: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarblade: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			tripleaxel: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			wideguard: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	surskit: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			aquajet: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fellstinger: ["1L1"],
			flash: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			liquidation: ["1L1"],
			lunge: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mist: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			pounce: ["1L1"],
			powersplit: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			solarbeam: ["1L1"],
			stickyweb: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 3, level: 3},
		],
	},
	masquerain: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bubble: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			liquidation: ["1L1"],
			lunge: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			ominouswind: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			quiverdance: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlwind: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 21, maxEggMoves: 1},
		],
	},
	shroomish: {
		learnset: {
			absorb: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			poisonpowder: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spore: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			venoshock: ["1L1"],
			wakeupslap: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 15, abilities: ["1L1"], moves: ["1L1"]},
		],
	},
	breloom: {
		learnset: {
			absorb: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			machpunch: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poisonjab: ["1L1"],
			poisonpowder: ["1L1"],
			pounce: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			skyuppercut: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spore: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			vacuumwave: ["1L1"],
			venoshock: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	slakoth: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gunkshot: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			playrough: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slackoff: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	vigoroth: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			playrough: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	slaking: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hammerarm: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			playrough: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			punishment: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, gender: "M", nature: "Adamant", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	nincada: {
		learnset: {
			absorb: ["1L1"],
			aerialace: ["1L1"],
			bide: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			finalgambit: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			gust: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			leechlife: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			toxic: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	ninjask: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	shedinja: {
		learnset: {
			absorb: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			batonpass: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grudge: ["1L1"],
			harden: ["1L1"],
			healblock: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			leechlife: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			willowisp: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	whismur: {
		learnset: {
			astonish: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			circlethrow: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			defensecurl: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smellingsalts: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stomp: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			synchronoise: ["1L1"],
			takedown: ["1L1"],
			teeterdance: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			whirlwind: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
		],
	},
	loudred: {
		learnset: {
			astonish: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			synchronoise: ["1L1"],
			taunt: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 16, maxEggMoves: 1},
		],
	},
	exploud: {
		learnset: {
			astonish: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			boomburst: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			synchronoise: ["1L1"],
			taunt: ["1L1"],
			terrainpulse: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 100, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 50, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	makuhita: {
		learnset: {
			armthrust: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletpunch: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crosschop: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			knockoff: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smellingsalts: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			vitalthrow: ["1L1"],
			wakeupslap: ["1L1"],
			whirlpool: ["1L1"],
			whirlwind: ["1L1"],
			wideguard: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 18, moves: ["1L1"]},
		],
	},
	hariyama: {
		learnset: {
			armthrust: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			headlongrush: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smellingsalts: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			vitalthrow: ["1L1"],
			wakeupslap: ["1L1"],
			whirlpool: ["1L1"],
			whirlwind: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 22},
		],
	},
	nosepass: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gravity: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			magnitude: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			wideguard: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 26, moves: ["1L1"]},
		],
	},
	probopass: {
		learnset: {
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magnetbomb: ["1L1"],
			magneticflux: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			voltswitch: ["1L1"],
			wideguard: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	skitty: {
		learnset: {
			assist: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			cosmicpower: ["1L1"],
			covet: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			mimic: ["1L1"],
			mudbomb: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			simplebeam: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			wakeupslap: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
			{generation: 3, level: 5, shiny: 1, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
			{generation: 3, level: 10, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 3, level: 3, gender: "F", ivs: {hp: 5, atk: 4, def: 4, spa: 5, spd: 4, spe: 4}, abilities: ["1L1"], pokeball: "pokeball"},
		],
	},
	delcatty: {
		learnset: {
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 18, abilities: ["1L1"], moves: ["1L1"]},
		],
	},
	sableye: {
		learnset: {
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			counter: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			meanlook: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			moonlight: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			octazooka: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poisonjab: ["1L1"],
			poltergeist: ["1L1"],
			powergem: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			waterpulse: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 33, abilities: ["1L1"], moves: ["1L1"]},
			{generation: 5, level: 50, gender: "M", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, nature: "Relaxed", ivs: {hp: 31, spa: 31}, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, nature: "Bold", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	mawile: {
		learnset: {
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dynamicpunch: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			faketears: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalburst: ["1L1"],
			mimic: ["1L1"],
			mistyterrain: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			poisonfang: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			sing: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stockpile: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			visegrip: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 22, moves: ["1L1"]},
			{generation: 6, level: 50, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	aron: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonrush: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			magnetrise: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smellingsalts: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stomp: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	lairon: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			magnetrise: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	aggron: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lowkick: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 100, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 50, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 50, nature: "Brave", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	meditite: {
		learnset: {
			acupressure: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulletpunch: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			feint: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			meditate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			poisonjab: ["1L1"],
			powerswap: ["1L1"],
			powertrick: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 20, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	medicham: {
		learnset: {
			acupressure: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			axekick: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			meditate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			poisonjab: ["1L1"],
			powertrick: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 35},
			{generation: 6, level: 34, maxEggMoves: 1},
		],
	},
	electrike: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electroball: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			flameburst: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			icefang: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tackle: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	manectric: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 44, moves: ["1L1"]},
			{generation: 6, level: 50, nature: "Timid", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	plusle: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bestow: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			defensecurl: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nuzzle: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sing: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			watersport: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	minun: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			defensecurl: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			echoedvoice: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nuzzle: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trumpcard: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	volbeat: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			counter: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			dizzypunch: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			infestation: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			moonlight: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			playrough: ["1L1"],
			pounce: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailglow: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	illumise: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			infestation: ["1L1"],
			lightscreen: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			moonlight: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			pounce: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			wish: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	budew: {
		learnset: {
			absorb: ["1L1"],
			attract: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			cottonspore: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			growth: ["1L1"],
			hiddenpower: ["1L1"],
			leafstorm: ["1L1"],
			lifedew: ["1L1"],
			megadrain: ["1L1"],
			mindreader: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			pinmissile: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	roselia: {
		learnset: {
			absorb: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			cottonspore: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			growth: ["1L1"],
			hiddenpower: ["1L1"],
			ingrain: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lifedew: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mimic: ["1L1"],
			mindreader: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			nightmare: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 22, moves: ["1L1"]},
		],
	},
	roserade: {
		learnset: {
			absorb: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ingrain: ["1L1"],
			laserfocus: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uproar: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	gulpin: {
		learnset: {
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			destinybond: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			infestation: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			strength: ["1L1"],
			stuffcheeks: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterpulse: ["1L1"],
			wringout: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 17, moves: ["1L1"]},
		],
	},
	swalot: {
		learnset: {
			acidspray: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterpulse: ["1L1"],
			wringout: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	carvanha: {
		learnset: {
			agility: ["1L1"],
			ancientpower: ["1L1"],
			aquajet: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonfang: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 15, moves: ["1L1"]},
			{generation: 6, level: 1, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	sharpedo: {
		learnset: {
			agility: ["1L1"],
			ancientpower: ["1L1"],
			aquajet: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			poisonfang: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, nature: "Adamant", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 43, gender: "M", perfectIVs: 2, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 7, level: 10},
		],
	},
	wailmer: {
		learnset: {
			amnesia: ["1L1"],
			aquaring: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			splash: ["1L1"],
			steelroller: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			thrash: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			waterspout: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	wailord: {
		learnset: {
			amnesia: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			defensecurl: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			naturalgift: ["1L1"],
			nobleroar: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			splash: ["1L1"],
			steelroller: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			waterspout: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 100, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 50, moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 3, level: 25},
			{generation: 4, level: 35},
			{generation: 5, level: 30},
			{generation: 7, level: 10},
		],
	},
	numel: {
		learnset: {
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flashcannon: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			howl: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			lashout: ["1L1"],
			lavaplume: ["1L1"],
			magnitude: ["1L1"],
			mimic: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			willowisp: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 14, abilities: ["1L1"], moves: ["1L1"]},
			{generation: 6, level: 1, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	camerupt: {
		learnset: {
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			eruption: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			fissure: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flashcannon: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			lashout: ["1L1"],
			lavaplume: ["1L1"],
			magnitude: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			willowisp: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 43, gender: "M", perfectIVs: 2, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 6, level: 30},
		],
	},
	torkoal: {
		learnset: {
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			eruption: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			lavaplume: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shellsmash: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
			withdraw: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 50, gender: "M", nature: "Bold", abilities: ["1L1"], ivs: {hp: 31, atk: 12, def: 31, spa: 31, spd: 31, spe: 0}, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	spoink: {
		learnset: {
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			lunge: ["1L1"],
			magiccoat: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			odorsleuth: ["1L1"],
			payback: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			simplebeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			splash: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			whirlwind: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
		],
	},
	grumpig: {
		learnset: {
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			lunge: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			odorsleuth: ["1L1"],
			payback: ["1L1"],
			powergem: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			splash: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			teeterdance: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	spinda: {
		learnset: {
			assist: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			dizzypunch: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			guardsplit: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			lastresort: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychocut: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sing: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			smellingsalts: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spotlight: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			teeterdance: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
		],
	},
	trapinch: {
		learnset: {
			astonish: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			firstimpression: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gust: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			laserfocus: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 1, shiny: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	vibrava: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			boomburst: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fissure: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			laserfocus: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			sonicboom: ["1L1"],
			stealthrock: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
		},
	},
	flygon: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			alluringvoice: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			boomburst: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			outrage: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychicnoise: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			sonicboom: ["1L1"],
			stealthrock: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 45, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, gender: "M", nature: "Naive", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	cacnea: {
		learnset: {
			absorb: ["1L1"],
			acid: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			cottonspore: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fellstinger: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			ingrain: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			magicalleaf: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			needlearm: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			powertrip: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			smellingsalts: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
		],
	},
	cacturne: {
		learnset: {
			absorb: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			cottonspore: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ingrain: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			needlearm: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			powertrip: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			spikyshield: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 45, moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 6, level: 30},
		],
	},
	swablu: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			cottonguard: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			healbell: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mist: ["1L1"],
			moonblast: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			outrage: ["1L1"],
			peck: ["1L1"],
			perishsong: ["1L1"],
			playrough: ["1L1"],
			pluck: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			sing: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
			{generation: 5, level: 1, shiny: true, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 1, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	altaria: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			alluringvoice: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			breakingswipe: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			cottonguard: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			featherdance: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			healbell: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			mimic: ["1L1"],
			mist: ["1L1"],
			moonblast: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			outrage: ["1L1"],
			peck: ["1L1"],
			perishsong: ["1L1"],
			playrough: ["1L1"],
			pluck: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			sing: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 45, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 36, moves: ["1L1"]},
			{generation: 5, level: 35, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 100, nature: "Modest", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	zangoose: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			bellydrum: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			finalgambit: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			powertrip: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 18, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 28, moves: ["1L1"]},
		],
	},
	seviper: {
		learnset: {
			acidspray: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			finalgambit: ["1L1"],
			firefang: ["1L1"],
			flamethrower: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			glare: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			infestation: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lick: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			poisonfang: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			punishment: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 18, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 30, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	lunatone: {
		learnset: {
			acrobatics: ["1L1"],
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			healblock: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			powergem: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			telekinesis: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			weatherball: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 25, moves: ["1L1"]},
			{generation: 7, level: 30, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	solrock: {
		learnset: {
			acrobatics: ["1L1"],
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			healblock: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			morningsun: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			telekinesis: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 41, moves: ["1L1"]},
			{generation: 7, level: 30, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	barboach: {
		learnset: {
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragondance: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			magnitude: ["1L1"],
			mimic: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	whiscash: {
		learnset: {
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragondance: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			magnitude: ["1L1"],
			mimic: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 51, gender: "F", nature: "Gentle", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 4, level: 10},
			{generation: 7, level: 10},
		],
	},
	corphish: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			aquajet: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crabhammer: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dragondance: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			guillotine: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			switcheroo: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trumpcard: ["1L1"],
			visegrip: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball", emeraldEventEgg: true},
		],
	},
	crawdaunt: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crabhammer: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dragondance: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			guillotine: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			hardpress: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			visegrip: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 100, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 50, moves: ["1L1"], pokeball: "pokeball"},
		],
		encounters: [
			{generation: 7, level: 10},
		],
	},
	baltoy: {
		learnset: {
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			eerieimpulse: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			explosion: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			healblock: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			powersplit: ["1L1"],
			powerswap: ["1L1"],
			powertrick: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			telekinesis: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 17, moves: ["1L1"]},
		],
	},
	claydol: {
		learnset: {
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			bodypress: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			eerieimpulse: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			explosion: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			healblock: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			powersplit: ["1L1"],
			powerswap: ["1L1"],
			powertrick: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	lileep: {
		learnset: {
			acid: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			constrict: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			ingrain: ["1L1"],
			megadrain: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			worryseed: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	cradily: {
		learnset: {
			acid: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			constrict: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			ingrain: ["1L1"],
			leechseed: ["1L1"],
			megadrain: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			toxic: ["1L1"],
			worryseed: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
		},
	},
	anorith: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			aquajet: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bugbite: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crosspoison: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			metalclaw: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			toxic: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	armaldo: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crosspoison: ["1L1"],
			crushclaw: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			metalclaw: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			toxic: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	feebas: {
		learnset: {
			attract: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonpulse: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 5, gender: "F", nature: "Calm", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	milotic: {
		learnset: {
			alluringvoice: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragoncheer: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wrap: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 35, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, gender: "F", nature: "Bold", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, shiny: true, gender: "M", nature: "Timid", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 58, gender: "M", nature: "Lax", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	castform: {
		learnset: {
			amnesia: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			cosmicpower: ["1L1"],
			defensecurl: ["1L1"],
			defog: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			guardswap: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			lastresort: ["1L1"],
			luckychant: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflecttype: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			workup: ["1L1"],
		},
	},
	kecleon: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			camouflage: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			dizzypunch: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflecttype: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			skillswap: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			tailwhip: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			waterpulse: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
		},
	},
	shuppet: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			foresight: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			grudge: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 45, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	banette: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			cottonguard: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grudge: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 37, abilities: ["1L1"], moves: ["1L1"]},
			{generation: 5, level: 37, gender: "F", isHidden: true, moves: ["1L1"]},
		],
		encounters: [
			{generation: 5, level: 32},
		],
	},
	duskull: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gravity: ["1L1"],
			grudge: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			meanlook: ["1L1"],
			memento: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowsneak: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 45, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 19, moves: ["1L1"]},
		],
	},
	dusclops: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			meanlook: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowpunch: ["1L1"],
			shadowsneak: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 16},
			{generation: 6, level: 30},
		],
	},
	dusknoir: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkestlariat: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			hardpress: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			meanlook: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowpunch: ["1L1"],
			shadowsneak: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	tropius: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bestow: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragondance: ["1L1"],
			dragonhammer: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			gust: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leaftornado: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			magicalleaf: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			ominouswind: ["1L1"],
			outrage: ["1L1"],
			petalblizzard: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			silverwind: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			spite: ["1L1"],
			steelwing: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wideguard: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 53, gender: "F", nature: "Jolly", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	chingling: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bind: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wish: ["1L1"],
			wrap: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	chimecho: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bind: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			craftyshield: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			defog: ["1L1"],
			disable: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			perishsong: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wish: ["1L1"],
			wrap: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 10, gender: "M", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	absol: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brutalswing: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			focusenergy: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			magiccoat: ["1L1"],
			meanlook: ["1L1"],
			mefirst: ["1L1"],
			megahorn: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			perishsong: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			waterpulse: ["1L1"],
			willowisp: ["1L1"],
			wish: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: 1, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 35, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 70, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	snorunt: {
		learnset: {
			astonish: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			switcheroo: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 20, abilities: ["1L1"], moves: ["1L1"]},
		],
	},
	glalie: {
		learnset: {
			astonish: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			freezedry: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			mimic: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	froslass: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			destinybond: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poltergeist: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			tripleaxel: ["1L1"],
			wakeupslap: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	spheal: {
		learnset: {
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			bellydrum: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			iceball: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			steelroller: ["1L1"],
			stockpile: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 17, abilities: ["1L1"], moves: ["1L1"]},
		],
	},
	sealeo: {
		learnset: {
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			defensecurl: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			iceball: ["1L1"],
			icebeam: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelroller: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 25},
			{generation: 6, level: 28, maxEggMoves: 1},
		],
	},
	walrein: {
		learnset: {
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			defensecurl: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			iceball: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 5, level: 30},
		],
	},
	clamperl: {
		learnset: {
			aquaring: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			captivate: ["1L1"],
			clamp: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shellsmash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	huntail: {
		learnset: {
			aquatail: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			captivate: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	gorebyss: {
		learnset: {
			agility: ["1L1"],
			amnesia: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			captivate: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	relicanth: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			liquidation: ["1L1"],
			magnitude: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	luvdisc: {
		learnset: {
			agility: ["1L1"],
			aquajet: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			healpulse: ["1L1"],
			heartstamp: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			luckychant: ["1L1"],
			mimic: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			wish: ["1L1"],
		},
	},
	bagon: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			wish: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 1, shiny: true, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 6, level: 1, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	shelgon: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 7, level: 15},
		],
	},
	salamence: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 50, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 50, moves: ["1L1"]},
			{generation: 4, level: 50, gender: "M", nature: "Naughty", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 7, level: 9},
		],
	},
	beldum: {
		learnset: {
			headbutt: ["1L1"],
			holdback: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			steelbeam: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 5, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	metang: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			bulletpunch: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			metalclaw: ["1L1"],
			meteorbeam: ["1L1"],
			meteormash: ["1L1"],
			mimic: ["1L1"],
			miracleeye: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 30, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	metagross: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			bulletpunch: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			metalclaw: ["1L1"],
			meteorbeam: ["1L1"],
			meteormash: ["1L1"],
			mimic: ["1L1"],
			miracleeye: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicfangs: ["1L1"],
			psychicnoise: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 62, nature: "Brave", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 45, shiny: true, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 45, isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 45, isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 58, nature: "Serious", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, nature: "Jolly", ivs: {hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 31}, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	regirock: {
		learnset: {
			ancientpower: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			hammerarm: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lockon: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			powergem: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 40, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 65, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	regice: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			hail: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			lockon: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 40, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 65, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	registeel: {
		learnset: {
			aerialace: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			hammerarm: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lockon: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			selfdestruct: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 40, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 65, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	latias: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			guardsplit: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mimic: ["1L1"],
			mistball: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychocut: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			reflecttype: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			roleplay: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wish: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 35, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 68, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, nature: "Bashful", moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	latios: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flipturn: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			healblock: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			lusterpurge: ["1L1"],
			magiccoat: ["1L1"],
			memento: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			powersplit: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychocut: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			simplebeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 35, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 68, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, nature: "Modest", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	kyogre: {
		learnset: {
			ancientpower: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			defensecurl: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			liquidation: ["1L1"],
			mimic: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			originpulse: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sheercold: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			waterspout: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 45, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 80, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 45, moves: ["1L1"]},
			{generation: 6, level: 100, nature: "Timid", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	groudon: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			eruption: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lavaplume: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			mimic: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			poweruppunch: ["1L1"],
			precipiceblades: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 45, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 80, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 45, moves: ["1L1"]},
			{generation: 6, level: 100, nature: "Adamant", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	rayquaza: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			avalanche: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			celebrate: ["1L1"],
			confide: ["1L1"],
			cosmicpower: ["1L1"],
			crunch: ["1L1"],
			defog: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonascent: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			meteorbeam: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			vcreate: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wildcharge: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 70, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 70, moves: ["1L1"]},
			{generation: 6, level: 70, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 70, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	jirachi: {
		learnset: {
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			doomdesire: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			happyhour: ["1L1"],
			headbutt: ["1L1"],
			healingwish: ["1L1"],
			heartstamp: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lastresort: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			meteormash: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			moonblast: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			wish: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 5, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: true, nature: "Bashful", ivs: {hp: 24, atk: 3, def: 30, spa: 12, spd: 16, spe: 11}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: true, nature: "Careful", ivs: {hp: 10, atk: 0, def: 10, spa: 10, spd: 26, spe: 12}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: true, nature: "Docile", ivs: {hp: 19, atk: 7, def: 10, spa: 19, spd: 10, spe: 16}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: true, nature: "Hasty", ivs: {hp: 3, atk: 12, def: 12, spa: 7, spd: 11, spe: 9}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: true, nature: "Jolly", ivs: {hp: 11, atk: 8, def: 6, spa: 14, spd: 5, spe: 20}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: true, nature: "Lonely", ivs: {hp: 31, atk: 23, def: 26, spa: 29, spd: 18, spe: 5}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: true, nature: "Naughty", ivs: {hp: 21, atk: 31, def: 31, spa: 18, spd: 24, spe: 19}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: true, nature: "Serious", ivs: {hp: 29, atk: 10, def: 31, spa: 25, spd: 23, spe: 21}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 5, shiny: true, nature: "Timid", ivs: {hp: 15, atk: 28, def: 29, spa: 3, spd: 0, spe: 7}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 3, level: 30, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 5, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 5, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 15, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 25, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 15, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, nature: "Timid", moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	deoxys: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			avalanche: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			cosmicpower: ["1L1"],
			counter: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			meteorbeam: ["1L1"],
			meteormash: ["1L1"],
			mimic: ["1L1"],
			mirrorcoat: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychoboost: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			waterpulse: ["1L1"],
			wonderroom: ["1L1"],
			wrap: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 3, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 30, shiny: 1, moves: ["1L1"]},
			{generation: 3, level: 70, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 100, moves: ["1L1"], pokeball: "duskball"},
			{generation: 6, level: 80, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	deoxysattack: {
		eventOnly: false,
	},
	deoxysdefense: {
		eventOnly: false,
	},
	deoxysspeed: {
		eventOnly: false,
	},
	turtwig: {
		learnset: {
			absorb: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shellsmash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wideguard: ["1L1"],
			withdraw: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 9, level: 1, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	grotle: {
		learnset: {
			absorb: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			withdraw: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	torterra: {
		learnset: {
			absorb: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frenzyplant: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			headlongrush: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			withdraw: ["1L1"],
			woodhammer: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 100, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	chimchar: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			assist: ["1L1"],
			attract: ["1L1"],
			blazekick: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 40, gender: "M", nature: "Mild", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 4, level: 40, gender: "M", nature: "Hardy", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 9, level: 1, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	monferno: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			machpunch: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	infernape: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			blastburn: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			machpunch: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			ragingfury: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 100, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 88, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	piplup: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			mist: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			pound: ["1L1"],
			powertrip: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stealthrock: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 15, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 15, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 7, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 30, gender: "M", nature: "Hardy", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 9, level: 1, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	prinplup: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			metalclaw: ["1L1"],
			mist: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stealthrock: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
	},
	empoleon: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aquajet: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			featherdance: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			liquidation: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			mist: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelwing: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 100, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	starly: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			finalgambit: ["1L1"],
			fly: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 1, gender: "M", nature: "Mild", moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	staravia: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			finalgambit: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 4},
		],
	},
	staraptor: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			finalgambit: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			laserfocus: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
	},
	bidoof: {
		learnset: {
			amnesia: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperfang: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			watersport: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 1, gender: "M", nature: "Lonely", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	bibarel: {
		learnset: {
			amnesia: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hyperfang: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			liquidation: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 4},
		],
	},
	kricketot: {
		learnset: {
			bide: ["1L1"],
			bugbite: ["1L1"],
			endeavor: ["1L1"],
			growl: ["1L1"],
			lunge: ["1L1"],
			mudslap: ["1L1"],
			skittersmack: ["1L1"],
			snore: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			uproar: ["1L1"],
		},
	},
	kricketune: {
		learnset: {
			absorb: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fellstinger: ["1L1"],
			flash: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			perishsong: ["1L1"],
			pounce: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			silverwind: ["1L1"],
			sing: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stickyweb: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	shinx: {
		learnset: {
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			bite: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			firefang: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			icefang: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	luxio: {
		learnset: {
			attract: ["1L1"],
			bite: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			firefang: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icefang: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	luxray: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			firefang: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	cranidos: {
		learnset: {
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragoncheer: ["1L1"],
			dragonpulse: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			whirlwind: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	rampardos: {
		learnset: {
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	shieldon: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			fissure: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			guardsplit: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			magnetrise: ["1L1"],
			metalburst: ["1L1"],
			metalsound: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wideguard: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	bastiodon: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			metalburst: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wideguard: ["1L1"],
		},
	},
	burmy: {
		learnset: {
			bugbite: ["1L1"],
			electroweb: ["1L1"],
			hiddenpower: ["1L1"],
			protect: ["1L1"],
			snore: ["1L1"],
			stringshot: ["1L1"],
			tackle: ["1L1"],
		},
	},
	wormadam: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growth: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			leafstorm: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			quiverdance: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	wormadamsandy: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			quiverdance: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
		},
	},
	wormadamtrash: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			magnetrise: ["1L1"],
			metalburst: ["1L1"],
			metalsound: ["1L1"],
			mirrorshot: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			quiverdance: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
		},
	},
	mothim: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			camouflage: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			lunge: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			poisonpowder: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			quiverdance: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
		},
	},
	combee: {
		learnset: {
			aircutter: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			dualwingbeat: ["1L1"],
			endeavor: ["1L1"],
			gust: ["1L1"],
			lunge: ["1L1"],
			mudslap: ["1L1"],
			ominouswind: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			terablast: ["1L1"],
		},
	},
	vespiquen: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			assurance: ["1L1"],
			attackorder: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crosspoison: ["1L1"],
			cut: ["1L1"],
			defendorder: ["1L1"],
			defog: ["1L1"],
			destinybond: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fellstinger: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			healorder: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			laserfocus: ["1L1"],
			lunge: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			pinmissile: ["1L1"],
			poisonsting: ["1L1"],
			pollenpuff: ["1L1"],
			pounce: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychicnoise: ["1L1"],
			pursuit: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	pachirisu: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			bestow: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hyperfang: ["1L1"],
			iondeluge: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nuzzle: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, nature: "Impish", ivs: {hp: 31, atk: 31, def: 31, spa: 14, spd: 31, spe: 31}, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	buizel: {
		learnset: {
			agility: ["1L1"],
			aquajet: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bulkup: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doublehit: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			mefirst: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			odorsleuth: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			sonicboom: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tackle: ["1L1"],
			tailslap: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			wavecrash: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	floatzel: {
		learnset: {
			agility: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bulkup: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metronome: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			sonicboom: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			wavecrash: ["1L1"],
			whirlpool: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 22},
			{generation: 5, level: 10},
		],
	},
	cherubi: {
		learnset: {
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flowershield: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			leafage: ["1L1"],
			leechseed: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			morningsun: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	cherrim: {
		learnset: {
			attract: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flowershield: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			laserfocus: ["1L1"],
			leafage: ["1L1"],
			leechseed: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			morningsun: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			playrough: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	shellos: {
		learnset: {
			acidarmor: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			liquidation: ["1L1"],
			memento: ["1L1"],
			mirrorcoat: ["1L1"],
			mist: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			stoneedge: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trumpcard: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			yawn: ["1L1"],
		},
	},
	gastrodon: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			liquidation: ["1L1"],
			memento: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, gender: "F", nature: "Modest", abilities: ["1L1"], ivs: {hp: 31, atk: 0, def: 31, spa: 31, spd: 31, spe: 31}, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 4, level: 20},
		],
	},
	gastrodoneast: {
		learnset: {
			earthpower: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			protect: ["1L1"],
			surf: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 50, gender: "F", nature: "Quiet", abilities: ["1L1"], ivs: {hp: 31, atk: 2, def: 31, spa: 31, spd: 31, spe: 0}, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 50, gender: "F", nature: "Sassy", abilities: ["1L1"], ivs: {hp: 31, atk: 0, def: 31, spa: 31, spd: 31, spe: 0}, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 9, level: 50, gender: "M", nature: "Bold", abilities: ["1L1"], ivs: {hp: 31, atk: 0, def: 31, spa: 31, spd: 31, spe: 8}, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 9, level: 50, gender: "F", nature: "Calm", abilities: ["1L1"], ivs: {hp: 31, atk: 0, def: 31, spa: 31, spd: 31, spe: 8}, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 4, level: 20},
		],
	},
	drifloon: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gust: ["1L1"],
			gyroball: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			magiccoat: ["1L1"],
			memento: ["1L1"],
			minimize: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			telekinesis: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	drifblim: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			destinybond: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			gyroball: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			magiccoat: ["1L1"],
			minimize: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			storedpower: ["1L1"],
			strengthsap: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			telekinesis: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
		},
		encounters: [
			{generation: 7, level: 11, pokeball: "pokeball"},
		],
	},
	buneary: {
		learnset: {
			afteryou: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bounce: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			circlethrow: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			cosmicpower: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			dizzypunch: ["1L1"],
			doublehit: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			jumpkick: ["1L1"],
			lastresort: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skyuppercut: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			teeterdance: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
		},
	},
	lopunny: {
		learnset: {
			acrobatics: ["1L1"],
			afteryou: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brutalswing: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			cosmicpower: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			dizzypunch: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			firepunch: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			jumpkick: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mirrorcoat: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			splash: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
		},
	},
	glameow: {
		learnset: {
			aerialace: ["1L1"],
			assist: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			wakeupslap: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
		},
	},
	purugly: {
		learnset: {
			aerialace: ["1L1"],
			assist: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 32, maxEggMoves: 1},
		],
	},
	stunky: {
		learnset: {
			acidspray: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			corrosivegas: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			fireblast: ["1L1"],
			flameburst: ["1L1"],
			flamethrower: ["1L1"],
			focusenergy: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			memento: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			punishment: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailslap: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
		},
	},
	skuntank: {
		learnset: {
			acidspray: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			corrosivegas: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			focusenergy: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			memento: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smokescreen: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailslap: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 29},
		],
	},
	bronzor: {
		learnset: {
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			healblock: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			icespinner: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lightscreen: ["1L1"],
			metalsound: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			powergem: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			speedswap: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	bronzong: {
		learnset: {
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			explosion: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			hardpress: ["1L1"],
			healblock: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icespinner: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lightscreen: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			payback: ["1L1"],
			powergem: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			speedswap: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			weatherball: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 50, nature: "Relaxed", ivs: {hp: 31, atk: 31, def: 31, spa: 22, spd: 31, spe: 0}, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 9, level: 50, nature: "Modest", moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 6, level: 30},
		],
	},
	chatot: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			attract: ["1L1"],
			boomburst: ["1L1"],
			captivate: ["1L1"],
			chatter: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			mimic: ["1L1"],
			mirrormove: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sing: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 25, gender: "M", nature: "Jolly", abilities: ["1L1"], moves: ["1L1"]},
		],
	},
	spiritomb: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grudge: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			lashout: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			pursuit: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 61, gender: "F", nature: "Quiet", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	gible: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			flamethrower: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			metalclaw: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
		},
	},
	gabite: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			dualchop: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			flamethrower: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			metalclaw: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
		},
	},
	garchomp: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			dualchop: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			liquidation: ["1L1"],
			metalclaw: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			poisonjab: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 100, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 48, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 48, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 66, gender: "F", perfectIVs: 3, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	riolu: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			bite: ["1L1"],
			blazekick: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletpunch: ["1L1"],
			captivate: ["1L1"],
			circlethrow: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			crosschop: ["1L1"],
			crunch: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			finalgambit: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			forcepalm: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			howl: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			meteormash: ["1L1"],
			mindreader: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			skyuppercut: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 30, gender: "M", nature: "Serious", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	lucario: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			blazekick: ["1L1"],
			bodyslam: ["1L1"],
			bonerush: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletpunch: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			finalgambit: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lifedew: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magnetrise: ["1L1"],
			mefirst: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			meteormash: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, gender: "M", nature: "Modest", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 30, gender: "M", nature: "Adamant", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 50, gender: "M", nature: "Naughty", ivs: {atk: 31}, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, nature: "Jolly", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 40, gender: "M", nature: "Serious", abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 8, level: 80, gender: "M", nature: "Serious", abilities: ["1L1"], ivs: {hp: 31, atk: 30, def: 30, spa: 31, spd: 30, spe: 31}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 9, level: 75, shiny: true, gender: "M", nature: "Naive", abilities: ["1L1"], ivs: {hp: 31, atk: 31, def: 20, spa: 31, spd: 20, spe: 31}, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	hippopotas: {
		learnset: {
			amnesia: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			fissure: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			icefang: ["1L1"],
			irontail: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlwind: ["1L1"],
			yawn: ["1L1"],
		},
	},
	hippowdon: {
		learnset: {
			amnesia: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			fissure: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			yawn: ["1L1"],
		},
	},
	skorupi: {
		learnset: {
			acupressure: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crosspoison: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			fellstinger: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			infestation: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonfang: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			twineedle: ["1L1"],
			venoshock: ["1L1"],
			whirlwind: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	drapion: {
		learnset: {
			acupressure: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crosspoison: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fellstinger: ["1L1"],
			firefang: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonfang: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 22, pokeball: "safariball"},
			{generation: 6, level: 30},
		],
	},
	croagunk: {
		learnset: {
			acidspray: ["1L1"],
			acupressure: ["1L1"],
			aerialace: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			belch: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletpunch: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crosschop: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			feint: ["1L1"],
			feintattack: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			meditate: ["1L1"],
			mefirst: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smellingsalts: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			wakeupslap: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
		],
	},
	toxicroak: {
		learnset: {
			acidspray: ["1L1"],
			aerialace: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			belch: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			corrosivegas: ["1L1"],
			crosspoison: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudbomb: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 22, pokeball: "safariball"},
			{generation: 6, level: 30},
		],
	},
	carnivine: {
		learnset: {
			acidspray: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			bugbite: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			growth: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			ingrain: ["1L1"],
			knockoff: ["1L1"],
			leaftornado: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			ragepowder: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			vinewhip: ["1L1"],
			worryseed: ["1L1"],
			wringout: ["1L1"],
		},
	},
	finneon: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			alluringvoice: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gust: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			ominouswind: ["1L1"],
			payback: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	lumineon: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			alluringvoice: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			payback: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 20},
		],
	},
	snover: {
		learnset: {
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			growth: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			ingrain: ["1L1"],
			irontail: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megapunch: ["1L1"],
			mist: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			sheercold: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			solarbeam: ["1L1"],
			stomp: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			woodhammer: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	abomasnow: {
		learnset: {
			attract: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			hail: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			ingrain: ["1L1"],
			irontail: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			magicalleaf: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mist: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			sheercold: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			woodhammer: ["1L1"],
			worryseed: ["1L1"],
		},
		encounters: [
			{generation: 4, level: 38},
		],
	},
	rotom: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			disarmingvoice: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			lightscreen: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, nature: "Naughty", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, nature: "Quirky", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 10, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	rotomheat: {
		learnset: {
			overheat: ["1L1"],
		},
	},
	rotomwash: {
		learnset: {
			hydropump: ["1L1"],
		},
	},
	rotomfrost: {
		learnset: {
			blizzard: ["1L1"],
		},
	},
	rotomfan: {
		learnset: {
			airslash: ["1L1"],
		},
	},
	rotommow: {
		learnset: {
			leafstorm: ["1L1"],
		},
	},
	uxie: {
		learnset: {
			acrobatics: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			memento: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			mysticalpower: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			wonderroom: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 65, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	mesprit: {
		learnset: {
			acrobatics: ["1L1"],
			allyswitch: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			copycat: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			healingwish: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			mysticalpower: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			painsplit: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	azelf: {
		learnset: {
			acrobatics: ["1L1"],
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			explosion: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			mysticalpower: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	dialga: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			aurasphere: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			headbutt: ["1L1"],
			healblock: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			magnetrise: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			roaroftime: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			twister: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 47, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 1, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 5, isHidden: true, moves: ["1L1"], pokeball: "dreamball"},
			{generation: 5, level: 100, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 100, nature: "Modest", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, nature: "Bold", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 9, level: 75, nature: "Quiet", isHidden: true, perfectIVs: 4, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	dialgaorigin: {
		eventOnly: false,
	},
	palkia: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			aurasphere: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healblock: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			liquidation: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			outrage: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spacialrend: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 47, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 1, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 5, isHidden: true, moves: ["1L1"], pokeball: "dreamball"},
			{generation: 5, level: 100, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 100, nature: "Timid", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, nature: "Hasty", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 9, level: 75, nature: "Modest", isHidden: true, perfectIVs: 4, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	palkiaorigin: {
		eventOnly: false,
	},
	heatran: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			eruption: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			lunge: ["1L1"],
			magmastorm: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			pounce: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 50, gender: "M", nature: "Quiet", moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 68, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	regigigas: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			avalanche: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crushgrip: ["1L1"],
			darkestlariat: ["1L1"],
			dizzypunch: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			hammerarm: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			wideguard: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 1, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 68, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 100, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	giratina: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			aurasphere: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			destinybond: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			headbutt: ["1L1"],
			healblock: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			magiccoat: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			outrage: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowforce: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 47, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 1, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 5, isHidden: true, moves: ["1L1"], pokeball: "dreamball"},
			{generation: 5, level: 100, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 100, nature: "Brave", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	giratinaorigin: {
		eventOnly: false,
	},
	cresselia: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			lightscreen: ["1L1"],
			lunarblessing: ["1L1"],
			lunardance: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mist: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			powergem: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 68, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 68, nature: "Modest", moves: ["1L1"]},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	phione: {
		learnset: {
			acidarmor: ["1L1"],
			alluringvoice: ["1L1"],
			ancientpower: ["1L1"],
			aquaring: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			liquidation: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takeheart: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	manaphy: {
		learnset: {
			acidarmor: ["1L1"],
			alluringvoice: ["1L1"],
			ancientpower: ["1L1"],
			aquaring: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			healbell: ["1L1"],
			heartswap: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailglow: ["1L1"],
			takeheart: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 5, moves: ["1L1"]},
			{generation: 4, level: 1, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, nature: "Impish", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 1, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 15, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	darkrai: {
		learnset: {
			aerialace: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			darkvoid: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lastresort: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roaroftime: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spacialrend: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 4, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 9, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	shaymin: {
		learnset: {
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aromatherapy: ["1L1"],
			batonpass: ["1L1"],
			bulletseed: ["1L1"],
			celebrate: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			healingwish: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			ominouswind: ["1L1"],
			petalblizzard: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			seedflare: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 4, level: 30, shiny: 1, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 15, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 20, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	shayminsky: {
		eventOnly: false,
	},
	arceus: {
		learnset: {
			acidspray: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			airslash: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			aurasphere: ["1L1"],
			avalanche: ["1L1"],
			blastburn: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bugbuzz: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			cosmicpower: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dreameater: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			electricterrain: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healingwish: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			judgment: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			meteorbeam: ["1L1"],
			mistyterrain: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			perishsong: ["1L1"],
			phantomforce: ["1L1"],
			poisonjab: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			punishment: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			roaroftime: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowforce: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spacialrend: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 4, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 100, moves: ["1L1"]},
			{generation: 6, level: 100, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	arceusbug: {
		eventOnly: false,
	},
	arceusdark: {
		eventOnly: false,
	},
	arceusdragon: {
		eventOnly: false,
	},
	arceuselectric: {
		eventOnly: false,
	},
	arceusfairy: {
		eventOnly: false,
	},
	arceusfighting: {
		eventOnly: false,
	},
	arceusfire: {
		eventOnly: false,
	},
	arceusflying: {
		eventOnly: false,
	},
	arceusghost: {
		eventOnly: false,
	},
	arceusgrass: {
		eventOnly: false,
	},
	arceusground: {
		eventOnly: false,
	},
	arceusice: {
		eventOnly: false,
	},
	arceuspoison: {
		eventOnly: false,
	},
	arceuspsychic: {
		eventOnly: false,
	},
	arceusrock: {
		eventOnly: false,
	},
	arceussteel: {
		eventOnly: false,
	},
	arceuswater: {
		eventOnly: false,
	},
	victini: {
		learnset: {
			batonpass: ["1L1"],
			blazekick: ["1L1"],
			blueflare: ["1L1"],
			boltstrike: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			celebrate: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			fusionbolt: ["1L1"],
			fusionflare: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			glaciate: ["1L1"],
			grassknot: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mysticalfire: ["1L1"],
			overheat: ["1L1"],
			powerswap: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scorchingsands: ["1L1"],
			searingshot: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			speedswap: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			vcreate: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, moves: ["1L1"]},
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 15, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 15, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 15, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 50, nature: "Brave", perfectIVs: 6, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	snivy: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			glare: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leaftornado: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			meanlook: ["1L1"],
			megadrain: ["1L1"],
			mirrorcoat: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			twister: ["1L1"],
			vinewhip: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 5, gender: "M", nature: "Hardy", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	servine: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leaftornado: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			vinewhip: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
		},
	},
	serperior: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frenzyplant: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			holdback: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leaftornado: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			petalblizzard: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			vinewhip: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 100, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	tepig: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			burnup: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gyroball: ["1L1"],
			headsmash: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			magnitude: ["1L1"],
			mudslap: ["1L1"],
			odorsleuth: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smog: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	pignite: {
		learnset: {
			armthrust: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gyroball: ["1L1"],
			headsmash: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			mudslap: ["1L1"],
			odorsleuth: ["1L1"],
			overheat: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smog: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	emboar: {
		learnset: {
			armthrust: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			blastburn: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			hardpress: ["1L1"],
			headsmash: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			holdback: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			mudslap: ["1L1"],
			odorsleuth: ["1L1"],
			overheat: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smog: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 100, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	oshawott: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			aquacutter: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			grassknot: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			nightslash: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sacredsword: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trumpcard: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	dewott: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			grassknot: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			vacuumwave: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	samurott: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			dragontail: ["1L1"],
			drillrun: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			holdback: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			megahorn: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 100, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	samurotthisui: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			ceaselessedge: ["1L1"],
			chillingwater: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			drillrun: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			liquidation: ["1L1"],
			megahorn: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			scaryface: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snarl: ["1L1"],
			snowscape: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	patrat: {
		learnset: {
			afteryou: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperfang: ["1L1"],
			hypnosis: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			meanlook: ["1L1"],
			nastyplot: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tearfullook: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	watchog: {
		learnset: {
			afteryou: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hyperfang: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			meanlook: ["1L1"],
			nastyplot: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	lillipup: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			bite: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			mudslap: ["1L1"],
			odorsleuth: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
	},
	herdier: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			bite: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			odorsleuth: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 20, isHidden: true},
		],
	},
	stoutland: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			bite: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			ironhead: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			odorsleuth: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 23},
		],
	},
	purrloin: {
		learnset: {
			aerialace: ["1L1"],
			assist: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			nastyplot: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			uturn: ["1L1"],
			yawn: ["1L1"],
		},
	},
	liepard: {
		learnset: {
			aerialace: ["1L1"],
			assist: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			burningjealousy: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			nastyplot: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			uturn: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 20, gender: "F", nature: "Jolly", isHidden: true, moves: ["1L1"]},
		],
	},
	pansage: {
		learnset: {
			acrobatics: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grasswhistle: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			playnice: ["1L1"],
			protect: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikyshield: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			vinewhip: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 1, shiny: 1, gender: "M", nature: "Brave", ivs: {spa: 31}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 30, gender: "M", nature: "Serious", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	simisage: {
		learnset: {
			acrobatics: ["1L1"],
			attract: ["1L1"],
			brickbreak: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	pansear: {
		learnset: {
			acrobatics: ["1L1"],
			amnesia: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bite: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gastroacid: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			playnice: ["1L1"],
			protect: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
		],
	},
	simisear: {
		learnset: {
			acrobatics: ["1L1"],
			attract: ["1L1"],
			brickbreak: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gastroacid: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 5, perfectIVs: 2, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	panpour: {
		learnset: {
			acrobatics: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gastroacid: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			mudsport: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			playnice: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 10, gender: "M", isHidden: true, moves: ["1L1"]},
		],
	},
	simipour: {
		learnset: {
			acrobatics: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gastroacid: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
		},
	},
	munna: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			sonicboom: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			telekinesis: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			worryseed: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 39, nature: "Mild", isHidden: true, moves: ["1L1"], pokeball: "dreamball"},
		],
	},
	musharna: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			mistyexplosion: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			painsplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			telekinesis: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			worryseed: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, isHidden: true, moves: ["1L1"]},
		],
	},
	pidove: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bestow: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			gust: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			leer: ["1L1"],
			luckychant: ["1L1"],
			morningsun: ["1L1"],
			nightslash: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 1, shiny: 1, gender: "F", nature: "Hardy", ivs: {atk: 31}, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	tranquill: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			gust: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			leer: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
		},
	},
	unfezant: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			gust: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			leer: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 22},
		],
	},
	blitzle: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			flamecharge: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			magnetrise: ["1L1"],
			mefirst: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			stomp: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	zebstrika: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flamecharge: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			iondeluge: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			magnetrise: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			stomp: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	roggenrola: {
		learnset: {
			attract: ["1L1"],
			autotomize: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gravity: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			irondefense: ["1L1"],
			lockon: ["1L1"],
			magnitude: ["1L1"],
			meteorbeam: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			toxic: ["1L1"],
			wideguard: ["1L1"],
		},
	},
	boldore: {
		learnset: {
			attract: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gravity: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			irondefense: ["1L1"],
			meteorbeam: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			toxic: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 24},
		],
	},
	gigalith: {
		learnset: {
			attract: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			meteorbeam: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	woobat: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			flatter: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gust: ["1L1"],
			gyroball: ["1L1"],
			heartstamp: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			nastyplot: ["1L1"],
			odorsleuth: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychocut: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			simplebeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venomdrench: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	swoobat: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			gyroball: ["1L1"],
			heartstamp: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			nastyplot: ["1L1"],
			odorsleuth: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicfangs: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			simplebeam: ["1L1"],
			skillswap: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venomdrench: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	drilbur: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			irondefense: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	excadrill: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			crushclaw: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			horndrill: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			magnetrise: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	audino: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			bestow: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mistyterrain: ["1L1"],
			painsplit: ["1L1"],
			playnice: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			signalbeam: ["1L1"],
			simplebeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 30, gender: "F", nature: "Calm", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 30, gender: "F", nature: "Serious", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 30, gender: "F", nature: "Jolly", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, nature: "Relaxed", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	timburr: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			chipaway: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			cometpunch: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			hammerarm: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			machpunch: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smellingsalts: ["1L1"],
			snore: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			wakeupslap: ["1L1"],
			wideguard: ["1L1"],
			workup: ["1L1"],
		},
	},
	gurdurr: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			chipaway: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			hammerarm: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			icepunch: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			machpunch: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			wakeupslap: ["1L1"],
			workup: ["1L1"],
		},
	},
	conkeldurr: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			chipaway: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hammerarm: ["1L1"],
			hardpress: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			wakeupslap: ["1L1"],
			workup: ["1L1"],
		},
	},
	tympole: {
		learnset: {
			acid: ["1L1"],
			afteryou: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			confide: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hypervoice: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			mist: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			venomdrench: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	palpitoad: {
		learnset: {
			acid: ["1L1"],
			afteryou: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hypervoice: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			venomdrench: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	seismitoad: {
		learnset: {
			acid: ["1L1"],
			afteryou: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 15},
		],
	},
	throh: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			circlethrow: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			matblock: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			stormthrow: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			vitalthrow: ["1L1"],
			wideguard: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	sawk: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			dig: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			karatechop: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	sewaddle: {
		learnset: {
			agility: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			camouflage: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			hiddenpower: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			mefirst: ["1L1"],
			mindreader: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stickyweb: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			switcheroo: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	swadloon: {
		learnset: {
			attract: ["1L1"],
			batonpass: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			hiddenpower: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stickyweb: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			worryseed: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 19},
		],
	},
	leavanny: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fellstinger: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			pollenpuff: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 20, isHidden: true},
		],
	},
	venipede: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bugbite: ["1L1"],
			confide: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gyroball: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			steamroller: ["1L1"],
			steelroller: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			twineedle: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
		},
	},
	whirlipede: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			confide: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gyroball: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			steamroller: ["1L1"],
			steelroller: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
		},
	},
	scolipede: {
		learnset: {
			agility: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bugbite: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			crosspoison: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			megahorn: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smartstrike: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			steamroller: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	cottonee: {
		learnset: {
			absorb: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			cottonguard: ["1L1"],
			cottonspore: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			knockoff: ["1L1"],
			leechseed: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			mistyterrain: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			poisonpowder: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	whimsicott: {
		learnset: {
			absorb: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			cottonguard: ["1L1"],
			cottonspore: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			gust: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			knockoff: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			naturepower: ["1L1"],
			playrough: ["1L1"],
			poisonpowder: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			uturn: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, gender: "F", nature: "Timid", ivs: {spe: 31}, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	petilil: {
		learnset: {
			absorb: ["1L1"],
			afteryou: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			growth: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			ingrain: ["1L1"],
			laserfocus: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			synthesis: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	lilligant: {
		learnset: {
			absorb: ["1L1"],
			afteryou: ["1L1"],
			alluringvoice: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			laserfocus: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quiverdance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	lilliganthisui: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			airslash: ["1L1"],
			axekick: ["1L1"],
			brickbreak: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			defog: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			icespinner: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			megakick: ["1L1"],
			metronome: ["1L1"],
			petalblizzard: ["1L1"],
			poisonjab: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			seedbomb: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			victorydance: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	basculin: {
		learnset: {
			agility: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			flail: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	basculinwhitestriped: {
		learnset: {
			agility: ["1L1"],
			aquajet: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			chillingwater: ["1L1"],
			crunch: ["1L1"],
			doubleedge: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flipturn: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			lastrespects: ["1L1"],
			liquidation: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	basculegion: {
		learnset: {
			agility: ["1L1"],
			aquajet: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			chillingwater: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			doubleedge: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flipturn: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			hex: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			lastrespects: ["1L1"],
			liquidation: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			nightshade: ["1L1"],
			outrage: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	basculegionf: {
		learnset: {
			agility: ["1L1"],
			aquajet: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			chillingwater: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			doubleedge: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flipturn: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			hex: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			lastrespects: ["1L1"],
			liquidation: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			nightshade: ["1L1"],
			outrage: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	sandile: {
		learnset: {
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			meanlook: ["1L1"],
			mefirst: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			payback: ["1L1"],
			powertrip: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
		},
	},
	krokorok: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			payback: ["1L1"],
			powertrip: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
		},
	},
	krookodile: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkestlariat: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			meanlook: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			powertrip: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
		},
	},
	darumaka: {
		learnset: {
			attract: ["1L1"],
			bellydrum: ["1L1"],
			bite: ["1L1"],
			brickbreak: ["1L1"],
			confide: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			incinerate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			overheat: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	darumakagalar: {
		learnset: {
			attract: ["1L1"],
			avalanche: ["1L1"],
			bellydrum: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			dig: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			freezedry: ["1L1"],
			grassknot: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			incinerate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			overheat: ["1L1"],
			powdersnow: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	darmanitan: {
		learnset: {
			attract: ["1L1"],
			bellydrum: ["1L1"],
			bite: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			confide: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mysticalfire: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			powerswap: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			rage: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 35, isHidden: true, moves: ["1L1"]},
			{generation: 6, level: 35, gender: "M", nature: "Calm", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 6, level: 32, maxEggMoves: 1},
		],
	},
	darmanitangalar: {
		learnset: {
			attract: ["1L1"],
			avalanche: ["1L1"],
			bellydrum: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			dig: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			iciclecrash: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lashout: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	maractus: {
		learnset: {
			absorb: ["1L1"],
			acupressure: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			cottonguard: ["1L1"],
			cottonspore: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			ingrain: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			megadrain: ["1L1"],
			naturepower: ["1L1"],
			needlearm: ["1L1"],
			peck: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			spikyshield: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			synthesis: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			weatherball: ["1L1"],
			woodhammer: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	dwebble: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bugbite: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rockwrecker: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shellsmash: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			toxic: ["1L1"],
			wideguard: ["1L1"],
			withdraw: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	crustle: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bugbite: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			meteorbeam: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rockwrecker: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shellsmash: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			toxic: ["1L1"],
			withdraw: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 33, maxEggMoves: 1},
		],
	},
	scraggy: {
		learnset: {
			acidspray: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			chipaway: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			icepunch: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 1, gender: "M", nature: "Adamant", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	scrafty: {
		learnset: {
			acidspray: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			chipaway: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, gender: "M", nature: "Brave", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	sigilyph: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			gust: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			miracleeye: ["1L1"],
			mirrormove: ["1L1"],
			pluck: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychocut: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			speedswap: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			tailwind: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			whirlwind: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	yamask: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			craftyshield: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			grudge: ["1L1"],
			guardsplit: ["1L1"],
			haze: ["1L1"],
			healblock: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			magiccoat: ["1L1"],
			meanlook: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poltergeist: ["1L1"],
			powersplit: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	yamaskgalar: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			brutalswing: ["1L1"],
			calmmind: ["1L1"],
			craftyshield: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			guardsplit: ["1L1"],
			haze: ["1L1"],
			hex: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			meanlook: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			payback: ["1L1"],
			poltergeist: ["1L1"],
			powersplit: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			thief: ["1L1"],
			toxicspikes: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	cofagrigus: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			craftyshield: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grudge: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			haze: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			magiccoat: ["1L1"],
			meanlook: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			powersplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 66, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 6, level: 32, maxEggMoves: 1},
		],
	},
	runerigus: {
		learnset: {
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			craftyshield: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			dragonpulse: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			haze: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			meanlook: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			powersplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			revenge: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			skillswap: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			toxicspikes: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	tirtouga: {
		learnset: {
			ancientpower: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			guardswap: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			meteorbeam: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shellsmash: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wideguard: ["1L1"],
			withdraw: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	carracosta: {
		learnset: {
			ancientpower: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			guardswap: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			meteorbeam: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shellsmash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wideguard: ["1L1"],
			withdraw: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	archen: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			headsmash: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			meteorbeam: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			thrash: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wingattack: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	archeops: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			airslash: ["1L1"],
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			meteorbeam: ["1L1"],
			outrage: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			thrash: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wingattack: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	trubbish: {
		learnset: {
			acidspray: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			belch: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			corrosivegas: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			mudsport: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisongas: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			stockpile: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
		},
	},
	garbodor: {
		learnset: {
			acidspray: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			corrosivegas: ["1L1"],
			crosspoison: ["1L1"],
			darkpulse: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			metalclaw: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisongas: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			stockpile: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 31},
			{generation: 6, level: 30},
			{generation: 7, level: 24},
		],
	},
	zorua: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			nightdaze: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
		},
	},
	zoruahisui: {
		learnset: {
			agility: ["1L1"],
			bittermalice: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			comeuppance: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			hex: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			scratch: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snarl: ["1L1"],
			snowscape: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			trick: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	zoroark: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nastyplot: ["1L1"],
			nightdaze: ["1L1"],
			nightshade: ["1L1"],
			nightslash: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, gender: "M", nature: "Quirky", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, moves: ["1L1"], pokeball: "ultraball"},
			{generation: 6, level: 45, gender: "M", nature: "Naughty", moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 5, level: 25},
		],
	},
	zoroarkhisui: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			bittermalice: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			happyhour: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snarl: ["1L1"],
			snowscape: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			trick: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 50, perfectIVs: 3, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	minccino: {
		learnset: {
			afteryou: ["1L1"],
			alluringvoice: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			mudslap: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shockwave: ["1L1"],
			sing: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailslap: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			tidyup: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wakeupslap: ["1L1"],
			workup: ["1L1"],
		},
	},
	cinccino: {
		learnset: {
			afteryou: ["1L1"],
			alluringvoice: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icespinner: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			mudslap: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shockwave: ["1L1"],
			sing: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailslap: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
		},
	},
	gothita: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			covet: ["1L1"],
			darkpulse: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			healbell: ["1L1"],
			healblock: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meanlook: ["1L1"],
			miracleeye: ["1L1"],
			mirrorcoat: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			playnice: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	gothorita: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			covet: ["1L1"],
			darkpulse: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			healbell: ["1L1"],
			healblock: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mirrorcoat: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			playnice: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 32, gender: "M", isHidden: true, moves: ["1L1"]},
			{generation: 5, level: 32, gender: "M", isHidden: true, moves: ["1L1"]},
		],
		encounters: [
			{generation: 5, level: 31},
		],
	},
	gothitelle: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			covet: ["1L1"],
			darkpulse: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			healbell: ["1L1"],
			healblock: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			playnice: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 34},
		],
	},
	solosis: {
		learnset: {
			acidarmor: ["1L1"],
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			healblock: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			steelroller: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	duosion: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			healblock: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			steelroller: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 31},
		],
	},
	reuniclus: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			dizzypunch: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			healblock: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			megapunch: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			powerswap: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			steelroller: ["1L1"],
			storedpower: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 34},
		],
	},
	ducklett: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aquajet: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gust: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			luckychant: ["1L1"],
			mefirst: ["1L1"],
			mirrormove: ["1L1"],
			mudsport: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			wingattack: ["1L1"],
		},
	},
	swanna: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			alluringvoice: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			bubblebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			flipturn: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wingattack: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	vanillite: {
		learnset: {
			acidarmor: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			auroraveil: ["1L1"],
			autotomize: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			confide: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			iceshard: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			mirrorcoat: ["1L1"],
			mirrorshot: ["1L1"],
			mist: ["1L1"],
			naturalgift: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	vanillish: {
		learnset: {
			acidarmor: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			confide: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			iceshard: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			mirrorcoat: ["1L1"],
			mirrorshot: ["1L1"],
			mist: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	vanilluxe: {
		learnset: {
			acidarmor: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			beatup: ["1L1"],
			blizzard: ["1L1"],
			confide: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			freezedry: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			mirrorcoat: ["1L1"],
			mirrorshot: ["1L1"],
			mist: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	deerling: {
		learnset: {
			agility: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			camouflage: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			jumpkick: ["1L1"],
			lastresort: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			odorsleuth: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 30, gender: "F", isHidden: true, moves: ["1L1"]},
		],
	},
	sawsbuck: {
		learnset: {
			agility: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			camouflage: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hornleech: ["1L1"],
			hyperbeam: ["1L1"],
			jumpkick: ["1L1"],
			lastresort: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megahorn: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	emolga: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			airslash: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			eerieimpulse: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			iondeluge: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			nuzzle: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spark: ["1L1"],
			speedswap: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	karrablast: {
		learnset: {
			acidspray: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hornattack: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			megahorn: ["1L1"],
			nightslash: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			toxic: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 30, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	escavalier: {
		learnset: {
			acidspray: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fellstinger: ["1L1"],
			flail: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			megahorn: ["1L1"],
			metalburst: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			toxic: ["1L1"],
			twineedle: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	foongus: {
		learnset: {
			absorb: ["1L1"],
			afteryou: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			defensecurl: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			hiddenpower: ["1L1"],
			ingrain: ["1L1"],
			leafstorm: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			ragepowder: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spore: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			synthesis: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			venoshock: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	amoonguss: {
		learnset: {
			absorb: ["1L1"],
			afteryou: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ingrain: ["1L1"],
			leafstorm: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			ragepowder: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spore: ["1L1"],
			stompingtantrum: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			synthesis: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			venoshock: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 50, shiny: true, gender: "F", nature: "Sassy", ivs: {hp: 31, atk: 0, def: 31, spa: 31, spd: 31, spe: 0}, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 5, level: 37},
			{generation: 5, level: 35, isHidden: true},
		],
	},
	frillish: {
		learnset: {
			absorb: ["1L1"],
			acidarmor: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			constrict: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			destinybond: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			hail: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			magiccoat: ["1L1"],
			mist: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			poisonsting: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strengthsap: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			waterspout: ["1L1"],
			whirlpool: ["1L1"],
			willowisp: ["1L1"],
			wringout: ["1L1"],
		},
	},
	jellicent: {
		learnset: {
			absorb: ["1L1"],
			acidarmor: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			confide: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			destinybond: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			magiccoat: ["1L1"],
			muddywater: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			poisonsting: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			waterspout: ["1L1"],
			whirlpool: ["1L1"],
			willowisp: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 40, isHidden: true, moves: ["1L1"]},
		],
		encounters: [
			{generation: 5, level: 5},
		],
	},
	alomomola: {
		learnset: {
			acrobatics: ["1L1"],
			alluringvoice: ["1L1"],
			aquajet: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brine: ["1L1"],
			calmmind: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			dive: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			magiccoat: ["1L1"],
			mirrorcoat: ["1L1"],
			mist: ["1L1"],
			mistyterrain: ["1L1"],
			painsplit: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			wakeupslap: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			wideguard: ["1L1"],
			wish: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	joltik: {
		learnset: {
			absorb: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			camouflage: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			crosspoison: ["1L1"],
			cut: ["1L1"],
			disable: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magnetrise: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			rockclimb: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			spiderweb: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	galvantula: {
		learnset: {
			absorb: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			crosspoison: ["1L1"],
			cut: ["1L1"],
			disable: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magnetrise: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			spiderweb: ["1L1"],
			stickyweb: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	ferroseed: {
		learnset: {
			acidspray: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			ingrain: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			leechseed: ["1L1"],
			magnetrise: ["1L1"],
			metalclaw: ["1L1"],
			mirrorshot: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	ferrothorn: {
		learnset: {
			aerialace: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			ingrain: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			magnetrise: ["1L1"],
			metalclaw: ["1L1"],
			mirrorshot: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	klink: {
		learnset: {
			assurance: ["1L1"],
			autotomize: ["1L1"],
			bind: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			geargrind: ["1L1"],
			gravity: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			mirrorshot: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			rockpolish: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shiftgear: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			telekinesis: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			visegrip: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	klang: {
		learnset: {
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			autotomize: ["1L1"],
			bind: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			geargrind: ["1L1"],
			gravity: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			mirrorshot: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			rockpolish: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shiftgear: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			telekinesis: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			visegrip: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	klinklang: {
		learnset: {
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			autotomize: ["1L1"],
			bind: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			electricterrain: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			geargrind: ["1L1"],
			gearup: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magneticflux: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			mirrorshot: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			rockpolish: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shiftgear: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			telekinesis: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			visegrip: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	tynamo: {
		learnset: {
			charge: ["1L1"],
			chargebeam: ["1L1"],
			knockoff: ["1L1"],
			magnetrise: ["1L1"],
			spark: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
		},
	},
	eelektrik: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			acrobatics: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magnetrise: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	eelektross: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			acrobatics: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			closecombat: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			crushclaw: ["1L1"],
			cut: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drainpunch: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			iondeluge: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			lunge: ["1L1"],
			magnetrise: ["1L1"],
			outrage: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	elgyem: {
		learnset: {
			afteryou: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			healblock: ["1L1"],
			hiddenpower: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			meteorbeam: ["1L1"],
			miracleeye: ["1L1"],
			nastyplot: ["1L1"],
			painsplit: ["1L1"],
			powersplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			simplebeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			synchronoise: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	beheeyem: {
		learnset: {
			afteryou: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			healblock: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			meteorbeam: ["1L1"],
			miracleeye: ["1L1"],
			nastyplot: ["1L1"],
			painsplit: ["1L1"],
			powersplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			simplebeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			synchronoise: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	litwick: {
		learnset: {
			acid: ["1L1"],
			acidarmor: ["1L1"],
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			haze: ["1L1"],
			heatwave: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			memento: ["1L1"],
			minimize: ["1L1"],
			mysticalfire: ["1L1"],
			nightshade: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poltergeist: ["1L1"],
			powersplit: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			smog: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	lampent: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			haze: ["1L1"],
			heatwave: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			lashout: ["1L1"],
			memento: ["1L1"],
			minimize: ["1L1"],
			mysticalfire: ["1L1"],
			nightshade: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			smog: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	chandelure: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			haze: ["1L1"],
			heatwave: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			memento: ["1L1"],
			minimize: ["1L1"],
			mysticalfire: ["1L1"],
			nightshade: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			smog: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, gender: "F", nature: "Modest", ivs: {spa: 31}, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	axew: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			dualchop: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			firstimpression: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			guillotine: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			nightslash: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 1, shiny: 1, gender: "M", nature: "Naive", ivs: {spe: 31}, abilities: ["1L1"], moves: ["1L1"], pokeball: "pokeball"},
			{generation: 5, level: 10, gender: "F", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 30, gender: "M", nature: "Naive", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	fraxure: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			dualchop: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			guillotine: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	haxorus: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			guillotine: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 59, gender: "F", nature: "Naive", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	cubchoo: {
		learnset: {
			aerialace: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nightslash: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			powdersnow: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			sheercold: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			waterpulse: ["1L1"],
			xscissor: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	beartic: {
		learnset: {
			aerialace: ["1L1"],
			aquajet: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			hardpress: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			powdersnow: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			sheercold: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			waterpulse: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	cryogonal: {
		learnset: {
			acidarmor: ["1L1"],
			acrobatics: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			freezedry: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			mist: ["1L1"],
			nightslash: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			sharpen: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	shelmet: {
		learnset: {
			absorb: ["1L1"],
			acid: ["1L1"],
			acidarmor: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			finalgambit: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			megadrain: ["1L1"],
			mindreader: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venoshock: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 30, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	accelgor: {
		learnset: {
			absorb: ["1L1"],
			acid: ["1L1"],
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			guardswap: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			mefirst: ["1L1"],
			megadrain: ["1L1"],
			mudshot: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uturn: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			watershuriken: ["1L1"],
			yawn: ["1L1"],
		},
	},
	stunfisk: {
		learnset: {
			aquatail: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			camouflage: ["1L1"],
			charge: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			lashout: ["1L1"],
			magnetrise: ["1L1"],
			mefirst: ["1L1"],
			mudbomb: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflecttype: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			yawn: ["1L1"],
		},
	},
	stunfiskgalar: {
		learnset: {
			astonish: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			flashcannon: ["1L1"],
			foulplay: ["1L1"],
			icefang: ["1L1"],
			irondefense: ["1L1"],
			lashout: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflecttype: ["1L1"],
			rest: ["1L1"],
			revenge: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snaptrap: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			surf: ["1L1"],
			tackle: ["1L1"],
			terrainpulse: ["1L1"],
			thunderwave: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			yawn: ["1L1"],
		},
	},
	mienfoo: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			feint: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			honeclaws: ["1L1"],
			jumpkick: ["1L1"],
			knockoff: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			meditate: ["1L1"],
			mefirst: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smellingsalts: ["1L1"],
			snore: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uturn: ["1L1"],
			vitalthrow: ["1L1"],
			workup: ["1L1"],
		},
	},
	mienshao: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			blazekick: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icespinner: ["1L1"],
			jumpkick: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			meditate: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			upperhand: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			wideguard: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 65, gender: "M", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	druddigon: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			chargebeam: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			crushclaw: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			glare: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			nightslash: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poisontail: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 1, shiny: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	golett: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			magnitude: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudslap: ["1L1"],
			nightshade: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shadowpunch: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
		},
	},
	golurk: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			chargebeam: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkestlariat: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			hardpress: ["1L1"],
			heatcrash: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			magnitude: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudslap: ["1L1"],
			nightshade: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shadowpunch: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 70, shiny: true, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 6, level: 30},
		],
	},
	pawniard: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			brickbreak: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			grassknot: ["1L1"],
			guillotine: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magnetrise: ["1L1"],
			meanlook: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			pursuit: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rockpolish: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	bisharp: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			brickbreak: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			guillotine: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magnetrise: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockpolish: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 7, level: 33},
		],
	},
	kingambit: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			brickbreak: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			guillotine: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			kowtowcleave: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			nightslash: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			reversal: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	bouffalant: {
		learnset: {
			aerialace: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			cottonguard: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			headcharge: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hornattack: ["1L1"],
			ironhead: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			megahorn: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, nature: "Adamant", ivs: {hp: 31, atk: 31}, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	rufflet: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			bulkup: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			crushclaw: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			leer: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			skydrop: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	braviary: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			bulkup: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			crushclaw: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			metalclaw: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 25, gender: "M", isHidden: true, moves: ["1L1"]},
		],
		encounters: [
			{generation: 6, level: 45},
		],
	},
	braviaryhisui: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			bulkup: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			confuseray: ["1L1"],
			crushclaw: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			esperwing: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icywind: ["1L1"],
			leer: ["1L1"],
			metalclaw: ["1L1"],
			nightshade: ["1L1"],
			peck: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			skyattack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	vullaby: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bravebird: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			featherdance: ["1L1"],
			feintattack: ["1L1"],
			flatter: ["1L1"],
			fly: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gust: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			meanlook: ["1L1"],
			mirrormove: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
		},
	},
	mandibuzz: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bonerush: ["1L1"],
			bravebird: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			featherdance: ["1L1"],
			feintattack: ["1L1"],
			flatter: ["1L1"],
			fly: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			mirrormove: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 25, gender: "F", isHidden: true, moves: ["1L1"]},
		],
	},
	heatmor: {
		learnset: {
			aerialace: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			burningjealousy: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fireblast: ["1L1"],
			firelash: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			knockoff: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			nightslash: ["1L1"],
			odorsleuth: ["1L1"],
			overheat: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			willowisp: ["1L1"],
			wrap: ["1L1"],
		},
	},
	durant: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			bugbite: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			firstimpression: ["1L1"],
			flail: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			guillotine: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			visegrip: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	deino: {
		learnset: {
			aquatail: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			incinerate: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 1, shiny: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	zweilous: {
		learnset: {
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			incinerate: ["1L1"],
			lashout: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 5, level: 49},
		],
	},
	hydreigon: {
		learnset: {
			acrobatics: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			steelwing: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 70, shiny: true, gender: "M", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 52, gender: "M", perfectIVs: 2, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 6, level: 59},
		],
	},
	larvesta: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			harden: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			incinerate: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magnetrise: ["1L1"],
			morningsun: ["1L1"],
			overheat: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	volcarona: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			amnesia: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fierydance: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magnetrise: ["1L1"],
			mysticalfire: ["1L1"],
			overheat: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			quiverdance: ["1L1"],
			ragepowder: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 35, moves: ["1L1"]},
			{generation: 5, level: 77, gender: "M", nature: "Calm", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 7, level: 41},
		],
	},
	cobalion: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			aurasphere: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flashcannon: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			magnetrise: ["1L1"],
			megahorn: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockpolish: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sacredsword: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			voltswitch: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 42, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 45, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 65, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	terrakion: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			aurasphere: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			megahorn: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sacredsword: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 42, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 45, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 65, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	virizion: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			aurasphere: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			laserfocus: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megahorn: ["1L1"],
			naturepower: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sacredsword: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 42, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 45, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 65, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	tornadus: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bleakwindstorm: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gust: ["1L1"],
			hammerarm: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			metronome: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			weatherball: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 5, isHidden: true, moves: ["1L1"], pokeball: "dreamball"},
			{generation: 5, level: 70, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	tornadustherian: {
		eventOnly: false,
	},
	thundurus: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hammerarm: ["1L1"],
			healblock: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			risingvoltage: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			weatherball: ["1L1"],
			wildboltstorm: ["1L1"],
			wildcharge: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 40, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 5, isHidden: true, moves: ["1L1"], pokeball: "dreamball"},
			{generation: 5, level: 70, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	thundurustherian: {
		eventOnly: false,
	},
	reshiram: {
		learnset: {
			ancientpower: ["1L1"],
			blueflare: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			fusionflare: ["1L1"],
			gigaimpact: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			mist: ["1L1"],
			mysticalfire: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, moves: ["1L1"]},
			{generation: 5, level: 70, moves: ["1L1"]},
			{generation: 5, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	zekrom: {
		learnset: {
			ancientpower: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			boltstrike: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			fusionbolt: ["1L1"],
			gigaimpact: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, moves: ["1L1"]},
			{generation: 5, level: 70, moves: ["1L1"]},
			{generation: 5, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	landorus: {
		learnset: {
			attract: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			hammerarm: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			punishment: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandsearstorm: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			weatherball: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 5, isHidden: true, moves: ["1L1"], pokeball: "dreamball"},
			{generation: 6, level: 65, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, nature: "Adamant", ivs: {hp: 31, atk: 31, def: 31, spa: 1, spd: 31, spe: 24}, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	landorustherian: {
		eventOnly: false,
	},
	kyurem: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			freezedry: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			glaciate: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 75, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	kyuremblack: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			freezedry: ["1L1"],
			freezeshock: ["1L1"],
			frustration: ["1L1"],
			fusionbolt: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 75, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	kyuremwhite: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			freezedry: ["1L1"],
			frustration: ["1L1"],
			fusionflare: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			iceburn: ["1L1"],
			icefang: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 75, shiny: 1, moves: ["1L1"]},
			{generation: 5, level: 70, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 50, shiny: 1, moves: ["1L1"]},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	keldeo: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flipturn: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			megahorn: ["1L1"],
			muddywater: ["1L1"],
			painsplit: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sacredsword: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			secretsword: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			vacuumwave: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 15, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 65, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	keldeoresolute: {
		eventOnly: false,
	},
	meloetta: {
		learnset: {
			acrobatics: ["1L1"],
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			batonpass: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			celebrate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dualchop: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icepunch: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			payback: ["1L1"],
			perishsong: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			relicsong: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sing: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			teeterdance: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wakeupslap: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 15, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 15, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	genesect: {
		learnset: {
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			blazekick: ["1L1"],
			blizzard: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			fellstinger: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			gunkshot: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lastresort: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magnetbomb: ["1L1"],
			magnetrise: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			quickattack: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowclaw: ["1L1"],
			shiftgear: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			simplebeam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelbeam: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			technoblast: ["1L1"],
			telekinesis: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			uturn: ["1L1"],
			xscissor: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 5, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 15, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 5, level: 100, shiny: true, nature: "Hasty", ivs: {atk: 31, spe: 31}, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 60, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	genesectburn: {
		eventOnly: false,
	},
	genesectchill: {
		eventOnly: false,
	},
	genesectdouse: {
		eventOnly: false,
	},
	genesectshock: {
		eventOnly: false,
	},
	chespin: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			gyroball: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			metalclaw: ["1L1"],
			mudshot: ["1L1"],
			naturepower: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			vinewhip: ["1L1"],
			wideguard: ["1L1"],
			woodhammer: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	quilladin: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			gyroball: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			metalclaw: ["1L1"],
			mudshot: ["1L1"],
			naturepower: ["1L1"],
			needlearm: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			vinewhip: ["1L1"],
			woodhammer: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	chesnaught: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			bite: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frenzyplant: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			metalclaw: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			needlearm: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			spikyshield: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			vinewhip: ["1L1"],
			woodhammer: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	fennekin: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			overheat: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 15, gender: "F", nature: "Hardy", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	braixen: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			overheat: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	delphox: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			blastburn: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			luckychant: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			overheat: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	froakie: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			bestow: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			bubble: ["1L1"],
			camouflage: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			lick: ["1L1"],
			liquidation: ["1L1"],
			mindreader: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smokescreen: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 7, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	frogadier: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			bubble: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			lick: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smokescreen: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
		},
	},
	greninja: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bubble: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			happyhour: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			lick: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			matblock: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nightslash: ["1L1"],
			pound: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shadowsneak: ["1L1"],
			sleeptalk: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			smokescreen: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			watershuriken: ["1L1"],
			weatherball: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 36, ivs: {spe: 31}, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 100, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	greninjabond: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bubble: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			lick: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			matblock: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nightslash: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			shadowsneak: ["1L1"],
			sleeptalk: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			smokescreen: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			watershuriken: ["1L1"],
			weatherball: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 36, ivs: {hp: 20, atk: 31, def: 20, spa: 31, spd: 20, spe: 31}, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	bunnelby: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doublekick: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			hiddenpower: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			odorsleuth: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
		},
	},
	diggersby: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doublekick: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			hammerarm: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			odorsleuth: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smackdown: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
		},
	},
	fletchling: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			flail: ["1L1"],
			flamecharge: ["1L1"],
			flareblitz: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			mefirst: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			peck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
	},
	fletchinder: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			feint: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flail: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			incinerate: ["1L1"],
			mefirst: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			peck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 7, level: 16},
		],
	},
	talonflame: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			bulkup: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			feint: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flail: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			mefirst: ["1L1"],
			naturalgift: ["1L1"],
			overheat: ["1L1"],
			peck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
	},
	scatterbug: {
		learnset: {
			bugbite: ["1L1"],
			poisonpowder: ["1L1"],
			pounce: ["1L1"],
			ragepowder: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
		},
	},
	spewpa: {
		learnset: {
			bugbite: ["1L1"],
			electroweb: ["1L1"],
			harden: ["1L1"],
			irondefense: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			strugglebug: ["1L1"],
			terablast: ["1L1"],
		},
	},
	vivillon: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			pounce: ["1L1"],
			powder: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			quiverdance: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	vivillonfancy: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			hiddenpower: ["1L1"],
			holdhands: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			pounce: ["1L1"],
			powder: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			quiverdance: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 12, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	vivillonpokeball: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			pounce: ["1L1"],
			powder: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			quiverdance: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 12, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	litleo: {
		learnset: {
			acrobatics: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			mudslap: ["1L1"],
			nobleroar: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
	},
	pyroar: {
		learnset: {
			acrobatics: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			mudslap: ["1L1"],
			nobleroar: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 49, gender: "M", perfectIVs: 2, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 6, level: 30},
		],
	},
	flabebe: {
		learnset: {
			afteryou: ["1L1"],
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			camouflage: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			vinewhip: ["1L1"],
			wish: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	floette: {
		learnset: {
			afteryou: ["1L1"],
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			metronome: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			vinewhip: ["1L1"],
			wish: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	floetteeternal: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			lightofruin: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			toxic: ["1L1"],
			vinewhip: ["1L1"],
			wish: ["1L1"],
			worryseed: ["1L1"],
		},
		eventOnly: true,
	},
	florges: {
		learnset: {
			afteryou: ["1L1"],
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flowershield: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			naturepower: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synthesis: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			wish: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	skiddo: {
		learnset: {
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hornleech: ["1L1"],
			irontail: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			milkdrink: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			vinewhip: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	gogoat: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hornleech: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			milkdrink: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			vinewhip: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	pancham: {
		learnset: {
			aerialace: ["1L1"],
			armthrust: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			circlethrow: ["1L1"],
			coaching: ["1L1"],
			cometpunch: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			icepunch: ["1L1"],
			ironhead: ["1L1"],
			karatechop: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			mefirst: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			partingshot: ["1L1"],
			payback: ["1L1"],
			powertrip: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seismictoss: ["1L1"],
			shadowclaw: ["1L1"],
			skyuppercut: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stoneedge: ["1L1"],
			stormthrow: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			vitalthrow: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 30, gender: "M", nature: "Adamant", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	pangoro: {
		learnset: {
			aerialace: ["1L1"],
			armthrust: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletpunch: ["1L1"],
			circlethrow: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			cometpunch: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkestlariat: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			hammerarm: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icepunch: ["1L1"],
			infestation: ["1L1"],
			ironhead: ["1L1"],
			karatechop: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nightslash: ["1L1"],
			outrage: ["1L1"],
			partingshot: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			skyuppercut: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			vitalthrow: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 7, level: 24},
		],
	},
	furfrou: {
		learnset: {
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			bite: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			cottonguard: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			mimic: ["1L1"],
			odorsleuth: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	espurr: {
		learnset: {
			allyswitch: ["1L1"],
			assist: ["1L1"],
			attract: ["1L1"],
			barrier: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gravity: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	meowstic: {
		learnset: {
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meanlook: ["1L1"],
			miracleeye: ["1L1"],
			mistyterrain: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailslap: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	meowsticf: {
		learnset: {
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mefirst: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailslap: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	honedge: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			block: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			destinybond: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gyroball: ["1L1"],
			hiddenpower: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			nightslash: ["1L1"],
			powertrick: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sacredsword: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarblade: ["1L1"],
			spite: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			toxic: ["1L1"],
			wideguard: ["1L1"],
		},
	},
	doublade: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gyroball: ["1L1"],
			hiddenpower: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			nightslash: ["1L1"],
			powertrick: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sacredsword: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarblade: ["1L1"],
			spite: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			toxic: ["1L1"],
		},
	},
	aegislash: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			block: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			headsmash: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			kingsshield: ["1L1"],
			laserfocus: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			nightslash: ["1L1"],
			powertrick: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			sacredsword: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarblade: ["1L1"],
			spite: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			toxic: ["1L1"],
			wideguard: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, gender: "F", nature: "Quiet", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	spritzee: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			disable: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			faketears: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gyroball: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			nastyplot: ["1L1"],
			odorsleuth: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			sweetscent: ["1L1"],
			telekinesis: ["1L1"],
			thunderbolt: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			wish: ["1L1"],
		},
	},
	aromatisse: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			disable: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			faketears: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			healbell: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			nastyplot: ["1L1"],
			odorsleuth: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			sweetscent: ["1L1"],
			telekinesis: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, nature: "Relaxed", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	swirlix: {
		learnset: {
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bellydrum: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			cottonguard: ["1L1"],
			cottonspore: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			faketears: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			mistyexplosion: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stickyweb: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			tackle: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			wish: ["1L1"],
			yawn: ["1L1"],
		},
	},
	slurpuff: {
		learnset: {
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			cottonguard: ["1L1"],
			cottonspore: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			faketears: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigaimpact: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stickyweb: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			tackle: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			wish: ["1L1"],
		},
	},
	inkay: {
		learnset: {
			acupressure: ["1L1"],
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bind: ["1L1"],
			calmmind: ["1L1"],
			camouflage: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			happyhour: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			lunge: ["1L1"],
			nastyplot: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			powersplit: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			simplebeam: ["1L1"],
			skillswap: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			topsyturvy: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wrap: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	malamar: {
		learnset: {
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bind: ["1L1"],
			block: ["1L1"],
			brutalswing: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			lunge: ["1L1"],
			nastyplot: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderbolt: ["1L1"],
			topsyturvy: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wrap: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, nature: "Adamant", ivs: {hp: 31, atk: 31}, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	binacle: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			clamp: ["1L1"],
			confide: ["1L1"],
			crosschop: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			liquidation: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shellsmash: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			switcheroo: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			withdraw: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	barbaracle: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			clamp: ["1L1"],
			confide: ["1L1"],
			crosschop: ["1L1"],
			cut: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dualchop: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			laserfocus: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			meteorbeam: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowclaw: ["1L1"],
			shellsmash: ["1L1"],
			skullbash: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			withdraw: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	skrelp: {
		learnset: {
			acid: ["1L1"],
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			bubble: ["1L1"],
			camouflage: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			outrage: ["1L1"],
			playrough: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			twister: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	dragalge: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			bubble: ["1L1"],
			camouflage: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flipturn: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			outrage: ["1L1"],
			playrough: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			twister: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 35},
		],
	},
	clauncher: {
		learnset: {
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crabhammer: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flashcannon: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			visegrip: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	clawitzer: {
		learnset: {
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crabhammer: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flashcannon: ["1L1"],
			flipturn: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			liquidation: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			visegrip: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			weatherball: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 35},
		],
	},
	helioptile: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bulldoze: ["1L1"],
			camouflage: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			electricterrain: ["1L1"],
			electrify: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			glare: ["1L1"],
			grassknot: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			lowsweep: ["1L1"],
			magnetrise: ["1L1"],
			mudslap: ["1L1"],
			paraboliccharge: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	heliolisk: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electrify: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudslap: ["1L1"],
			paraboliccharge: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	tyrunt: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			frustration: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			horndrill: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			meteorbeam: ["1L1"],
			outrage: ["1L1"],
			playrough: ["1L1"],
			poisonfang: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 10, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	tyrantrum: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headsmash: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			honeclaws: ["1L1"],
			horndrill: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			meteorbeam: ["1L1"],
			outrage: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	amaura: {
		learnset: {
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			barrier: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			darkpulse: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			dragontail: ["1L1"],
			dreameater: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			freezedry: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			meteorbeam: ["1L1"],
			mirrorcoat: ["1L1"],
			mist: ["1L1"],
			mudshot: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 10, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	aurorus: {
		learnset: {
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dragontail: ["1L1"],
			dreameater: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			freezedry: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			meteorbeam: ["1L1"],
			mist: ["1L1"],
			mudshot: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	sylveon: {
		learnset: {
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			faketears: ["1L1"],
			flash: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			mudslap: ["1L1"],
			mysticalfire: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandattack: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			weatherball: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 10, gender: "F", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, gender: "F", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	hawlucha: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bravebird: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			crosschop: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			dualwingbeat: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			featherdance: ["1L1"],
			feint: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			flyingpress: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			karatechop: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			lunge: ["1L1"],
			meanlook: ["1L1"],
			mefirst: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudsport: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	dedenne: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			mistyterrain: ["1L1"],
			naturalgift: ["1L1"],
			nuzzle: ["1L1"],
			paraboliccharge: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	carbink: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			meteorbeam: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			naturepower: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			sharpen: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	goomy: {
		learnset: {
			absorb: ["1L1"],
			acidarmor: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bubble: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonpulse: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			irontail: ["1L1"],
			lifedew: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			outrage: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 1, shiny: 1, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	sliggoo: {
		learnset: {
			absorb: ["1L1"],
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bubble: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonpulse: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			infestation: ["1L1"],
			irontail: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
		},
		encounters: [
			{generation: 6, level: 30},
		],
	},
	sliggoohisui: {
		learnset: {
			absorb: ["1L1"],
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			curse: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonpulse: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			flashcannon: ["1L1"],
			gyroball: ["1L1"],
			heavyslam: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			ironhead: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			shelter: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	goodra: {
		learnset: {
			absorb: ["1L1"],
			acidspray: ["1L1"],
			aquatail: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bubble: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			incinerate: ["1L1"],
			infestation: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			outrage: ["1L1"],
			poisontail: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	goodrahisui: {
		learnset: {
			absorb: ["1L1"],
			acidspray: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			curse: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			heavyslam: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			shelter: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	klefki: {
		learnset: {
			astonish: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			craftyshield: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fairylock: ["1L1"],
			fairywind: ["1L1"],
			flashcannon: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			healblock: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			mirrorshot: ["1L1"],
			mistyterrain: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			steelbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
		},
	},
	phantump: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bestow: ["1L1"],
			branchpoke: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			forestscurse: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			grudge: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hornleech: ["1L1"],
			imprison: ["1L1"],
			ingrain: ["1L1"],
			lashout: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			naturepower: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			poisonjab: ["1L1"],
			poltergeist: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			venomdrench: ["1L1"],
			willowisp: ["1L1"],
			woodhammer: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	trevenant: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			branchpoke: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			focusblast: ["1L1"],
			forestscurse: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			haze: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hornleech: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			ingrain: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			naturepower: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			poisonjab: ["1L1"],
			poltergeist: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			venomdrench: ["1L1"],
			willowisp: ["1L1"],
			woodhammer: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	pumpkaboo: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bestow: ["1L1"],
			bulletseed: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			gyroball: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			mysticalfire: ["1L1"],
			naturepower: ["1L1"],
			painsplit: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowsneak: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickortreat: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	pumpkaboosuper: {
		learnset: {
			astonish: ["1L1"],
			scaryface: ["1L1"],
			shadowsneak: ["1L1"],
			trickortreat: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	gourgeist: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			brutalswing: ["1L1"],
			bulletseed: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			gyroball: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			moonblast: ["1L1"],
			mysticalfire: ["1L1"],
			nastyplot: ["1L1"],
			naturepower: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowsneak: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickortreat: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	bergmite: {
		learnset: {
			afteryou: ["1L1"],
			attract: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			barrier: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			iceball: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			mirrorcoat: ["1L1"],
			mist: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			sharpen: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	avalugg: {
		learnset: {
			afteryou: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			iceball: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icespinner: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			sharpen: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			waterpulse: ["1L1"],
			wideguard: ["1L1"],
		},
	},
	avalugghisui: {
		learnset: {
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			hardpress: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			meteorbeam: ["1L1"],
			mountaingale: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snowscape: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			wideguard: ["1L1"],
		},
	},
	noibat: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			brickbreak: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gust: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			leechlife: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			whirlwind: ["1L1"],
			wildcharge: ["1L1"],
			wingattack: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	noivern: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			boomburst: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flamethrower: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			moonlight: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			whirlwind: ["1L1"],
			wildcharge: ["1L1"],
			wingattack: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	xerneas: {
		learnset: {
			aromatherapy: ["1L1"],
			aurorabeam: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			geomancy: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			hail: ["1L1"],
			healpulse: ["1L1"],
			hiddenpower: ["1L1"],
			hornleech: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			ingrain: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			megahorn: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			outrage: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terrainpulse: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, moves: ["1L1"]},
			{generation: 6, level: 100, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	yveltal: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			airslash: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragonrush: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			oblivionwing: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, moves: ["1L1"]},
			{generation: 6, level: 100, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	zygarde: {
		learnset: {
			bind: ["1L1"],
			bite: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			camouflage: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			coreenforcer: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			glare: ["1L1"],
			grassknot: ["1L1"],
			haze: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			landswrath: ["1L1"],
			outrage: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			thousandarrows: ["1L1"],
			thousandwaves: ["1L1"],
			toxic: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 70, moves: ["1L1"]},
			{generation: 6, level: 100, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 30, moves: ["1L1"]},
			{generation: 7, level: 50, moves: ["1L1"]},
			{generation: 7, level: 50, isHidden: true, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: true, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, shiny: true, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	zygarde10: {
		learnset: {
			bind: ["1L1"],
			dig: ["1L1"],
			dragonbreath: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			extremespeed: ["1L1"],
			glare: ["1L1"],
			haze: ["1L1"],
			landswrath: ["1L1"],
			outrage: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			thousandarrows: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 30, moves: ["1L1"]},
			{generation: 7, level: 50, isHidden: true, moves: ["1L1"]},
			{generation: 7, level: 50, isHidden: true, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: true, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 100, shiny: true, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, isHidden: true, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	diancie: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			batonpass: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			diamondstorm: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			earthpower: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			meteorbeam: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			moonblast: ["1L1"],
			mysticalfire: ["1L1"],
			naturepower: ["1L1"],
			playrough: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			sharpen: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 50, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	hoopa: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			block: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			covet: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dualchop: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardsplit: ["1L1"],
			gunkshot: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hyperspacefury: ["1L1"],
			hyperspacehole: ["1L1"],
			icepunch: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			nastyplot: ["1L1"],
			phantomforce: ["1L1"],
			powersplit: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 15, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	hoopaunbound: {
		eventOnly: false,
	},
	volcanion: {
		learnset: {
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			haze: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			mist: ["1L1"],
			mistyterrain: ["1L1"],
			mudshot: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steameruption: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 70, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 6, level: 70, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 60, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	rowlet: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bravebird: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			featherdance: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			knockoff: ["1L1"],
			leafage: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			nastyplot: ["1L1"],
			naturepower: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	dartrix: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bravebird: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			featherdance: ["1L1"],
			foresight: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			knockoff: ["1L1"],
			leafage: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			nastyplot: ["1L1"],
			naturepower: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	decidueye: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bravebird: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			featherdance: ["1L1"],
			foresight: ["1L1"],
			frenzyplant: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leafage: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			nastyplot: ["1L1"],
			naturepower: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			peck: ["1L1"],
			phantomforce: ["1L1"],
			pluck: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			skittersmack: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			spiritshackle: ["1L1"],
			spite: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	decidueyehisui: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			bravebird: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulletseed: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confuseray: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			featherdance: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frenzyplant: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			knockoff: ["1L1"],
			leafage: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rocktomb: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			trailblaze: ["1L1"],
			triplearrows: ["1L1"],
			upperhand: ["1L1"],
			uturn: ["1L1"],
		},
	},
	litten: {
		learnset: {
			acrobatics: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulkup: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			partingshot: ["1L1"],
			payday: ["1L1"],
			powertrip: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
	},
	torracat: {
		learnset: {
			acrobatics: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulkup: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
	},
	incineroar: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			blastburn: ["1L1"],
			blazekick: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crosschop: ["1L1"],
			crunch: ["1L1"],
			darkestlariat: ["1L1"],
			darkpulse: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	popplio: {
		learnset: {
			acrobatics: ["1L1"],
			amnesia: ["1L1"],
			aquajet: ["1L1"],
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			aromaticmist: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lifedew: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			perishsong: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
		},
	},
	brionne: {
		learnset: {
			acrobatics: ["1L1"],
			amnesia: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
		},
	},
	primarina: {
		learnset: {
			acrobatics: ["1L1"],
			alluringvoice: ["1L1"],
			amnesia: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			magiccoat: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			perishsong: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			shadowball: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			sparklingaria: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			uproar: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	pikipek: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			boomburst: ["1L1"],
			bravebird: ["1L1"],
			brickbreak: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			flamecharge: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			knockoff: ["1L1"],
			mirrormove: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
		},
	},
	trumbeak: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			brickbreak: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			flamecharge: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			knockoff: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
		},
	},
	toucannon: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			beakblast: ["1L1"],
			bravebird: ["1L1"],
			brickbreak: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			flamecharge: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			knockoff: ["1L1"],
			overheat: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supersonic: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
		},
		encounters: [
			{generation: 7, level: 26},
		],
	},
	yungoos: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			frustration: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperfang: ["1L1"],
			icefang: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			odorsleuth: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	gumshoos: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hyperfang: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			lowsweep: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			odorsleuth: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		encounters: [
			{generation: 7, level: 17},
		],
	},
	gumshoostotem: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			bite: ["1L1"],
			block: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			hiddenpower: ["1L1"],
			hyperfang: ["1L1"],
			icepunch: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			mudslap: ["1L1"],
			odorsleuth: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 20, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	grubbin: {
		learnset: {
			acrobatics: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			bugbite: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			electricterrain: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magnetrise: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			stickyweb: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			visegrip: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	charjabug: {
		learnset: {
			acrobatics: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			bugbite: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			hiddenpower: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magnetrise: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			stickyweb: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			visegrip: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	vikavolt: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulldoze: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			guillotine: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magnetrise: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spark: ["1L1"],
			stickyweb: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			supercellslam: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			visegrip: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			xscissor: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	vikavolttotem: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			electroweb: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			guillotine: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			mudslap: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spark: ["1L1"],
			stringshot: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			visegrip: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			xscissor: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 35, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	crabrawler: {
		learnset: {
			amnesia: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			crabhammer: ["1L1"],
			dig: ["1L1"],
			dizzypunch: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			visegrip: ["1L1"],
			wideguard: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	crabominable: {
		learnset: {
			amnesia: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			dig: ["1L1"],
			dizzypunch: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			hardpress: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icehammer: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	oricorio: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			defog: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			flatter: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			icywind: ["1L1"],
			mirrormove: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quash: ["1L1"],
			quiverdance: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revelationdance: ["1L1"],
			reversal: ["1L1"],
			roleplay: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
		},
	},
	cutiefly: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bestow: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			faketears: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			lastresort: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magicroom: ["1L1"],
			moonblast: ["1L1"],
			playrough: ["1L1"],
			pollenpuff: ["1L1"],
			pounce: ["1L1"],
			powder: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			quiverdance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			stickyweb: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tailwind: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			uturn: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	ribombee: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			faketears: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			lastresort: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			magicroom: ["1L1"],
			naturepower: ["1L1"],
			playrough: ["1L1"],
			pollenpuff: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychup: ["1L1"],
			quiverdance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			speedswap: ["1L1"],
			storedpower: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			uturn: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	ribombeetotem: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			frustration: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			infestation: ["1L1"],
			lastresort: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			magicroom: ["1L1"],
			naturepower: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			quiverdance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			tailwind: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			uturn: ["1L1"],
			wonderroom: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	rockruff: {
		learnset: {
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			crushclaw: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			frustration: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypervoice: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			mudslap: ["1L1"],
			odorsleuth: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	rockruffdusk: {
		learnset: {
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			crushclaw: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			frustration: ["1L1"],
			happyhour: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypervoice: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			mudslap: ["1L1"],
			odorsleuth: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 10, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	lycanroc: {
		learnset: {
			accelerock: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypervoice: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			mudslap: ["1L1"],
			odorsleuth: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailslap: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	lycanrocmidnight: {
		learnset: {
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypervoice: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudslap: ["1L1"],
			odorsleuth: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	lycanrocdusk: {
		learnset: {
			accelerock: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			crushclaw: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			howl: ["1L1"],
			hypervoice: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			leer: ["1L1"],
			mudslap: ["1L1"],
			odorsleuth: ["1L1"],
			outrage: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailslap: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	wishiwashi: {
		learnset: {
			aquaring: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			tearfullook: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	mareanie: {
		learnset: {
			acidspray: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			lunge: ["1L1"],
			magiccoat: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spikecannon: ["1L1"],
			spite: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterpulse: ["1L1"],
			wideguard: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 1, shiny: 1, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	toxapex: {
		learnset: {
			acidspray: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			banefulbunker: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			crosspoison: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			lunge: ["1L1"],
			magiccoat: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spikecannon: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterpulse: ["1L1"],
			wideguard: ["1L1"],
		},
	},
	mudbray: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			frustration: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magnitude: ["1L1"],
			megakick: ["1L1"],
			mudbomb: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
		},
	},
	mudsdale: {
		learnset: {
			attract: ["1L1"],
			bide: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lashout: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
		},
		encounters: [
			{generation: 7, level: 29},
		],
	},
	dewpider: {
		learnset: {
			aquaring: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			leechlife: ["1L1"],
			liquidation: ["1L1"],
			lunge: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mirrorcoat: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			powersplit: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			spiderweb: ["1L1"],
			spitup: ["1L1"],
			stickyweb: ["1L1"],
			stockpile: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			wonderroom: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	araquanid: {
		learnset: {
			aquaring: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			liquidation: ["1L1"],
			lunge: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mirrorcoat: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			spiderweb: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wideguard: ["1L1"],
			wonderroom: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	araquanidtotem: {
		learnset: {
			aquaring: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bugbite: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			doubleteam: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			liquidation: ["1L1"],
			lunge: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mirrorcoat: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			spiderweb: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			wideguard: ["1L1"],
			wonderroom: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 25, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	fomantis: {
		learnset: {
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			hiddenpower: ["1L1"],
			ingrain: ["1L1"],
			leafage: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leechlife: ["1L1"],
			magicalleaf: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			petalblizzard: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	lurantis: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			crosspoison: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ingrain: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leafage: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leechlife: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			petalblizzard: ["1L1"],
			poisonjab: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			raindance: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			signalbeam: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			weatherball: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	lurantistotem: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growth: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ingrain: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leafage: ["1L1"],
			leafblade: ["1L1"],
			leechlife: ["1L1"],
			lowsweep: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			petalblizzard: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			signalbeam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			toxic: ["1L1"],
			worryseed: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 30, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	morelull: {
		learnset: {
			absorb: ["1L1"],
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			growth: ["1L1"],
			hiddenpower: ["1L1"],
			ingrain: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megadrain: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			naturepower: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			signalbeam: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spore: ["1L1"],
			spotlight: ["1L1"],
			strengthsap: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			wonderroom: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	shiinotic: {
		learnset: {
			absorb: ["1L1"],
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ingrain: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megadrain: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			naturepower: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			signalbeam: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spore: ["1L1"],
			spotlight: ["1L1"],
			strengthsap: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			weatherball: ["1L1"],
			wonderroom: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	salandit: {
		learnset: {
			acidspray: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			belch: ["1L1"],
			burningjealousy: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			poisonfang: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	salazzle: {
		learnset: {
			acidspray: ["1L1"],
			acrobatics: ["1L1"],
			agility: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			corrosivegas: ["1L1"],
			covet: ["1L1"],
			crosspoison: ["1L1"],
			disable: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firelash: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			poisonfang: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
		encounters: [
			{generation: 7, level: 16},
		],
	},
	salazzletotem: {
		learnset: {
			acrobatics: ["1L1"],
			attract: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			disable: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			nastyplot: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 30, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	stufful: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			frustration: ["1L1"],
			hammerarm: ["1L1"],
			hiddenpower: ["1L1"],
			icepunch: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thrash: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			wideguard: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	bewear: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			darkestlariat: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hammerarm: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			thrash: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, gender: "F", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	bounsweet: {
		learnset: {
			acupressure: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			flail: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			leafstorm: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			naturepower: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	steenee: {
		learnset: {
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			lightscreen: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			petalblizzard: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			splash: ["1L1"],
			stomp: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 20, nature: "Naive", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	tsareena: {
		learnset: {
			acrobatics: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			bulletseed: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleslap: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			hyperbeam: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leafstorm: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			megakick: ["1L1"],
			naturepower: ["1L1"],
			payback: ["1L1"],
			petalblizzard: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			punishment: ["1L1"],
			rapidspin: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			splash: ["1L1"],
			stomp: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			teeterdance: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			tropkick: ["1L1"],
			uturn: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	comfey: {
		learnset: {
			acrobatics: ["1L1"],
			afteryou: ["1L1"],
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			amnesia: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			floralhealing: ["1L1"],
			flowershield: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			healbell: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			knockoff: ["1L1"],
			leaftornado: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			painsplit: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			playrough: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetkiss: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			synthesis: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uturn: ["1L1"],
			vinewhip: ["1L1"],
			worryseed: ["1L1"],
			wrap: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 10, nature: "Jolly", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	oranguru: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			covet: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			instruct: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			nastyplot: ["1L1"],
			naturepower: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 1, shiny: 1, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	passimian: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			bestow: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			earthquake: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			vitalthrow: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 1, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, isHidden: true, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	wimpod: {
		learnset: {
			aquajet: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bugbuzz: ["1L1"],
			confide: ["1L1"],
			defensecurl: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			leechlife: ["1L1"],
			metalclaw: ["1L1"],
			mudshot: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			wideguard: ["1L1"],
		},
	},
	golisopod: {
		learnset: {
			aerialace: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulkup: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			darkpulse: ["1L1"],
			defensecurl: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			dualchop: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			firstimpression: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			liquidation: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scald: ["1L1"],
			screech: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	sandygast: {
		learnset: {
			absorb: ["1L1"],
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			destinybond: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gravity: ["1L1"],
			harden: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			megadrain: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			shadowball: ["1L1"],
			shoreup: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
		},
	},
	palossand: {
		learnset: {
			absorb: ["1L1"],
			afteryou: ["1L1"],
			amnesia: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			harden: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			megadrain: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			shadowball: ["1L1"],
			shoreup: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
		},
	},
	pyukumuku: {
		learnset: {
			attract: ["1L1"],
			batonpass: ["1L1"],
			bestow: ["1L1"],
			bide: ["1L1"],
			block: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			gastroacid: ["1L1"],
			hail: ["1L1"],
			harden: ["1L1"],
			helpinghand: ["1L1"],
			lightscreen: ["1L1"],
			memento: ["1L1"],
			mirrorcoat: ["1L1"],
			mudsport: ["1L1"],
			painsplit: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			purify: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			soak: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			venomdrench: ["1L1"],
			watersport: ["1L1"],
		},
	},
	typenull: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			confide: ["1L1"],
			crushclaw: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dragonclaw: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flamecharge: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			healblock: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lastresort: ["1L1"],
			magiccoat: ["1L1"],
			metalsound: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			punishment: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			shadowclaw: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terrainpulse: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 40, shiny: 1, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 7, level: 60, shiny: 1, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 8, level: 50, shiny: 1, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	silvally: {
		learnset: {
			aerialace: ["1L1"],
			airslash: ["1L1"],
			bite: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			crushclaw: ["1L1"],
			defog: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonclaw: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grasspledge: ["1L1"],
			hail: ["1L1"],
			healblock: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			magiccoat: ["1L1"],
			metalsound: ["1L1"],
			multiattack: ["1L1"],
			outrage: ["1L1"],
			partingshot: ["1L1"],
			payback: ["1L1"],
			poisonfang: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			punishment: ["1L1"],
			pursuit: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terrainpulse: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 100, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	minior: {
		learnset: {
			acrobatics: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			cosmicpower: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			meteorbeam: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scorchingsands: ["1L1"],
			selfdestruct: ["1L1"],
			shellsmash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	komala: {
		learnset: {
			acrobatics: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icespinner: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metalclaw: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			sing: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			wish: ["1L1"],
			woodhammer: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	turtonator: {
		learnset: {
			attract: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			curse: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flail: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headsmash: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lashout: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scorchingsands: ["1L1"],
			shellsmash: ["1L1"],
			shelltrap: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smog: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
			wideguard: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 1, shiny: 1, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 30, gender: "M", nature: "Brave", moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	togedemaru: {
		learnset: {
			afteryou: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			defensecurl: ["1L1"],
			disarmingvoice: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			fellstinger: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			magnetrise: ["1L1"],
			nuzzle: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			spikyshield: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			twineedle: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
			zingzap: ["1L1"],
		},
	},
	togedemarutotem: {
		learnset: {
			afteryou: ["1L1"],
			attract: ["1L1"],
			bounce: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			defensecurl: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			electricterrain: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			fellstinger: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			magnetrise: ["1L1"],
			nuzzle: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			spikyshield: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
			zingzap: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 30, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	mimikyu: {
		learnset: {
			afteryou: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			beatup: ["1L1"],
			bulkup: ["1L1"],
			burningjealousy: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			destinybond: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grudge: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			lastresort: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			magicroom: ["1L1"],
			mimic: ["1L1"],
			mistyterrain: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			playrough: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			woodhammer: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 10, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 10, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 50, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 9, level: 25, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	mimikyutotem: {
		learnset: {
			afteryou: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			bulkup: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			lastresort: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			magicroom: ["1L1"],
			mimic: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			woodhammer: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 40, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	bruxish: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bulkup: ["1L1"],
			calmmind: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			crunch: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisonfang: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicfangs: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			rage: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synchronoise: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	drampa: {
		learnset: {
			amnesia: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			breakingswipe: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			glare: ["1L1"],
			grassknot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			lashout: ["1L1"],
			lightscreen: ["1L1"],
			mist: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaleshot: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 1, shiny: 1, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	dhelmise: {
		learnset: {
			absorb: ["1L1"],
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			anchorshot: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			growth: ["1L1"],
			gyroball: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			megadrain: ["1L1"],
			metalsound: ["1L1"],
			muddywater: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			spite: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			switcheroo: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			whirlpool: ["1L1"],
			wrap: ["1L1"],
		},
	},
	jangmoo: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	hakamoo: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			bide: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			shadowclaw: ["1L1"],
			skyuppercut: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	kommoo: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			autotomize: ["1L1"],
			bellydrum: ["1L1"],
			bide: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			boomburst: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			clangingscales: ["1L1"],
			clangoroussoul: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skyuppercut: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		encounters: [
			{generation: 7, level: 41},
		],
	},
	kommoototem: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			autotomize: ["1L1"],
			bellydrum: ["1L1"],
			bide: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			clangingscales: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			skyuppercut: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	tapukoko: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			bravebird: ["1L1"],
			calmmind: ["1L1"],
			charge: ["1L1"],
			confide: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			falseswipe: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lightscreen: ["1L1"],
			meanlook: ["1L1"],
			mirrormove: ["1L1"],
			naturepower: ["1L1"],
			naturesmadness: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			shockwave: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			steelwing: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			withdraw: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 60, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: true, nature: "Timid", moves: ["1L1"], pokeball: "cherishball"},
			{generation: 7, level: 60, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	tapulele: {
		learnset: {
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			astonish: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meanlook: ["1L1"],
			moonblast: ["1L1"],
			naturepower: ["1L1"],
			naturesmadness: ["1L1"],
			playrough: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			withdraw: ["1L1"],
			wonderroom: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 60, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	tapubulu: {
		learnset: {
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			darkestlariat: ["1L1"],
			dazzlinggleam: ["1L1"],
			disable: ["1L1"],
			dualchop: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			guardswap: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hornattack: ["1L1"],
			hornleech: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			leafage: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			meanlook: ["1L1"],
			megadrain: ["1L1"],
			megahorn: ["1L1"],
			megapunch: ["1L1"],
			naturepower: ["1L1"],
			naturesmadness: ["1L1"],
			payback: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			whirlwind: ["1L1"],
			withdraw: ["1L1"],
			woodhammer: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 60, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	tapufini: {
		learnset: {
			aquaring: ["1L1"],
			blizzard: ["1L1"],
			brine: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			haze: ["1L1"],
			healpulse: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meanlook: ["1L1"],
			mist: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			muddywater: ["1L1"],
			naturepower: ["1L1"],
			naturesmadness: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			withdraw: ["1L1"],
			wonderroom: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 60, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	cosmog: {
		learnset: {
			splash: ["1L1"],
			teleport: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 5, moves: ["1L1"]},
			{generation: 8, level: 5, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	cosmoem: {
		learnset: {
			cosmicpower: ["1L1"],
			teleport: ["1L1"],
		},
	},
	solgaleo: {
		learnset: {
			agility: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			cosmicpower: ["1L1"],
			crunch: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flashcannon: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			heatcrash: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			morningsun: ["1L1"],
			mysticalfire: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicfangs: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			sunsteelstrike: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			wakeupslap: ["1L1"],
			wideguard: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 55, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
	},
	lunala: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			airslash: ["1L1"],
			blizzard: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			meteorbeam: ["1L1"],
			moonblast: ["1L1"],
			moongeistbeam: ["1L1"],
			moonlight: ["1L1"],
			nightdaze: ["1L1"],
			nightshade: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			telekinesis: ["1L1"],
			teleport: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wideguard: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 55, moves: ["1L1"]},
			{generation: 7, level: 60, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
	},
	nihilego: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			allyswitch: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			chargebeam: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			corrosivegas: ["1L1"],
			crosspoison: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			grassknot: ["1L1"],
			guardsplit: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			meteorbeam: ["1L1"],
			mirrorcoat: ["1L1"],
			painsplit: ["1L1"],
			poisonjab: ["1L1"],
			pound: ["1L1"],
			powergem: ["1L1"],
			powersplit: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			telekinesis: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trickroom: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			wonderroom: ["1L1"],
			worryseed: ["1L1"],
			wrap: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 55, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	buzzwole: {
		learnset: {
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			cometpunch: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			darkestlariat: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			dualwingbeat: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fellstinger: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			harden: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			icepunch: ["1L1"],
			ironhead: ["1L1"],
			leechlife: ["1L1"],
			lowsweep: ["1L1"],
			lunge: ["1L1"],
			megapunch: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			vitalthrow: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 65, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	pheromosa: {
		learnset: {
			agility: ["1L1"],
			assurance: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			echoedvoice: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hiddenpower: ["1L1"],
			highjumpkick: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			jumpkick: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			lunge: ["1L1"],
			mefirst: ["1L1"],
			outrage: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			quickguard: ["1L1"],
			quiverdance: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			stomp: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			tripleaxel: ["1L1"],
			triplekick: ["1L1"],
			uturn: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 60, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	xurkitree: {
		learnset: {
			bind: ["1L1"],
			brutalswing: ["1L1"],
			calmmind: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			dazzlinggleam: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			ingrain: ["1L1"],
			iondeluge: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magnetrise: ["1L1"],
			naturepower: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tailglow: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			wrap: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 65, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	celesteela: {
		learnset: {
			absorb: ["1L1"],
			acrobatics: ["1L1"],
			airslash: ["1L1"],
			autotomize: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ingrain: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			leechseed: ["1L1"],
			magnetrise: ["1L1"],
			megadrain: ["1L1"],
			megahorn: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			round: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			shockwave: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			toxic: ["1L1"],
			wideguard: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 65, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	kartana: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			defog: ["1L1"],
			detect: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			falseswipe: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			guillotine: ["1L1"],
			hiddenpower: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			leafblade: ["1L1"],
			nightslash: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			sacredsword: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			solarblade: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tailwind: ["1L1"],
			toxic: ["1L1"],
			vacuumwave: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 60, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	guzzlord: {
		learnset: {
			amnesia: ["1L1"],
			belch: ["1L1"],
			bite: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			corrosivegas: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			hammerarm: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lastresort: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			steamroller: ["1L1"],
			steelroller: ["1L1"],
			stockpile: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swallow: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			toxic: ["1L1"],
			wideguard: ["1L1"],
			wringout: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 70, moves: ["1L1"]},
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	necrozma: {
		learnset: {
			aerialace: ["1L1"],
			allyswitch: ["1L1"],
			autotomize: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			cosmicpower: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			magnetrise: ["1L1"],
			metalclaw: ["1L1"],
			meteorbeam: ["1L1"],
			mirrorshot: ["1L1"],
			moonlight: ["1L1"],
			morningsun: ["1L1"],
			nightslash: ["1L1"],
			outrage: ["1L1"],
			photongeyser: ["1L1"],
			powergem: ["1L1"],
			prismaticlaser: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicfangs: ["1L1"],
			psychocut: ["1L1"],
			psyshock: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			wringout: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 75, moves: ["1L1"]},
			{generation: 7, level: 65, moves: ["1L1"]},
			{generation: 7, level: 75, shiny: true, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	necrozmaduskmane: {
		learnset: {
			sunsteelstrike: ["1L1"],
		},
		eventOnly: false,
	},
	necrozmadawnwings: {
		learnset: {
			moongeistbeam: ["1L1"],
		},
		eventOnly: false,
	},
	necrozmaultra: {
		learnset: {
			moongeistbeam: ["1L1"],
			sunsteelstrike: ["1L1"],
		},
	},
	magearna: {
		learnset: {
			afteryou: ["1L1"],
			agility: ["1L1"],
			aurasphere: ["1L1"],
			aurorabeam: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			craftyshield: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flashcannon: ["1L1"],
			fleurcannon: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gearup: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			healbell: ["1L1"],
			heartswap: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			luckychant: ["1L1"],
			magneticflux: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			mindreader: ["1L1"],
			mirrorshot: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			painsplit: ["1L1"],
			playrough: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shiftgear: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			solarbeam: ["1L1"],
			sonicboom: ["1L1"],
			speedswap: ["1L1"],
			spikes: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			synchronoise: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			trumpcard: ["1L1"],
			voltswitch: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	magearnaoriginal: {
		learnset: {
			agility: ["1L1"],
			aurasphere: ["1L1"],
			aurorabeam: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confuseray: ["1L1"],
			craftyshield: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disarmingvoice: ["1L1"],
			drainingkiss: ["1L1"],
			eerieimpulse: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flashcannon: ["1L1"],
			fleurcannon: ["1L1"],
			focusblast: ["1L1"],
			gearup: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			gyroball: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			magneticflux: ["1L1"],
			metalsound: ["1L1"],
			mindreader: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			painsplit: ["1L1"],
			playrough: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shiftgear: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			solarbeam: ["1L1"],
			speedswap: ["1L1"],
			spikes: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			voltswitch: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 50, nature: "Mild", ivs: {hp: 31, atk: 30, def: 30, spa: 31, spd: 31, spe: 0}, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	marshadow: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			aurasphere: ["1L1"],
			blazekick: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			ironhead: ["1L1"],
			jumpkick: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lastresort: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poisonjab: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rollingkick: ["1L1"],
			round: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowpunch: ["1L1"],
			shadowsneak: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spectralthief: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 60, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	poipole: {
		learnset: {
			acid: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			covet: ["1L1"],
			dragonpulse: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fellstinger: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gastroacid: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			irontail: ["1L1"],
			nastyplot: ["1L1"],
			peck: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uproar: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 40, shiny: 1, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 7, level: 40, shiny: true, nature: "Modest", perfectIVs: 3, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 20, moves: ["1L1"], pokeball: "beastball"},
		],
		eventOnly: false,
	},
	naganadel: {
		learnset: {
			acid: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			breakingswipe: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			crosspoison: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fellstinger: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gastroacid: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			peck: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			shadowclaw: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smartstrike: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	stakataka: {
		learnset: {
			allyswitch: ["1L1"],
			autotomize: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			doubleedge: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			heatcrash: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			magnetrise: ["1L1"],
			megakick: ["1L1"],
			meteorbeam: ["1L1"],
			protect: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			telekinesis: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			wideguard: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	blacephalon: {
		learnset: {
			afteryou: ["1L1"],
			astonish: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			incinerate: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			mindblown: ["1L1"],
			mysticalfire: ["1L1"],
			nightshade: ["1L1"],
			overheat: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			quash: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			round: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 60, shiny: 1, moves: ["1L1"]},
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	zeraora: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			aurasphere: ["1L1"],
			blazekick: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			calmmind: ["1L1"],
			charge: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualchop: ["1L1"],
			echoedvoice: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			falseswipe: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			outrage: ["1L1"],
			payday: ["1L1"],
			plasmafists: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			shockwave: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
			{generation: 8, level: 100, shiny: true, nature: "Hasty", ivs: {hp: 31, atk: 31, def: 30, spa: 31, spd: 31, spe: 31}, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	meltan: {
		learnset: {
			acidarmor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			irondefense: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			tailwhip: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
		},
	},
	melmetal: {
		learnset: {
			acidarmor: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			darkestlariat: ["1L1"],
			discharge: ["1L1"],
			doubleironbash: ["1L1"],
			dynamicpunch: ["1L1"],
			earthquake: ["1L1"],
			electricterrain: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			tailwhip: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 100, nature: "Brave", ivs: {hp: 31, atk: 31, def: 31, spa: 31, spd: 31, spe: 0}, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	grookey: {
		learnset: {
			acrobatics: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			branchpoke: ["1L1"],
			bulletseed: ["1L1"],
			drainpunch: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			growth: ["1L1"],
			hammerarm: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lowkick: ["1L1"],
			magicalleaf: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			naturepower: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			woodhammer: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	thwackey: {
		learnset: {
			acrobatics: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			branchpoke: ["1L1"],
			bulletseed: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			drainpunch: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			lowkick: ["1L1"],
			magicalleaf: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			woodhammer: ["1L1"],
			workup: ["1L1"],
		},
	},
	rillaboom: {
		learnset: {
			acrobatics: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			boomburst: ["1L1"],
			branchpoke: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			darkestlariat: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			drainpunch: ["1L1"],
			drumbeating: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frenzyplant: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growl: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudshot: ["1L1"],
			nobleroar: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			woodhammer: ["1L1"],
			workup: ["1L1"],
		},
	},
	scorbunny: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			blazekick: ["1L1"],
			bounce: ["1L1"],
			burningjealousy: ["1L1"],
			counter: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			electroball: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			focusenergy: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			highjumpkick: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			mudshot: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
		},
	},
	raboot: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			blazekick: ["1L1"],
			bounce: ["1L1"],
			bulkup: ["1L1"],
			burningjealousy: ["1L1"],
			counter: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			electroball: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			focusenergy: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			mudshot: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			weatherball: ["1L1"],
			workup: ["1L1"],
		},
	},
	cinderace: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			blastburn: ["1L1"],
			blazekick: ["1L1"],
			bounce: ["1L1"],
			bulkup: ["1L1"],
			burningjealousy: ["1L1"],
			coaching: ["1L1"],
			counter: ["1L1"],
			courtchange: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			electroball: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			pyroball: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			scorchingsands: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			weatherball: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	sobble: {
		learnset: {
			aquajet: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bind: ["1L1"],
			bounce: ["1L1"],
			chillingwater: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fellstinger: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			hydropump: ["1L1"],
			iceshard: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			mist: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
	},
	drizzile: {
		learnset: {
			attract: ["1L1"],
			batonpass: ["1L1"],
			bind: ["1L1"],
			bounce: ["1L1"],
			chillingwater: ["1L1"],
			dive: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			hydropump: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
	},
	inteleon: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bind: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			breakingswipe: ["1L1"],
			chillingwater: ["1L1"],
			darkpulse: ["1L1"],
			dive: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			metronome: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			shadowball: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snipeshot: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			uturn: ["1L1"],
			vacuumwave: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
	},
	skwovet: {
		learnset: {
			amnesia: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bellydrum: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bulletseed: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			gyroball: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			lastresort: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			stuffcheeks: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			swallow: ["1L1"],
			tackle: ["1L1"],
			tailslap: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
		},
	},
	greedent: {
		learnset: {
			amnesia: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			bite: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			counter: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			fling: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			stompingtantrum: ["1L1"],
			stuffcheeks: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			swallow: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailslap: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	rookidee: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			defog: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			furyattack: ["1L1"],
			honeclaws: ["1L1"],
			leer: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			powertrip: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
		},
	},
	corvisquire: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bravebird: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			furyattack: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			leer: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			powertrip: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
		},
	},
	corviknight: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			bulkup: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			heavyslam: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			powertrip: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			steelbeam: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
		},
	},
	blipbug: {
		learnset: {
			infestation: ["1L1"],
			recover: ["1L1"],
			stickyweb: ["1L1"],
			strugglebug: ["1L1"],
			supersonic: ["1L1"],
		},
	},
	dottler: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			confusion: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			futuresight: ["1L1"],
			guardswap: ["1L1"],
			helpinghand: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			magicroom: ["1L1"],
			payback: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	orbeetle: {
		learnset: {
			afteryou: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodypress: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			guardswap: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			hypnosis: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			mirrorcoat: ["1L1"],
			payback: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uturn: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	nickit: {
		learnset: {
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			dig: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			foulplay: ["1L1"],
			honeclaws: ["1L1"],
			howl: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			mudshot: ["1L1"],
			nastyplot: ["1L1"],
			nightslash: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swift: ["1L1"],
			tailslap: ["1L1"],
			tailwhip: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
		},
	},
	thievul: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			burningjealousy: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			firefang: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			lashout: ["1L1"],
			mudshot: ["1L1"],
			nastyplot: ["1L1"],
			nightslash: ["1L1"],
			partingshot: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swift: ["1L1"],
			tailslap: ["1L1"],
			tailwhip: ["1L1"],
			taunt: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			uturn: ["1L1"],
		},
	},
	gossifleur: {
		learnset: {
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hypervoice: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			leaftornado: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			sing: ["1L1"],
			sleeppowder: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			sweetscent: ["1L1"],
			synthesis: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	eldegoss: {
		learnset: {
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			cottonguard: ["1L1"],
			cottonspore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			leaftornado: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			seedbomb: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			sweetscent: ["1L1"],
			synthesis: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	wooloo: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			copycat: ["1L1"],
			cottonguard: ["1L1"],
			counter: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			electroball: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			grassyglide: ["1L1"],
			growl: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			thunderwave: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	dubwool: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			copycat: ["1L1"],
			cottonguard: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			electroball: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			grassyglide: ["1L1"],
			growl: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			headbutt: ["1L1"],
			hyperbeam: ["1L1"],
			lastresort: ["1L1"],
			megakick: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			thunderwave: ["1L1"],
			wildcharge: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	chewtle: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			chillingwater: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			dive: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			gastroacid: ["1L1"],
			headbutt: ["1L1"],
			hydropump: ["1L1"],
			icefang: ["1L1"],
			jawlock: ["1L1"],
			liquidation: ["1L1"],
			mudshot: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			revenge: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			shellsmash: ["1L1"],
			skittersmack: ["1L1"],
			skullbash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	drednaw: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			highhorsepower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icespinner: ["1L1"],
			irondefense: ["1L1"],
			irontail: ["1L1"],
			jawlock: ["1L1"],
			liquidation: ["1L1"],
			megahorn: ["1L1"],
			meteorbeam: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			revenge: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	yamper: {
		learnset: {
			attract: ["1L1"],
			bite: ["1L1"],
			charge: ["1L1"],
			charm: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			electroball: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			flamecharge: ["1L1"],
			helpinghand: ["1L1"],
			howl: ["1L1"],
			nuzzle: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	boltund: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bulkup: ["1L1"],
			charge: ["1L1"],
			charm: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electrify: ["1L1"],
			electroball: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			nuzzle: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rest: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	rolycoly: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			gyroball: ["1L1"],
			heatcrash: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			meteorbeam: ["1L1"],
			mudslap: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	carkol: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			burnup: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			gyroball: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			meteorbeam: ["1L1"],
			mudslap: ["1L1"],
			overheat: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scald: ["1L1"],
			scorchingsands: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	coalossal: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			burnup: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			meteorbeam: ["1L1"],
			mudslap: ["1L1"],
			overheat: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scald: ["1L1"],
			scorchingsands: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			tarshot: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	applin: {
		learnset: {
			astonish: ["1L1"],
			attract: ["1L1"],
			defensecurl: ["1L1"],
			dracometeor: ["1L1"],
			grassyglide: ["1L1"],
			pounce: ["1L1"],
			recycle: ["1L1"],
			rollout: ["1L1"],
			suckerpunch: ["1L1"],
			terablast: ["1L1"],
			withdraw: ["1L1"],
		},
	},
	flapple: {
		learnset: {
			acidspray: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			airslash: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bulletseed: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dualwingbeat: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			gravapple: ["1L1"],
			growth: ["1L1"],
			heavyslam: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			outrage: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			trailblaze: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			wingattack: ["1L1"],
			withdraw: ["1L1"],
		},
	},
	appletun: {
		learnset: {
			amnesia: ["1L1"],
			appleacid: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			curse: ["1L1"],
			dracometeor: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			sweetscent: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			trailblaze: ["1L1"],
			withdraw: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	silicobra: {
		learnset: {
			attract: ["1L1"],
			belch: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			coil: ["1L1"],
			dig: ["1L1"],
			dragonrush: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			glare: ["1L1"],
			headbutt: ["1L1"],
			lastresort: ["1L1"],
			minimize: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			skittersmack: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			wrap: ["1L1"],
		},
	},
	sandaconda: {
		learnset: {
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			coil: ["1L1"],
			dig: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			gigaimpact: ["1L1"],
			glare: ["1L1"],
			headbutt: ["1L1"],
			highhorsepower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			minimize: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			outrage: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			skittersmack: ["1L1"],
			skullbash: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			wrap: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	cramorant: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			amnesia: ["1L1"],
			aquacutter: ["1L1"],
			aquaring: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			blizzard: ["1L1"],
			bravebird: ["1L1"],
			chillingwater: ["1L1"],
			defog: ["1L1"],
			dive: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			steelwing: ["1L1"],
			stockpile: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swallow: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			uproar: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	arrokuda: {
		learnset: {
			acupressure: ["1L1"],
			agility: ["1L1"],
			aquajet: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			crunch: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			drillrun: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			furyattack: ["1L1"],
			hydropump: ["1L1"],
			icefang: ["1L1"],
			laserfocus: ["1L1"],
			liquidation: ["1L1"],
			nightslash: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	barraskewda: {
		learnset: {
			agility: ["1L1"],
			aquajet: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			crunch: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			drillrun: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			laserfocus: ["1L1"],
			liquidation: ["1L1"],
			peck: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	toxel: {
		learnset: {
			acid: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			charm: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			growl: ["1L1"],
			metalsound: ["1L1"],
			nuzzle: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 1, isHidden: true, moves: ["1L1"], pokeball: "luxuryball"},
		],
	},
	toxtricity: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			boomburst: ["1L1"],
			brickbreak: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			discharge: ["1L1"],
			drainpunch: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			leer: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalsound: ["1L1"],
			metronome: ["1L1"],
			nobleroar: ["1L1"],
			nuzzle: ["1L1"],
			overdrive: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			psychicnoise: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			shiftgear: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 50, shiny: true, nature: "Rash", abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	toxtricitylowkey: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			attract: ["1L1"],
			belch: ["1L1"],
			boomburst: ["1L1"],
			brickbreak: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			discharge: ["1L1"],
			drainpunch: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			leer: ["1L1"],
			magneticflux: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalsound: ["1L1"],
			metronome: ["1L1"],
			nobleroar: ["1L1"],
			nuzzle: ["1L1"],
			overdrive: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			psychicnoise: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	sizzlipede: {
		learnset: {
			attract: ["1L1"],
			bite: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			burnup: ["1L1"],
			coil: ["1L1"],
			crunch: ["1L1"],
			defensecurl: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firelash: ["1L1"],
			firespin: ["1L1"],
			flamewheel: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scorchingsands: ["1L1"],
			skittersmack: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			venoshock: ["1L1"],
			wrap: ["1L1"],
		},
	},
	centiskorch: {
		learnset: {
			attract: ["1L1"],
			bite: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			burnup: ["1L1"],
			coil: ["1L1"],
			crunch: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firelash: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			gigaimpact: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			hyperbeam: ["1L1"],
			inferno: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			mysticalfire: ["1L1"],
			overheat: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scorchingsands: ["1L1"],
			skittersmack: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			thunderfang: ["1L1"],
			venoshock: ["1L1"],
			willowisp: ["1L1"],
			wrap: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	clobbopus: {
		learnset: {
			attract: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bulkup: ["1L1"],
			circlethrow: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			detect: ["1L1"],
			dive: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			focusblast: ["1L1"],
			icepunch: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			megapunch: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			seismictoss: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			soak: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			superpower: ["1L1"],
			taunt: ["1L1"],
			waterfall: ["1L1"],
			workup: ["1L1"],
		},
	},
	grapploct: {
		learnset: {
			attract: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			drainpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			focusblast: ["1L1"],
			gigaimpact: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			megapunch: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			octazooka: ["1L1"],
			octolock: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			taunt: ["1L1"],
			topsyturvy: ["1L1"],
			waterfall: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
	},
	sinistea: {
		learnset: {
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			astonish: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			foulplay: ["1L1"],
			gigadrain: ["1L1"],
			hex: ["1L1"],
			imprison: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			metronome: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			shadowball: ["1L1"],
			shellsmash: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sweetscent: ["1L1"],
			terablast: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			withdraw: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	sinisteaantique: {
		learnset: {
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			astonish: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			celebrate: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			foulplay: ["1L1"],
			gigadrain: ["1L1"],
			hex: ["1L1"],
			imprison: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			metronome: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			rest: ["1L1"],
			shadowball: ["1L1"],
			shellsmash: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sweetscent: ["1L1"],
			terablast: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			withdraw: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 50, isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	polteageist: {
		learnset: {
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			astonish: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			foulplay: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			metronome: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shellsmash: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			strengthsap: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sweetscent: ["1L1"],
			teatime: ["1L1"],
			terablast: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			willowisp: ["1L1"],
			withdraw: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	hatenna: {
		learnset: {
			afteryou: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confusion: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			imprison: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			metronome: ["1L1"],
			mistyterrain: ["1L1"],
			mysticalfire: ["1L1"],
			nuzzle: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quash: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
		},
	},
	hattrem: {
		learnset: {
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			brutalswing: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confusion: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			imprison: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			metronome: ["1L1"],
			mistyterrain: ["1L1"],
			mysticalfire: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
		},
	},
	hatterene: {
		learnset: {
			agility: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			brutalswing: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			confusion: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magicpowder: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			mysticalfire: ["1L1"],
			painsplit: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			powerswap: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	impidimp: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			burningjealousy: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			lashout: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mistyterrain: ["1L1"],
			nastyplot: ["1L1"],
			partingshot: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
		},
	},
	morgrem: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			burningjealousy: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			falsesurrender: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			imprison: ["1L1"],
			lashout: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mistyterrain: ["1L1"],
			nastyplot: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
		},
	},
	grimmsnarl: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			burningjealousy: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkestlariat: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			falsesurrender: ["1L1"],
			firepunch: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			hammerarm: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			lashout: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mistyterrain: ["1L1"],
			nastyplot: ["1L1"],
			playrough: ["1L1"],
			powerswap: ["1L1"],
			poweruppunch: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spiritbreak: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			wonderroom: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 50, nature: "Calm", shiny: true, abilities: ["1L1"], ivs: {hp: 31, atk: 0, def: 31, spa: 31, spd: 31, spe: 31}, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	milcery: {
		learnset: {
			acidarmor: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			attract: ["1L1"],
			babydolleyes: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			dazzlinggleam: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			helpinghand: ["1L1"],
			lastresort: ["1L1"],
			mistyterrain: ["1L1"],
			protect: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sweetkiss: ["1L1"],
			sweetscent: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 5, nature: "Hardy", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	alcremie: {
		learnset: {
			acidarmor: ["1L1"],
			alluringvoice: ["1L1"],
			aromatherapy: ["1L1"],
			aromaticmist: ["1L1"],
			attract: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			dazzlinggleam: ["1L1"],
			decorate: ["1L1"],
			disarmingvoice: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fling: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			mysticalfire: ["1L1"],
			painsplit: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sweetkiss: ["1L1"],
			sweetscent: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			triattack: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	falinks: {
		learnset: {
			agility: ["1L1"],
			assurance: ["1L1"],
			beatup: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			counter: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			firstimpression: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			lunge: ["1L1"],
			megahorn: ["1L1"],
			noretreat: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	pincurchin: {
		learnset: {
			acupressure: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bubblebeam: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			curse: ["1L1"],
			discharge: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			hex: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			liquidation: ["1L1"],
			memento: ["1L1"],
			muddywater: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			spikes: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			supercellslam: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			watergun: ["1L1"],
			wildcharge: ["1L1"],
			zingzap: ["1L1"],
		},
	},
	snom: {
		learnset: {
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			lunge: ["1L1"],
			mirrorcoat: ["1L1"],
			pounce: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			terablast: ["1L1"],
		},
	},
	frosmoth: {
		learnset: {
			acrobatics: ["1L1"],
			airslash: ["1L1"],
			attract: ["1L1"],
			aurorabeam: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			helpinghand: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			mist: ["1L1"],
			playrough: ["1L1"],
			pounce: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			quiverdance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			strugglebug: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			tripleaxel: ["1L1"],
			uturn: ["1L1"],
			weatherball: ["1L1"],
			wideguard: ["1L1"],
		},
	},
	stonjourner: {
		learnset: {
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			curse: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			hardpress: ["1L1"],
			heatcrash: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			meteorbeam: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			wideguard: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	eiscue: {
		learnset: {
			agility: ["1L1"],
			amnesia: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			bellydrum: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			chillingwater: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			flipturn: ["1L1"],
			freezedry: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			liquidation: ["1L1"],
			mist: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			soak: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	indeedee: {
		learnset: {
			afteryou: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			futuresight: ["1L1"],
			gravity: ["1L1"],
			healingwish: ["1L1"],
			helpinghand: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			lastresort: ["1L1"],
			magicalleaf: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mysticalfire: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			powersplit: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	indeedeef: {
		learnset: {
			alluringvoice: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			followme: ["1L1"],
			futuresight: ["1L1"],
			guardsplit: ["1L1"],
			guardswap: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			metronome: ["1L1"],
			mysticalfire: ["1L1"],
			payday: ["1L1"],
			playnice: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 75, shiny: 1, perfectIVs: 4, moves: ["1L1"]},
		],
	},
	morpeko: {
		learnset: {
			agility: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			aurawheel: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			brickbreak: ["1L1"],
			bulletseed: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			doubleedge: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			firefang: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			icefang: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			partingshot: ["1L1"],
			payback: ["1L1"],
			powertrip: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			quash: ["1L1"],
			quickattack: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spark: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	cufant: {
		learnset: {
			attract: ["1L1"],
			belch: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			growl: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			megakick: ["1L1"],
			mudshot: ["1L1"],
			playrough: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			screech: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			whirlwind: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	copperajah: {
		learnset: {
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hardpress: ["1L1"],
			heatcrash: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			megakick: ["1L1"],
			mudshot: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			revenge: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			supercellslam: ["1L1"],
			superpower: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	dracozolt: {
		learnset: {
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			bodyslam: ["1L1"],
			boltbeak: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			charge: ["1L1"],
			discharge: ["1L1"],
			dracometeor: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			electroball: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			gigaimpact: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irontail: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			meteorbeam: ["1L1"],
			outrage: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			risingvoltage: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			wildcharge: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 10, shiny: 1, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	arctozolt: {
		learnset: {
			ancientpower: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			boltbeak: ["1L1"],
			bulldoze: ["1L1"],
			charge: ["1L1"],
			discharge: ["1L1"],
			echoedvoice: ["1L1"],
			electroball: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			freezedry: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			meteorbeam: ["1L1"],
			payback: ["1L1"],
			pluck: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			risingvoltage: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			taunt: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			wildcharge: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 10, shiny: 1, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	dracovish: {
		learnset: {
			ancientpower: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			crunch: ["1L1"],
			dive: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fishiousrend: ["1L1"],
			gigaimpact: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			ironhead: ["1L1"],
			leechlife: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			megakick: ["1L1"],
			meteorbeam: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			tackle: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 10, shiny: 1, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 8, level: 80, nature: "Naive", abilities: ["1L1"], ivs: {hp: 30, atk: 31, def: 31, spa: 30, spd: 30, spe: 31}, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	arctovish: {
		learnset: {
			ancientpower: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			crunch: ["1L1"],
			dive: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fishiousrend: ["1L1"],
			freezedry: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			liquidation: ["1L1"],
			meteorbeam: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			superfang: ["1L1"],
			surf: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 10, shiny: 1, perfectIVs: 3, moves: ["1L1"], pokeball: "pokeball"},
		],
		eventOnly: false,
	},
	duraludon: {
		learnset: {
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			darkpulse: ["1L1"],
			doubleedge: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			focusenergy: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			heavyslam: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			laserfocus: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			mirrorcoat: ["1L1"],
			nightslash: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
		},
	},
	dreepy: {
		learnset: {
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			grudge: ["1L1"],
			helpinghand: ["1L1"],
			infestation: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swift: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
		},
	},
	drakloak: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			breakingswipe: ["1L1"],
			brine: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hydropump: ["1L1"],
			infestation: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			nightshade: ["1L1"],
			outrage: ["1L1"],
			phantomforce: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			quickattack: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	dragapult: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brine: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragondarts: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			fly: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			nightshade: ["1L1"],
			outrage: ["1L1"],
			phantomforce: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			quickattack: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			triattack: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 50, gender: "M", nature: "Jolly", perfectIVs: 6, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	zacian: {
		learnset: {
			agility: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			closecombat: ["1L1"],
			crunch: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			firefang: ["1L1"],
			flashcannon: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			metalclaw: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			nobleroar: ["1L1"],
			playrough: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			psychocut: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			sacredsword: ["1L1"],
			scaryface: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarblade: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailslap: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 70, perfectIVs: 3, moves: ["1L1"]},
			{generation: 8, level: 100, shiny: true, nature: "Adamant", ivs: {hp: 31, atk: 31, def: 31, spa: 30, spd: 31, spe: 31}, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	zaciancrowned: {
		learnset: {
			behemothblade: ["1L1"],
		},
		eventOnly: false,
	},
	zamazenta: {
		learnset: {
			agility: ["1L1"],
			bite: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			crunch: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			flashcannon: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			guardswap: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			moonblast: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			steelbeam: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			tailslap: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			trailblaze: ["1L1"],
			wideguard: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 70, perfectIVs: 3, moves: ["1L1"]},
			{generation: 8, level: 100, shiny: true, nature: "Adamant", ivs: {hp: 31, atk: 31, def: 31, spa: 30, spd: 31, spe: 31}, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	zamazentacrowned: {
		learnset: {
			behemothbash: ["1L1"],
		},
		eventOnly: false,
	},
	eternatus: {
		learnset: {
			agility: ["1L1"],
			assurance: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			confuseray: ["1L1"],
			cosmicpower: ["1L1"],
			crosspoison: ["1L1"],
			dracometeor: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dynamaxcannon: ["1L1"],
			endure: ["1L1"],
			eternabeam: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			gunkshot: ["1L1"],
			hyperbeam: ["1L1"],
			lightscreen: ["1L1"],
			meteorbeam: ["1L1"],
			mysticalfire: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 60, perfectIVs: 3, moves: ["1L1"]},
			{generation: 8, level: 100, shiny: true, nature: "Timid", perfectIVs: 6, moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	kubfu: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			counter: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			icepunch: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 10, perfectIVs: 3, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	urshifu: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			beatup: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			darkestlariat: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			payback: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			superpower: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			wickedblow: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	urshifurapidstrike: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aquajet: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bulkup: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			counter: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			drainpunch: ["1L1"],
			dynamicpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surgingstrikes: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	zarude: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			assurance: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulletseed: ["1L1"],
			closecombat: ["1L1"],
			crunch: ["1L1"],
			darkestlariat: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			drainpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			hammerarm: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			junglehealing: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leafstorm: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudshot: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			petalblizzard: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			vinewhip: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 60, nature: "Sassy", moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	zarudedada: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			assurance: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulletseed: ["1L1"],
			closecombat: ["1L1"],
			crunch: ["1L1"],
			darkestlariat: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			drainpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			furyswipes: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			hammerarm: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			junglehealing: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leafstorm: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			mudshot: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			petalblizzard: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			vinewhip: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 70, nature: "Adamant", moves: ["1L1"], pokeball: "cherishball"},
		],
		eventOnly: false,
	},
	regieleki: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			ancientpower: ["1L1"],
			assurance: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			hyperbeam: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			magnetrise: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			selfdestruct: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			supercellslam: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundercage: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	regidrago: {
		learnset: {
			ancientpower: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			crunch: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonenergy: ["1L1"],
			dragonpulse: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			hammerarm: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			laserfocus: ["1L1"],
			lightscreen: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunderfang: ["1L1"],
			twister: ["1L1"],
			visegrip: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 70, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	glastrier: {
		learnset: {
			assurance: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			lashout: ["1L1"],
			megahorn: ["1L1"],
			mist: ["1L1"],
			mudshot: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 75, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	spectrier: {
		learnset: {
			agility: ["1L1"],
			assurance: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			haze: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			lashout: ["1L1"],
			mudshot: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychocut: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 75, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	calyrex: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			batonpass: ["1L1"],
			bodypress: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			confusion: ["1L1"],
			drainingkiss: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			growth: ["1L1"],
			guardswap: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magicroom: ["1L1"],
			megadrain: ["1L1"],
			metronome: ["1L1"],
			mudshot: ["1L1"],
			payday: ["1L1"],
			pollenpuff: ["1L1"],
			pound: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			speedswap: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 80, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	calyrexice: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			assurance: ["1L1"],
			avalanche: ["1L1"],
			batonpass: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			confusion: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			drainingkiss: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			glaciallance: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			growth: ["1L1"],
			guardswap: ["1L1"],
			hail: ["1L1"],
			healpulse: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			lashout: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magicroom: ["1L1"],
			megadrain: ["1L1"],
			megahorn: ["1L1"],
			metronome: ["1L1"],
			mist: ["1L1"],
			mudshot: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			pollenpuff: ["1L1"],
			pound: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			speedswap: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			torment: ["1L1"],
			trailblaze: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 80, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	calyrexshadow: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			aromatherapy: ["1L1"],
			assurance: ["1L1"],
			astralbarrage: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			calmmind: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			drainingkiss: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			foulplay: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			growth: ["1L1"],
			guardswap: ["1L1"],
			haze: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			lashout: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magicroom: ["1L1"],
			megadrain: ["1L1"],
			metronome: ["1L1"],
			mudshot: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			phantomforce: ["1L1"],
			pollenpuff: ["1L1"],
			pound: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			speedswap: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			triattack: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 80, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	enamorus: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			astonish: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			drainingkiss: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			flatter: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			healingwish: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			mysticalfire: ["1L1"],
			outrage: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			springtidestorm: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			torment: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			weatherball: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	enamorustherian: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			astonish: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			drainingkiss: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			flatter: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			healingwish: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			mysticalfire: ["1L1"],
			outrage: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			springtidestorm: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			torment: ["1L1"],
			twister: ["1L1"],
			uproar: ["1L1"],
			weatherball: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	sprigatito: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			bite: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			copycat: ["1L1"],
			disarmingvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			helpinghand: ["1L1"],
			honeclaws: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			petalblizzard: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			scratch: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	floragato: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			bite: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			disarmingvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fling: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			helpinghand: ["1L1"],
			honeclaws: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			petalblizzard: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			scratch: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	meowscarada: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aurasphere: ["1L1"],
			bite: ["1L1"],
			brickbreak: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			darkpulse: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleteam: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fling: ["1L1"],
			flowertrick: ["1L1"],
			foulplay: ["1L1"],
			frenzyplant: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			helpinghand: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			nightslash: ["1L1"],
			petalblizzard: ["1L1"],
			playrough: ["1L1"],
			pollenpuff: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			scratch: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			skillswap: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			tripleaxel: ["1L1"],
			uturn: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	fuecoco: {
		learnset: {
			belch: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			leer: ["1L1"],
			mudslap: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			seedbomb: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			willowisp: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	crocalor: {
		learnset: {
			bite: ["1L1"],
			bodyslam: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			mudslap: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			willowisp: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	skeledirge: {
		learnset: {
			alluringvoice: ["1L1"],
			bite: ["1L1"],
			blastburn: ["1L1"],
			bodyslam: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			gigaimpact: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			incinerate: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			mudslap: ["1L1"],
			nightshade: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			torchsong: ["1L1"],
			willowisp: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	quaxly: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aquacutter: ["1L1"],
			aquajet: ["1L1"],
			batonpass: ["1L1"],
			bravebird: ["1L1"],
			chillingwater: ["1L1"],
			detect: ["1L1"],
			disarmingvoice: ["1L1"],
			doublehit: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			focusenergy: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hydropump: ["1L1"],
			lastresort: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			mistyterrain: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			roost: ["1L1"],
			sleeptalk: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			whirlpool: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
	},
	quaxwell: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aquacutter: ["1L1"],
			aquajet: ["1L1"],
			batonpass: ["1L1"],
			bravebird: ["1L1"],
			chillingwater: ["1L1"],
			disarmingvoice: ["1L1"],
			doublehit: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hydropump: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			mistyterrain: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			sleeptalk: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			tripleaxel: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
	},
	quaquaval: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aquacutter: ["1L1"],
			aquajet: ["1L1"],
			aquastep: ["1L1"],
			batonpass: ["1L1"],
			bravebird: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			counter: ["1L1"],
			disarmingvoice: ["1L1"],
			doublehit: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hurricane: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			megakick: ["1L1"],
			mistyterrain: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			sleeptalk: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			tripleaxel: ["1L1"],
			upperhand: ["1L1"],
			uturn: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			whirlpool: ["1L1"],
			wingattack: ["1L1"],
			workup: ["1L1"],
		},
	},
	lechonk: {
		learnset: {
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			chillingwater: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hypervoice: ["1L1"],
			ironhead: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			stuffcheeks: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swallow: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 15, gender: "M", isHidden: true, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	oinkologne: {
		learnset: {
			belch: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			chillingwater: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			ironhead: ["1L1"],
			lashout: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	oinkolognef: {
		learnset: {
			belch: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			chillingwater: ["1L1"],
			covet: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			ironhead: ["1L1"],
			lashout: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	tarountula: {
		learnset: {
			assurance: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulletseed: ["1L1"],
			circlethrow: ["1L1"],
			counter: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			firstimpression: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			memento: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			spikes: ["1L1"],
			stickyweb: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	spidops: {
		learnset: {
			aerialace: ["1L1"],
			assurance: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulletseed: ["1L1"],
			circlethrow: ["1L1"],
			counter: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			fling: ["1L1"],
			gastroacid: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			headbutt: ["1L1"],
			knockoff: ["1L1"],
			leechlife: ["1L1"],
			lowkick: ["1L1"],
			lunge: ["1L1"],
			painsplit: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rocktomb: ["1L1"],
			scaryface: ["1L1"],
			shadowclaw: ["1L1"],
			silktrap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			spikes: ["1L1"],
			stickyweb: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			upperhand: ["1L1"],
			uturn: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	nymble: {
		learnset: {
			agility: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			counter: ["1L1"],
			doublekick: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			firstimpression: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			screech: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	lokix: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			axekick: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			darkpulse: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			firstimpression: ["1L1"],
			fling: ["1L1"],
			gigaimpact: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			lunge: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			spite: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	rellor: {
		learnset: {
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			cosmicpower: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			gunkshot: ["1L1"],
			irondefense: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			memento: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			sandattack: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			weatherball: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	rabsca: {
		learnset: {
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			earthpower: ["1L1"],
			electroball: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			guardswap: ["1L1"],
			gunkshot: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			leechlife: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			poltergeist: ["1L1"],
			pounce: ["1L1"],
			powergem: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			revivalblessing: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			safeguard: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			speedswap: ["1L1"],
			storedpower: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			weatherball: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	greavard: {
		learnset: {
			allyswitch: ["1L1"],
			bite: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			destinybond: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			howl: ["1L1"],
			icefang: ["1L1"],
			lick: ["1L1"],
			memento: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			playrough: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			shadowsneak: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			yawn: ["1L1"],
		},
	},
	houndstone: {
		learnset: {
			bite: ["1L1"],
			bodypress: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			lastrespects: ["1L1"],
			lick: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			playrough: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	flittle: {
		learnset: {
			agility: ["1L1"],
			allyswitch: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			disarmingvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			foulplay: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hypnosis: ["1L1"],
			lightscreen: ["1L1"],
			mudslap: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psyshock: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			roost: ["1L1"],
			sandstorm: ["1L1"],
			seedbomb: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	espathra: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			calmmind: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			drillpeck: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			flashcannon: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			lastresort: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			luminacrash: ["1L1"],
			mudslap: ["1L1"],
			nightshade: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			sandstorm: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	farigiraf: {
		learnset: {
			agility: ["1L1"],
			amnesia: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			foulplay: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			guardswap: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			ironhead: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicfangs: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			twinbeam: ["1L1"],
			uproar: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	wiglett: {
		learnset: {
			agility: ["1L1"],
			aquajet: ["1L1"],
			blizzard: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			dig: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			foulplay: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			liquidation: ["1L1"],
			memento: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wrap: ["1L1"],
		},
	},
	wugtrio: {
		learnset: {
			agility: ["1L1"],
			aquajet: ["1L1"],
			blizzard: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			dig: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			liquidation: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			painsplit: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			tripledive: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wrap: ["1L1"],
		},
	},
	dondozo: {
		learnset: {
			aquatail: ["1L1"],
			avalanche: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			chillingwater: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			gigaimpact: ["1L1"],
			heavyslam: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			liquidation: ["1L1"],
			nobleroar: ["1L1"],
			orderup: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			soak: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			tickle: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			yawn: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	veluza: {
		learnset: {
			agility: ["1L1"],
			aquacutter: ["1L1"],
			aquajet: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			chillingwater: ["1L1"],
			crunch: ["1L1"],
			doubleedge: ["1L1"],
			drillrun: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			filletaway: ["1L1"],
			finalgambit: ["1L1"],
			flipturn: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			nightslash: ["1L1"],
			painsplit: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicfangs: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			scaleshot: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snowscape: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	finizen: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			astonish: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			boomburst: ["1L1"],
			bounce: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			counter: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doublehit: ["1L1"],
			drainingkiss: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			liquidation: ["1L1"],
			mist: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			sleeptalk: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			tickle: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	palafin: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			aquajet: ["1L1"],
			aquatail: ["1L1"],
			astonish: ["1L1"],
			aurasphere: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			bulkup: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			disarmingvoice: ["1L1"],
			dive: ["1L1"],
			doublehit: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			hardpress: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			jetpunch: ["1L1"],
			liquidation: ["1L1"],
			mist: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			sleeptalk: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			whirlpool: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 50, gender: "F", nature: "Adamant", ivs: {hp: 31, atk: 31, def: 31, spa: 17, spd: 31, spe: 31}, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	smoliv: {
		learnset: {
			absorb: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			strengthsap: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			trailblaze: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	dolliv: {
		learnset: {
			absorb: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			trailblaze: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	arboliva: {
		learnset: {
			absorb: ["1L1"],
			alluringvoice: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			dazzlinggleam: ["1L1"],
			earthpower: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			metronome: ["1L1"],
			mirrorcoat: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			razorleaf: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			safeguard: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			trailblaze: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	capsakid: {
		learnset: {
			bite: ["1L1"],
			bulletseed: ["1L1"],
			crunch: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			ingrain: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			magicalleaf: ["1L1"],
			protect: ["1L1"],
			ragepowder: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			rollout: ["1L1"],
			sandstorm: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	scovillain: {
		learnset: {
			bite: ["1L1"],
			bulletseed: ["1L1"],
			burningjealousy: ["1L1"],
			crunch: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			flamethrower: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			lashout: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			leer: ["1L1"],
			magicalleaf: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spicyextract: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
			willowisp: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	tadbulb: {
		learnset: {
			acidspray: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confuseray: ["1L1"],
			discharge: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			flail: ["1L1"],
			hypervoice: ["1L1"],
			lightscreen: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			paraboliccharge: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			sleeptalk: ["1L1"],
			soak: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			voltswitch: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	bellibolt: {
		learnset: {
			acidspray: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confuseray: ["1L1"],
			discharge: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			flail: ["1L1"],
			gigaimpact: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			lightscreen: ["1L1"],
			muddywater: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			supercellslam: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	varoom: {
		learnset: {
			acidspray: ["1L1"],
			assurance: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lick: ["1L1"],
			metalsound: ["1L1"],
			partingshot: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			spinout: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	revavroom: {
		learnset: {
			acidspray: ["1L1"],
			assurance: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			gyroball: ["1L1"],
			hardpress: ["1L1"],
			haze: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lashout: ["1L1"],
			lick: ["1L1"],
			magnetrise: ["1L1"],
			metalsound: ["1L1"],
			overheat: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			shiftgear: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			spinout: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uproar: ["1L1"],
			venoshock: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 50, gender: "F", nature: "Naughty", abilities: ["1L1"], ivs: {hp: 20, atk: 31, def: 20, spa: 20, spd: 20, spe: 20}, moves: ["1L1"], pokeball: "healball"},
		],
	},
	orthworm: {
		learnset: {
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			coil: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			metalburst: ["1L1"],
			metalsound: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			shedtail: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			wrap: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 29, gender: "M", nature: "Quirky", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, moves: ["1L1"]},
		],
	},
	tandemaus: {
		learnset: {
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			agility: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			bite: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			copycat: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hypervoice: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			playrough: ["1L1"],
			populationbomb: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swift: ["1L1"],
			switcheroo: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			tickle: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	maushold: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			copycat: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			echoedvoice: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			followme: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			playrough: ["1L1"],
			populationbomb: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			seedbomb: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
			tidyup: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	cetoddle: {
		learnset: {
			amnesia: ["1L1"],
			avalanche: ["1L1"],
			bellydrum: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			growl: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			playrough: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			sleeptalk: ["1L1"],
			snowscape: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			waterpulse: ["1L1"],
			yawn: ["1L1"],
		},
	},
	cetitan: {
		learnset: {
			amnesia: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hardpress: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			liquidation: ["1L1"],
			playrough: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			sleeptalk: ["1L1"],
			snowscape: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			waterpulse: ["1L1"],
		},
		eventData: [
			{generation: 9, moves: ["1L1"]},
		],
	},
	frigibax: {
		learnset: {
			aquatail: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			focusenergy: ["1L1"],
			freezedry: ["1L1"],
			helpinghand: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			leer: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			sleeptalk: ["1L1"],
			snowscape: ["1L1"],
			substitute: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
		},
	},
	arctibax: {
		learnset: {
			aerialace: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			focusenergy: ["1L1"],
			helpinghand: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snowscape: ["1L1"],
			substitute: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
		},
	},
	baxcalibur: {
		learnset: {
			aerialace: ["1L1"],
			avalanche: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			glaiverush: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			iceshard: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snowscape: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	tatsugiri: {
		learnset: {
			batonpass: ["1L1"],
			chillingwater: ["1L1"],
			counter: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			harden: ["1L1"],
			helpinghand: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			lunge: ["1L1"],
			memento: ["1L1"],
			mirrorcoat: ["1L1"],
			muddywater: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			sleeptalk: ["1L1"],
			soak: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 57, gender: "M", nature: "Quiet", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, moves: ["1L1"]},
		],
	},
	tatsugiristretchy: {
		learnset: {
			celebrate: ["1L1"],
			dracometeor: ["1L1"],
			helpinghand: ["1L1"],
			muddywater: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	cyclizar: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aquatail: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			crunch: ["1L1"],
			doubleedge: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icespinner: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			scaleshot: ["1L1"],
			shedtail: ["1L1"],
			shiftgear: ["1L1"],
			sleeptalk: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	pawmi: {
		learnset: {
			agility: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			celebrate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			fling: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			machpunch: ["1L1"],
			metalclaw: ["1L1"],
			nuzzle: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			scratch: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			sweetkiss: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 5, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	pawmo: {
		learnset: {
			agility: ["1L1"],
			armthrust: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			coaching: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			knockoff: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metalclaw: ["1L1"],
			nuzzle: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			scratch: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			upperhand: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	pawmot: {
		learnset: {
			agility: ["1L1"],
			armthrust: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			bodypress: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			doubleshock: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			knockoff: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metalclaw: ["1L1"],
			metronome: ["1L1"],
			nuzzle: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			revivalblessing: ["1L1"],
			rocktomb: ["1L1"],
			scratch: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			superfang: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			upperhand: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	wattrel: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			bravebird: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			discharge: ["1L1"],
			dualwingbeat: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			growl: ["1L1"],
			hurricane: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			roost: ["1L1"],
			sleeptalk: ["1L1"],
			spark: ["1L1"],
			spitup: ["1L1"],
			stockpile: ["1L1"],
			substitute: ["1L1"],
			swallow: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	kilowattrel: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			bravebird: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			discharge: ["1L1"],
			dualwingbeat: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			roost: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			supercellslam: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	bombirdier: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			bravebird: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			drillrun: ["1L1"],
			dualwingbeat: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			fly: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			heatwave: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			partingshot: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			powergem: ["1L1"],
			powertrip: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wingattack: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 20, gender: "F", nature: "Jolly", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, isHidden: true, moves: ["1L1"]},
		],
	},
	squawkabilly: {
		learnset: {
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			bravebird: ["1L1"],
			copycat: ["1L1"],
			doubleedge: ["1L1"],
			dualwingbeat: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			featherdance: ["1L1"],
			finalgambit: ["1L1"],
			flatter: ["1L1"],
			fly: ["1L1"],
			foulplay: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			lashout: ["1L1"],
			mimic: ["1L1"],
			partingshot: ["1L1"],
			peck: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			roost: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
		},
	},
	flamigo: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			bravebird: ["1L1"],
			bulkup: ["1L1"],
			chillingwater: ["1L1"],
			closecombat: ["1L1"],
			copycat: ["1L1"],
			detect: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			feint: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			lunge: ["1L1"],
			megakick: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			roost: ["1L1"],
			skyattack: ["1L1"],
			sleeptalk: ["1L1"],
			substitute: ["1L1"],
			swordsdance: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			upperhand: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			wideguard: ["1L1"],
			wingattack: ["1L1"],
		},
	},
	klawf: {
		learnset: {
			ancientpower: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			crabhammer: ["1L1"],
			dig: ["1L1"],
			earthpower: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flail: ["1L1"],
			fling: ["1L1"],
			gigaimpact: ["1L1"],
			guillotine: ["1L1"],
			harden: ["1L1"],
			helpinghand: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			metalclaw: ["1L1"],
			meteorbeam: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			trailblaze: ["1L1"],
			visegrip: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 16, gender: "F", nature: "Gentle", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, abilities: ["1L1"], moves: ["1L1"]},
		],
	},
	nacli: {
		learnset: {
			ancientpower: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			flashcannon: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			meteorbeam: ["1L1"],
			mudshot: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			sandstorm: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	naclstack: {
		learnset: {
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			harden: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			meteorbeam: ["1L1"],
			mudshot: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			saltcure: ["1L1"],
			sandstorm: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	garganacl: {
		learnset: {
			avalanche: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			firepunch: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			hammerarm: ["1L1"],
			harden: ["1L1"],
			hardpress: ["1L1"],
			headbutt: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			meteorbeam: ["1L1"],
			mudshot: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			saltcure: ["1L1"],
			sandstorm: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderpunch: ["1L1"],
			wideguard: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 50, gender: "M", nature: "Careful", ivs: {hp: 31, atk: 31, def: 31, spa: 22, spd: 31, spe: 31}, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	glimmet: {
		learnset: {
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			ancientpower: ["1L1"],
			confuseray: ["1L1"],
			dazzlinggleam: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			gunkshot: ["1L1"],
			harden: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			memento: ["1L1"],
			meteorbeam: ["1L1"],
			mudshot: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venoshock: ["1L1"],
		},
	},
	glimmora: {
		learnset: {
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			ancientpower: ["1L1"],
			confuseray: ["1L1"],
			dazzlinggleam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			harden: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			meteorbeam: ["1L1"],
			mortalspin: ["1L1"],
			mudshot: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			selfdestruct: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			spikyshield: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			venoshock: ["1L1"],
		},
	},
	shroodle: {
		learnset: {
			acidspray: ["1L1"],
			acrobatics: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			copycat: ["1L1"],
			crosspoison: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			furyswipes: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			metronome: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			partingshot: ["1L1"],
			poisonfang: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			scratch: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			switcheroo: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
		},
	},
	grafaiai: {
		learnset: {
			acidspray: ["1L1"],
			acrobatics: ["1L1"],
			batonpass: ["1L1"],
			dig: ["1L1"],
			doodle: ["1L1"],
			doubleedge: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metronome: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			poisonfang: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			shadowclaw: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			switcheroo: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	fidough: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			charm: ["1L1"],
			copycat: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			howl: ["1L1"],
			icefang: ["1L1"],
			lastresort: ["1L1"],
			lick: ["1L1"],
			mistyterrain: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			sweetscent: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			trailblaze: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 5, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	dachsbun: {
		learnset: {
			agility: ["1L1"],
			alluringvoice: ["1L1"],
			babydolleyes: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			charm: ["1L1"],
			covet: ["1L1"],
			crunch: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			drainingkiss: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			lastresort: ["1L1"],
			lick: ["1L1"],
			mistyterrain: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tackle: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			trailblaze: ["1L1"],
			workup: ["1L1"],
		},
	},
	maschiff: {
		learnset: {
			bite: ["1L1"],
			bodyslam: ["1L1"],
			charm: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			firefang: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			honeclaws: ["1L1"],
			icefang: ["1L1"],
			jawlock: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			trailblaze: ["1L1"],
		},
	},
	mabosstiff: {
		learnset: {
			bite: ["1L1"],
			bodyslam: ["1L1"],
			charm: ["1L1"],
			comeuppance: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			firefang: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			helpinghand: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			jawlock: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			lick: ["1L1"],
			outrage: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	bramblin: {
		learnset: {
			absorb: ["1L1"],
			astonish: ["1L1"],
			beatup: ["1L1"],
			block: ["1L1"],
			bulletseed: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			disable: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			hex: ["1L1"],
			infestation: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			megadrain: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			pounce: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			rollout: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowsneak: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			strengthsap: ["1L1"],
			substitute: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
		},
	},
	brambleghast: {
		learnset: {
			absorb: ["1L1"],
			astonish: ["1L1"],
			bulletseed: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			disable: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			leafstorm: ["1L1"],
			megadrain: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			pounce: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			rollout: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			trailblaze: ["1L1"],
		},
	},
	gimmighoul: {
		learnset: {
			astonish: ["1L1"],
			confuseray: ["1L1"],
			endure: ["1L1"],
			hex: ["1L1"],
			lightscreen: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			substitute: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 5, moves: ["1L1"]},
			{generation: 9, level: 75, shiny: 1, perfectIVs: 4, moves: ["1L1"]},
			{generation: 9, level: 5, nature: "Timid", ivs: {hp: 0, atk: 0, def: 0, spa: 0, spd: 0, spe: 31}, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	gholdengo: {
		learnset: {
			astonish: ["1L1"],
			chargebeam: ["1L1"],
			confuseray: ["1L1"],
			dazzlinggleam: ["1L1"],
			electroball: ["1L1"],
			endure: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			gigaimpact: ["1L1"],
			heavyslam: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			ironhead: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			makeitrain: ["1L1"],
			memento: ["1L1"],
			metalsound: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			poltergeist: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			sandstorm: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			steelbeam: ["1L1"],
			substitute: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			trick: ["1L1"],
		},
	},
	greattusk: {
		learnset: {
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			defensecurl: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			headlongrush: ["1L1"],
			headsmash: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hornattack: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			icespinner: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			megahorn: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psyshock: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 45, nature: "Naughty", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, moves: ["1L1"]},
			{generation: 9, level: 57, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	brutebonnet: {
		learnset: {
			absorb: ["1L1"],
			astonish: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			clearsmog: ["1L1"],
			closecombat: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			ingrain: ["1L1"],
			lashout: ["1L1"],
			leafstorm: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			pollenpuff: ["1L1"],
			protect: ["1L1"],
			ragepowder: ["1L1"],
			rest: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spore: ["1L1"],
			stompingtantrum: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			synthesis: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thrash: ["1L1"],
			trailblaze: ["1L1"],
			venoshock: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 52, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	sandyshocks: {
		learnset: {
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			discharge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			lightscreen: ["1L1"],
			magneticflux: ["1L1"],
			metalsound: ["1L1"],
			mirrorcoat: ["1L1"],
			mudshot: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			spark: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			supersonic: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			triattack: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 52, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	screamtail: {
		learnset: {
			amnesia: ["1L1"],
			batonpass: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			boomburst: ["1L1"],
			bulkup: ["1L1"],
			calmmind: ["1L1"],
			crunch: ["1L1"],
			dazzlinggleam: ["1L1"],
			dig: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			drainpunch: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gyroball: ["1L1"],
			helpinghand: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			nobleroar: ["1L1"],
			perishsong: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicfangs: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			sing: ["1L1"],
			sleeptalk: ["1L1"],
			snowscape: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			waterpulse: ["1L1"],
			wish: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 52, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	fluttermane: {
		learnset: {
			astonish: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confuseray: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			faketears: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			magicalleaf: ["1L1"],
			meanlook: ["1L1"],
			memento: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			mysticalfire: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			perishsong: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psyshock: ["1L1"],
			rest: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			trickroom: ["1L1"],
			wish: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 52, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	slitherwing: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulkup: ["1L1"],
			closecombat: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			dualwingbeat: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firstimpression: ["1L1"],
			flamecharge: ["1L1"],
			flareblitz: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			leechlife: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			lunge: ["1L1"],
			morningsun: ["1L1"],
			poisonpowder: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			sandstorm: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			whirlwind: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 52, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	roaringmoon: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			airslash: ["1L1"],
			bite: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamethrower: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			heatwave: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			jawlock: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			metalclaw: ["1L1"],
			nightslash: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			roost: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			uturn: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 52, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	irontreads: {
		learnset: {
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			defensecurl: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			hardpress: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hornattack: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			icespinner: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			megahorn: ["1L1"],
			metalsound: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			supercellslam: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderfang: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 45, nature: "Naughty", ivs: {hp: 30, atk: 30, def: 30, spa: 30, spd: 30, spe: 30}, moves: ["1L1"]},
			{generation: 9, level: 57, shiny: 1, moves: ["1L1"]},
		],
	},
	ironmoth: {
		learnset: {
			acidspray: ["1L1"],
			acrobatics: ["1L1"],
			agility: ["1L1"],
			airslash: ["1L1"],
			bugbuzz: ["1L1"],
			chargebeam: ["1L1"],
			confuseray: ["1L1"],
			dazzlinggleam: ["1L1"],
			discharge: ["1L1"],
			electricterrain: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fierydance: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			morningsun: ["1L1"],
			overheat: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			rest: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			sludgewave: ["1L1"],
			solarbeam: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			whirlwind: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 52, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	ironhands: {
		learnset: {
			armthrust: ["1L1"],
			bellydrum: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			charge: ["1L1"],
			closecombat: ["1L1"],
			detect: ["1L1"],
			doubleedge: ["1L1"],
			drainpunch: ["1L1"],
			earthquake: ["1L1"],
			electricterrain: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			gigaimpact: ["1L1"],
			hardpress: ["1L1"],
			heavyslam: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metronome: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			sandattack: ["1L1"],
			scaryface: ["1L1"],
			seismictoss: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			supercellslam: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			voltswitch: ["1L1"],
			whirlwind: ["1L1"],
			wildcharge: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 52, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	ironjugulis: {
		learnset: {
			acrobatics: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			bodyslam: ["1L1"],
			chargebeam: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			doubleedge: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			electricterrain: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			flamethrower: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			gigaimpact: ["1L1"],
			heatwave: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			rocktomb: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			triattack: ["1L1"],
			uturn: ["1L1"],
			workup: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 52, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	ironthorns: {
		learnset: {
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			gigaimpact: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lowkick: ["1L1"],
			metalclaw: ["1L1"],
			meteorbeam: ["1L1"],
			pinmissile: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockslide: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 52, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	ironbundle: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			auroraveil: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			chillingwater: ["1L1"],
			drillpeck: ["1L1"],
			electricterrain: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			freezedry: ["1L1"],
			gigaimpact: ["1L1"],
			helpinghand: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			playrough: ["1L1"],
			powdersnow: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			sleeptalk: ["1L1"],
			snowscape: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 52, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	ironvaliant: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			aurasphere: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			chargebeam: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confuseray: ["1L1"],
			dazzlinggleam: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			electricterrain: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			falseswipe: ["1L1"],
			feint: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			furycutter: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			hypnosis: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			leafblade: ["1L1"],
			lightscreen: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			magicalleaf: ["1L1"],
			metronome: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			nightslash: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			quickguard: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			spiritbreak: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			vacuumwave: ["1L1"],
			wideguard: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 52, shiny: 1, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	tinglu: {
		learnset: {
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			gigaimpact: ["1L1"],
			heavyslam: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			lashout: ["1L1"],
			meanlook: ["1L1"],
			memento: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			ruination: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			spikes: ["1L1"],
			spite: ["1L1"],
			stealthrock: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			throatchop: ["1L1"],
			whirlwind: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 60, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	chienpao: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			gigaimpact: ["1L1"],
			haze: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclecrash: ["1L1"],
			icywind: ["1L1"],
			lashout: ["1L1"],
			meanlook: ["1L1"],
			mist: ["1L1"],
			nightslash: ["1L1"],
			payback: ["1L1"],
			powdersnow: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			ruination: ["1L1"],
			sacredsword: ["1L1"],
			scaryface: ["1L1"],
			sheercold: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snowscape: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 60, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	wochien: {
		learnset: {
			absorb: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			darkpulse: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			foulplay: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			ingrain: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			meanlook: ["1L1"],
			megadrain: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			payback: ["1L1"],
			poisonpowder: ["1L1"],
			pollenpuff: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			ruination: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			spite: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			tickle: ["1L1"],
			trailblaze: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 60, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	chiyu: {
		learnset: {
			bounce: ["1L1"],
			burningjealousy: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			gigaimpact: ["1L1"],
			heatwave: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			inferno: ["1L1"],
			lashout: ["1L1"],
			lavaplume: ["1L1"],
			lightscreen: ["1L1"],
			meanlook: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			ruination: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			willowisp: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 60, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	koraidon: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			ancientpower: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			collisioncourse: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			drainpunch: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			gigaimpact: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			ironhead: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			meteorbeam: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocksmash: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			solarbeam: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wildcharge: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 68, nature: "Quirky", ivs: {hp: 31, atk: 31, def: 28, spa: 31, spd: 28, spe: 31}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 9, level: 72, nature: "Adamant", ivs: {hp: 25, atk: 31, def: 25, spa: 31, spd: 25, spe: 31}, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	miraidon: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			bodyslam: ["1L1"],
			calmmind: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			dazzlinggleam: ["1L1"],
			discharge: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electrodrift: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			lightscreen: ["1L1"],
			metalsound: ["1L1"],
			mirrorcoat: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			paraboliccharge: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			scaryface: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			supercellslam: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			uturn: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 68, nature: "Quirky", ivs: {hp: 31, atk: 31, def: 28, spa: 31, spd: 28, spe: 31}, moves: ["1L1"], pokeball: "pokeball"},
			{generation: 9, level: 72, nature: "Modest", ivs: {hp: 25, atk: 31, def: 25, spa: 31, spd: 25, spe: 31}, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	tinkatink: {
		learnset: {
			astonish: ["1L1"],
			babydolleyes: ["1L1"],
			brutalswing: ["1L1"],
			covet: ["1L1"],
			drainingkiss: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			feint: ["1L1"],
			flashcannon: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			helpinghand: ["1L1"],
			icehammer: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			metronome: ["1L1"],
			playrough: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sweetkiss: ["1L1"],
			swordsdance: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
		},
	},
	tinkatuff: {
		learnset: {
			astonish: ["1L1"],
			babydolleyes: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			covet: ["1L1"],
			drainingkiss: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			flashcannon: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			helpinghand: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			metronome: ["1L1"],
			playrough: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sweetkiss: ["1L1"],
			swordsdance: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
		},
	},
	tinkaton: {
		learnset: {
			astonish: ["1L1"],
			babydolleyes: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			covet: ["1L1"],
			drainingkiss: ["1L1"],
			encore: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			fakeout: ["1L1"],
			faketears: ["1L1"],
			flashcannon: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			gigatonhammer: ["1L1"],
			hardpress: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			metronome: ["1L1"],
			playrough: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sweetkiss: ["1L1"],
			swordsdance: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderwave: ["1L1"],
		},
	},
	charcadet: {
		learnset: {
			astonish: ["1L1"],
			celebrate: ["1L1"],
			clearsmog: ["1L1"],
			confuseray: ["1L1"],
			destinybond: ["1L1"],
			disable: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			incinerate: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			nightshade: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			sleeptalk: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			willowisp: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 5, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	armarouge: {
		learnset: {
			acidspray: ["1L1"],
			allyswitch: ["1L1"],
			armorcannon: ["1L1"],
			astonish: ["1L1"],
			aurasphere: ["1L1"],
			calmmind: ["1L1"],
			clearsmog: ["1L1"],
			confuseray: ["1L1"],
			darkpulse: ["1L1"],
			dragonpulse: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			meteorbeam: ["1L1"],
			mysticalfire: ["1L1"],
			nightshade: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			scorchingsands: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			weatherball: ["1L1"],
			wideguard: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	ceruledge: {
		learnset: {
			allyswitch: ["1L1"],
			astonish: ["1L1"],
			bitterblade: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			clearsmog: ["1L1"],
			closecombat: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			dragonclaw: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			nightshade: ["1L1"],
			nightslash: ["1L1"],
			overheat: ["1L1"],
			phantomforce: ["1L1"],
			poisonjab: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychocut: ["1L1"],
			psychup: ["1L1"],
			quickguard: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			sleeptalk: ["1L1"],
			solarblade: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			vacuumwave: ["1L1"],
			willowisp: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	toedscool: {
		learnset: {
			absorb: ["1L1"],
			acidspray: ["1L1"],
			acupressure: ["1L1"],
			bulletseed: ["1L1"],
			confuseray: ["1L1"],
			dazzlinggleam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			flashcannon: ["1L1"],
			foulplay: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			hex: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mirrorcoat: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			painsplit: ["1L1"],
			poisonpowder: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			ragepowder: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			spore: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			tickle: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			trickroom: ["1L1"],
			venoshock: ["1L1"],
			wrap: ["1L1"],
		},
	},
	toedscruel: {
		learnset: {
			absorb: ["1L1"],
			acidspray: ["1L1"],
			bulletseed: ["1L1"],
			confuseray: ["1L1"],
			dazzlinggleam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			flashcannon: ["1L1"],
			foulplay: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			knockoff: ["1L1"],
			leafstorm: ["1L1"],
			lightscreen: ["1L1"],
			lunge: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			painsplit: ["1L1"],
			poisonpowder: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			reflecttype: ["1L1"],
			rest: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			seedbomb: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			spore: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			trickroom: ["1L1"],
			venoshock: ["1L1"],
			wrap: ["1L1"],
		},
	},
	walkingwake: {
		learnset: {
			agility: ["1L1"],
			aquajet: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			chillingwater: ["1L1"],
			crunch: ["1L1"],
			doubleedge: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			flamethrower: ["1L1"],
			flipturn: ["1L1"],
			gigaimpact: ["1L1"],
			honeclaws: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hydrosteam: ["1L1"],
			hyperbeam: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			mudshot: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			twister: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlpool: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 75, perfectIVs: 3, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	ironleaves: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			airslash: ["1L1"],
			allyswitch: ["1L1"],
			brickbreak: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			doubleedge: ["1L1"],
			electricterrain: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			focusblast: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leer: ["1L1"],
			magicalleaf: ["1L1"],
			megahorn: ["1L1"],
			metalsound: ["1L1"],
			nightslash: ["1L1"],
			protect: ["1L1"],
			psyblade: ["1L1"],
			psychicterrain: ["1L1"],
			quash: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			reversal: ["1L1"],
			sacredsword: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 75, perfectIVs: 3, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	dipplin: {
		learnset: {
			astonish: ["1L1"],
			bodyslam: ["1L1"],
			bugbite: ["1L1"],
			bulletseed: ["1L1"],
			doublehit: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			gyroball: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			leafstorm: ["1L1"],
			outrage: ["1L1"],
			pollenpuff: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			sweetscent: ["1L1"],
			syrupbomb: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			withdraw: ["1L1"],
		},
	},
	poltchageist: {
		learnset: {
			absorb: ["1L1"],
			astonish: ["1L1"],
			calmmind: ["1L1"],
			curse: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			foulplay: ["1L1"],
			gigadrain: ["1L1"],
			grassyterrain: ["1L1"],
			hex: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			leafstorm: ["1L1"],
			lifedew: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			ragepowder: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			scald: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			terablast: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			withdraw: ["1L1"],
		},
	},
	poltchageistartisan: {
		learnset: {
			absorb: ["1L1"],
			astonish: ["1L1"],
			calmmind: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			foulplay: ["1L1"],
			gigadrain: ["1L1"],
			grassyterrain: ["1L1"],
			hex: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			leafstorm: ["1L1"],
			lifedew: ["1L1"],
			magicalleaf: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			ragepowder: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			scald: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			terablast: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			withdraw: ["1L1"],
		},
	},
	sinistcha: {
		learnset: {
			absorb: ["1L1"],
			astonish: ["1L1"],
			calmmind: ["1L1"],
			curse: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			foulplay: ["1L1"],
			gigadrain: ["1L1"],
			grassyterrain: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			leafstorm: ["1L1"],
			lifedew: ["1L1"],
			magicalleaf: ["1L1"],
			matchagotcha: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			ragepowder: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			scald: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			strengthsap: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			terablast: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			withdraw: ["1L1"],
		},
	},
	sinistchamasterpiece: {
		learnset: {
			absorb: ["1L1"],
			astonish: ["1L1"],
			calmmind: ["1L1"],
			curse: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			foulplay: ["1L1"],
			gigadrain: ["1L1"],
			grassyterrain: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			leafstorm: ["1L1"],
			lifedew: ["1L1"],
			magicalleaf: ["1L1"],
			matchagotcha: ["1L1"],
			megadrain: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			painsplit: ["1L1"],
			phantomforce: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			ragepowder: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			scald: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			strengthsap: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			terablast: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			withdraw: ["1L1"],
		},
	},
	okidogi: {
		learnset: {
			bite: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			closecombat: ["1L1"],
			counter: ["1L1"],
			crunch: ["1L1"],
			curse: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			drainpunch: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			firepunch: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hardpress: ["1L1"],
			highhorsepower: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			metalclaw: ["1L1"],
			outrage: ["1L1"],
			poisonfang: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rocktomb: ["1L1"],
			scaryface: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			upperhand: ["1L1"],
			uproar: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 70, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	munkidori: {
		learnset: {
			acidspray: ["1L1"],
			batonpass: ["1L1"],
			calmmind: ["1L1"],
			clearsmog: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			flatter: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			lashout: ["1L1"],
			lightscreen: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			partingshot: ["1L1"],
			poisonjab: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			rest: ["1L1"],
			scratch: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			spite: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 70, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	fezandipiti: {
		learnset: {
			acidspray: ["1L1"],
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			alluringvoice: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bravebird: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			crosspoison: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			disarmingvoice: ["1L1"],
			doublekick: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flatter: ["1L1"],
			fly: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			hex: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			icywind: ["1L1"],
			lashout: ["1L1"],
			lightscreen: ["1L1"],
			moonblast: ["1L1"],
			nastyplot: ["1L1"],
			peck: ["1L1"],
			playrough: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quickattack: ["1L1"],
			rest: ["1L1"],
			roost: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailslap: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			wingattack: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 70, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	ogerpon: {
		learnset: {
			brickbreak: ["1L1"],
			bulletseed: ["1L1"],
			charm: ["1L1"],
			counter: ["1L1"],
			doublekick: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			followme: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			helpinghand: ["1L1"],
			hornleech: ["1L1"],
			ivycudgel: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicalleaf: ["1L1"],
			playrough: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			reversal: ["1L1"],
			rocktomb: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			seedbomb: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			spikes: ["1L1"],
			spikyshield: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			vinewhip: ["1L1"],
			woodhammer: ["1L1"],
			zenheadbutt: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 20, nature: "Lonely", ivs: {hp: 31, atk: 31, def: 20, spa: 20, spd: 20, spe: 31}, moves: ["1L1"]},
			{generation: 9, level: 70, nature: "Lonely", ivs: {hp: 31, atk: 31, def: 20, spa: 20, spd: 20, spe: 31}, moves: ["1L1"]},
		],
		eventOnly: false,
	},
	ogerponhearthflame: {
		eventOnly: false,
	},
	ogerponwellspring: {
		eventOnly: false,
	},
	ogerponcornerstone: {
		eventOnly: false,
	},
	archaludon: {
		learnset: {
			aurasphere: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brickbreak: ["1L1"],
			darkpulse: ["1L1"],
			doubleedge: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			electroshot: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			focusenergy: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			gyroball: ["1L1"],
			hardpress: ["1L1"],
			heavyslam: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			lightscreen: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			scaryface: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snarl: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			steelbeam: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
		},
	},
	hydrapple: {
		learnset: {
			astonish: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			bugbite: ["1L1"],
			bulletseed: ["1L1"],
			curse: ["1L1"],
			doubleedge: ["1L1"],
			doublehit: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			ficklebeam: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			gyroball: ["1L1"],
			heavyslam: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			leafstorm: ["1L1"],
			magicalleaf: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			pollenpuff: ["1L1"],
			pounce: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			sweetscent: ["1L1"],
			syrupbomb: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			uproar: ["1L1"],
			withdraw: ["1L1"],
			yawn: ["1L1"],
		},
	},
	gougingfire: {
		learnset: {
			ancientpower: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			bulldoze: ["1L1"],
			burningbulwark: ["1L1"],
			crunch: ["1L1"],
			crushclaw: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			dracometeor: ["1L1"],
			dragoncheer: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			gigaimpact: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			howl: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			ironhead: ["1L1"],
			lavaplume: ["1L1"],
			leer: ["1L1"],
			morningsun: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			ragingfury: ["1L1"],
			rest: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snarl: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			takedown: ["1L1"],
			temperflare: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			weatherball: ["1L1"],
		},
	},
	ragingbolt: {
		learnset: {
			ancientpower: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			calmmind: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			crunch: ["1L1"],
			discharge: ["1L1"],
			doubleedge: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragoncheer: ["1L1"],
			dragonhammer: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			heavyslam: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			outrage: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			scaryface: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			solarbeam: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderclap: ["1L1"],
			thunderfang: ["1L1"],
			thunderwave: ["1L1"],
			twister: ["1L1"],
			voltswitch: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	ironboulder: {
		learnset: {
			aerialace: ["1L1"],
			agility: ["1L1"],
			airslash: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			counter: ["1L1"],
			doubleedge: ["1L1"],
			earthquake: ["1L1"],
			electricterrain: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			gigaimpact: ["1L1"],
			hornattack: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			megahorn: ["1L1"],
			meteorbeam: ["1L1"],
			mightycleave: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychocut: ["1L1"],
			psyshock: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			sacredsword: ["1L1"],
			sandstorm: ["1L1"],
			scaryface: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			solarblade: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swordsdance: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			wildcharge: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	ironcrown: {
		learnset: {
			agility: ["1L1"],
			airslash: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			confusion: ["1L1"],
			doubleedge: ["1L1"],
			electricterrain: ["1L1"],
			endure: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			focusblast: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			heavyslam: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			leer: ["1L1"],
			metalburst: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicnoise: ["1L1"],
			psychocut: ["1L1"],
			psyshock: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			sacredsword: ["1L1"],
			scaryface: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			solarblade: ["1L1"],
			steelbeam: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			supercellslam: ["1L1"],
			swordsdance: ["1L1"],
			tachyoncutter: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			voltswitch: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	terapagos: {
		learnset: {
			ancientpower: ["1L1"],
			aurasphere: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleedge: ["1L1"],
			dragonpulse: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heavyslam: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icespinner: ["1L1"],
			ironhead: ["1L1"],
			meteorbeam: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			roar: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			scorchingsands: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			supercellslam: ["1L1"],
			surf: ["1L1"],
			takedown: ["1L1"],
			terastarstorm: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
			withdraw: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	pecharunt: {
		learnset: {
			acidspray: ["1L1"],
			astonish: ["1L1"],
			curse: ["1L1"],
			defensecurl: ["1L1"],
			destinybond: ["1L1"],
			endure: ["1L1"],
			faketears: ["1L1"],
			foulplay: ["1L1"],
			gunkshot: ["1L1"],
			hex: ["1L1"],
			imprison: ["1L1"],
			malignantchain: ["1L1"],
			meanlook: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			nightshade: ["1L1"],
			partingshot: ["1L1"],
			phantomforce: ["1L1"],
			poisongas: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			rollout: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smog: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			venoshock: ["1L1"],
			withdraw: ["1L1"],
		},
	},
	syclar: {
		learnset: {
			absorb: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fellstinger: ["1L1"],
			fling: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclecrash: ["1L1"],
			icywind: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			naturalgift: ["1L1"],
			pinmissile: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			tailglow: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	syclant: {
		learnset: {
			absorb: ["1L1"],
			attract: ["1L1"],
			avalanche: ["1L1"],
			blizzard: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			cut: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			focuspunch: ["1L1"],
			frostbreath: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			icespinner: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			leechlife: ["1L1"],
			leer: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			pinmissile: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sheercold: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skittersmack: ["1L1"],
			slash: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			tripleaxel: ["1L1"],
			uturn: ["1L1"],
			waterpulse: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	revenankh: {
		learnset: {
			ancientpower: ["1L1"],
			armthrust: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			counter: ["1L1"],
			curse: ["1L1"],
			darkestlariat: ["1L1"],
			darkpulse: ["1L1"],
			destinybond: ["1L1"],
			detect: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			forcepalm: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			glare: ["1L1"],
			grudge: ["1L1"],
			hammerarm: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			knockoff: ["1L1"],
			laserfocus: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			machpunch: ["1L1"],
			meanlook: ["1L1"],
			megapunch: ["1L1"],
			memento: ["1L1"],
			metronome: ["1L1"],
			moonlight: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			phantomforce: ["1L1"],
			poisonjab: ["1L1"],
			poltergeist: ["1L1"],
			poweruppunch: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowpunch: ["1L1"],
			shadowsneak: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			vacuumwave: ["1L1"],
			willowisp: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			wrap: ["1L1"],
		},
	},
	embirch: {
		learnset: {
			amnesia: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragondance: ["1L1"],
			earthpower: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasswhistle: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lavaplume: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			overheat: ["1L1"],
			petaldance: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			watersport: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	flarelm: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			burningjealousy: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lavaplume: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			magicalleaf: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			overheat: ["1L1"],
			petaldance: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			worryseed: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	pyroak: {
		learnset: {
			amnesia: ["1L1"],
			ancientpower: ["1L1"],
			aromaticmist: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			burningjealousy: ["1L1"],
			burnup: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			growth: ["1L1"],
			headbutt: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			lavaplume: ["1L1"],
			leechseed: ["1L1"],
			lightscreen: ["1L1"],
			lowkick: ["1L1"],
			magicalleaf: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			overheat: ["1L1"],
			petalblizzard: ["1L1"],
			petaldance: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			stealthrock: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			woodhammer: ["1L1"],
			worryseed: ["1L1"],
			zapcannon: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	breezi: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			entrainment: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gunkshot: ["1L1"],
			gust: ["1L1"],
			healblock: ["1L1"],
			healingwish: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magicroom: ["1L1"],
			mefirst: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trickroom: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			whirlwind: ["1L1"],
			wish: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	fidgit: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			afteryou: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			cometpunch: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			dig: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fling: ["1L1"],
			followme: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			gunkshot: ["1L1"],
			gust: ["1L1"],
			healblock: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icespinner: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magicroom: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockclimb: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roleplay: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smartstrike: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			spikes: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trickroom: ["1L1"],
			twister: ["1L1"],
			uturn: ["1L1"],
			venoshock: ["1L1"],
			whirlwind: ["1L1"],
			wideguard: ["1L1"],
			wonderroom: ["1L1"],
		},
	},
	rebble: {
		learnset: {
			accelerock: ["1L1"],
			acupressure: ["1L1"],
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			lockon: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			vacuumwave: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	tactite: {
		learnset: {
			accelerock: ["1L1"],
			acupressure: ["1L1"],
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			lockon: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			vacuumwave: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	stratagem: {
		learnset: {
			accelerock: ["1L1"],
			acupressure: ["1L1"],
			aerialace: ["1L1"],
			ancientpower: ["1L1"],
			bulldoze: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disable: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			headsmash: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			laserfocus: ["1L1"],
			lockon: ["1L1"],
			metalsound: ["1L1"],
			meteorbeam: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			ominouswind: ["1L1"],
			paleowave: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockclimb: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			stealthrock: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			vacuumwave: ["1L1"],
			weatherball: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	privatyke: {
		learnset: {
			aquacutter: ["1L1"],
			aquajet: ["1L1"],
			armthrust: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			crosschop: ["1L1"],
			cut: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			machpunch: ["1L1"],
			megapunch: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			octazooka: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smokescreen: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			vacuumwave: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wideguard: ["1L1"],
			workup: ["1L1"],
			wrap: ["1L1"],
			yawn: ["1L1"],
		},
	},
	arghonaut: {
		learnset: {
			aquacutter: ["1L1"],
			aquajet: ["1L1"],
			armthrust: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bubble: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chillingwater: ["1L1"],
			chipaway: ["1L1"],
			circlethrow: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			crosschop: ["1L1"],
			crosspoison: ["1L1"],
			cut: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			machpunch: ["1L1"],
			megapunch: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			poisonjab: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			punishment: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			secretpower: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smokescreen: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikes: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			superpower: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			vacuumwave: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wideguard: ["1L1"],
			workup: ["1L1"],
			wrap: ["1L1"],
			yawn: ["1L1"],
		},
	},
	nohface: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			copycat: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			falseswipe: ["1L1"],
			featherdance: ["1L1"],
			feintattack: ["1L1"],
			flail: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			headbutt: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lick: ["1L1"],
			magiccoat: ["1L1"],
			memento: ["1L1"],
			metalsound: ["1L1"],
			meteormash: ["1L1"],
			metronome: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			odorsleuth: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			perishsong: ["1L1"],
			playrough: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychoshift: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tailwhip: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
			wish: ["1L1"],
			yawn: ["1L1"],
		},
	},
	kitsunoh: {
		learnset: {
			assurance: ["1L1"],
			attract: ["1L1"],
			bulldoze: ["1L1"],
			bulletpunch: ["1L1"],
			captivate: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			copycat: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			falseswipe: ["1L1"],
			feintattack: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			headbutt: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hyperbeam: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lastresort: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			magiccoat: ["1L1"],
			memento: ["1L1"],
			metalclaw: ["1L1"],
			metronome: ["1L1"],
			naturalgift: ["1L1"],
			nightshade: ["1L1"],
			odorsleuth: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			perishsong: ["1L1"],
			playrough: ["1L1"],
			poltergeist: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			shadowstrike: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			steelbeam: ["1L1"],
			strengthsap: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tailwhip: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderpunch: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uturn: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	monohm: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			powdersnow: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			sonicboom: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			twister: ["1L1"],
			voltswitch: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlwind: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	duohm: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			discharge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			sonicboom: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			trickroom: ["1L1"],
			twister: ["1L1"],
			voltswitch: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlwind: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	cyclohm: {
		learnset: {
			aerialace: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			blizzard: ["1L1"],
			breakingswipe: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			discharge: ["1L1"],
			doublehit: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragontail: ["1L1"],
			earthquake: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hail: ["1L1"],
			headbutt: ["1L1"],
			healbell: ["1L1"],
			hiddenpower: ["1L1"],
			honeclaws: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icywind: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lightscreen: ["1L1"],
			lockon: ["1L1"],
			muddywater: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			outrage: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			sonicboom: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thrash: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			triattack: ["1L1"],
			trickroom: ["1L1"],
			twister: ["1L1"],
			voltswitch: ["1L1"],
			waterfall: ["1L1"],
			waterpulse: ["1L1"],
			weatherball: ["1L1"],
			whirlwind: ["1L1"],
			wildcharge: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	dorsoil: {
		learnset: {
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			chipaway: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			firefang: ["1L1"],
			fissure: ["1L1"],
			flail: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			icespinner: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			magnitude: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			wideguard: ["1L1"],
		},
	},
	colossoil: {
		learnset: {
			ancientpower: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bounce: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dig: ["1L1"],
			dive: ["1L1"],
			doubleedge: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			furyattack: ["1L1"],
			gigaimpact: ["1L1"],
			headlongrush: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hornattack: ["1L1"],
			horndrill: ["1L1"],
			hyperbeam: ["1L1"],
			icespinner: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leer: ["1L1"],
			magnitude: ["1L1"],
			megahorn: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			protect: ["1L1"],
			pursuit: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swallow: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
		},
	},
	protowatt: {
		learnset: {
			bubble: ["1L1"],
			charge: ["1L1"],
			confuseray: ["1L1"],
			counter: ["1L1"],
			entrainment: ["1L1"],
			followme: ["1L1"],
			mefirst: ["1L1"],
			metronome: ["1L1"],
			mindreader: ["1L1"],
			mirrorcoat: ["1L1"],
			sheercold: ["1L1"],
			speedswap: ["1L1"],
			terablast: ["1L1"],
			thundershock: ["1L1"],
			watergun: ["1L1"],
		},
	},
	krilowatt: {
		learnset: {
			aquatail: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bubble: ["1L1"],
			bubblebeam: ["1L1"],
			bulldoze: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			cut: ["1L1"],
			discharge: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			furycutter: ["1L1"],
			gigaimpact: ["1L1"],
			guillotine: ["1L1"],
			hail: ["1L1"],
			heartswap: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icepunch: ["1L1"],
			iceshard: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magneticflux: ["1L1"],
			metronome: ["1L1"],
			mindreader: ["1L1"],
			mirrorcoat: ["1L1"],
			muddywater: ["1L1"],
			naturalgift: ["1L1"],
			payback: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			speedswap: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			voltswitch: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wildcharge: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 50, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	voodoll: {
		learnset: {
			acupressure: ["1L1"],
			afteryou: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			fling: ["1L1"],
			followme: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			grudge: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			machpunch: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			memento: ["1L1"],
			metronome: ["1L1"],
			mimic: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			perishsong: ["1L1"],
			pinmissile: ["1L1"],
			powertrip: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			pursuit: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smellingsalts: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			voltswitch: ["1L1"],
			workup: ["1L1"],
			wrap: ["1L1"],
		},
	},
	voodoom: {
		learnset: {
			acupressure: ["1L1"],
			afteryou: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			beatup: ["1L1"],
			brickbreak: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			captivate: ["1L1"],
			charge: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			copycat: ["1L1"],
			counter: ["1L1"],
			darkestlariat: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			feintattack: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focuspunch: ["1L1"],
			followme: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grudge: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icepunch: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mudslap: ["1L1"],
			nastyplot: ["1L1"],
			naturalgift: ["1L1"],
			nightmare: ["1L1"],
			nightslash: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			risingvoltage: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snarl: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			tearfullook: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderbolt: ["1L1"],
			thunderpunch: ["1L1"],
			thunderwave: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			voltswitch: ["1L1"],
			workup: ["1L1"],
			wrap: ["1L1"],
		},
	},
	scratchet: {
		learnset: {
			aerialace: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			grassknot: ["1L1"],
			harden: ["1L1"],
			haze: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			irontail: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			memento: ["1L1"],
			mudslap: ["1L1"],
			naturepower: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
	},
	tomohawk: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			batonpass: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			doubleteam: ["1L1"],
			dualwingbeat: ["1L1"],
			earthquake: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			furyswipes: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			harden: ["1L1"],
			haze: ["1L1"],
			healingwish: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			morningsun: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			roar: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rocktomb: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			steelwing: ["1L1"],
			stoneedge: ["1L1"],
			strength: ["1L1"],
			submission: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			whirlwind: ["1L1"],
			workup: ["1L1"],
		},
	},
	necturine: {
		learnset: {
			attract: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			curse: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			ingrain: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leechlife: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			magicalleaf: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			nightmare: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowsneak: ["1L1"],
			shellsmash: ["1L1"],
			sketch: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spite: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			vinewhip: ["1L1"],
			willowisp: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	necturna: {
		learnset: {
			attract: ["1L1"],
			calmmind: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hornleech: ["1L1"],
			hyperbeam: ["1L1"],
			leafblade: ["1L1"],
			leafstorm: ["1L1"],
			leechlife: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			magicalleaf: ["1L1"],
			naturepower: ["1L1"],
			nightshade: ["1L1"],
			ominouswind: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			poisonfang: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			shadowsneak: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			spite: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			swagger: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			vinewhip: ["1L1"],
			willowisp: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	mollux: {
		learnset: {
			acid: ["1L1"],
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			bide: ["1L1"],
			bind: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			corrosivegas: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			ember: ["1L1"],
			endure: ["1L1"],
			eruption: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			healbell: ["1L1"],
			healpulse: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			inferno: ["1L1"],
			lavaplume: ["1L1"],
			leechlife: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			moonlight: ["1L1"],
			overheat: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shockwave: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spotlight: ["1L1"],
			stealthrock: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trick: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			willowisp: ["1L1"],
			withdraw: ["1L1"],
		},
	},
	cupra: {
		learnset: {
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			counter: ["1L1"],
			cut: ["1L1"],
			disable: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			electroweb: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			finalgambit: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megahorn: ["1L1"],
			nastyplot: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			steelwing: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailglow: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			waterpulse: ["1L1"],
			willowisp: ["1L1"],
			wingattack: ["1L1"],
			wish: ["1L1"],
			wonderroom: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	argalis: {
		learnset: {
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dreameater: ["1L1"],
			echoedvoice: ["1L1"],
			electroweb: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			frustration: ["1L1"],
			hail: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megahorn: ["1L1"],
			nastyplot: ["1L1"],
			ominouswind: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spotlight: ["1L1"],
			steelwing: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailglow: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			waterpulse: ["1L1"],
			willowisp: ["1L1"],
			wish: ["1L1"],
			wonderroom: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	aurumoth: {
		learnset: {
			allyswitch: ["1L1"],
			ancientpower: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			calmmind: ["1L1"],
			closecombat: ["1L1"],
			confide: ["1L1"],
			cut: ["1L1"],
			doubleteam: ["1L1"],
			dragondance: ["1L1"],
			dreameater: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			electroweb: ["1L1"],
			expandingforce: ["1L1"],
			facade: ["1L1"],
			finalgambit: ["1L1"],
			flash: ["1L1"],
			fling: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			hail: ["1L1"],
			healingwish: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			lightscreen: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			megahorn: ["1L1"],
			nastyplot: ["1L1"],
			ominouswind: ["1L1"],
			overheat: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicterrain: ["1L1"],
			psychup: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			recycle: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roleplay: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			secretpower: ["1L1"],
			shadowball: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			silverwind: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			solarbeam: ["1L1"],
			spotlight: ["1L1"],
			steelwing: ["1L1"],
			stringshot: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			tackle: ["1L1"],
			tailglow: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			waterpulse: ["1L1"],
			willowisp: ["1L1"],
			wish: ["1L1"],
			wonderroom: ["1L1"],
			xscissor: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	brattler: {
		learnset: {
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			belch: ["1L1"],
			bind: ["1L1"],
			brutalswing: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			feint: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			glare: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			haze: ["1L1"],
			healbell: ["1L1"],
			hiddenpower: ["1L1"],
			icefang: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leafblade: ["1L1"],
			leer: ["1L1"],
			nastyplot: ["1L1"],
			naturepower: ["1L1"],
			nightslash: ["1L1"],
			partingshot: ["1L1"],
			payback: ["1L1"],
			poisonpowder: ["1L1"],
			poisontail: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			punishment: ["1L1"],
			pursuit: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			skittersmack: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikyshield: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			stunspore: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			sweetscent: ["1L1"],
			synthesis: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			vinewhip: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
			worryseed: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
		},
	},
	malaconda: {
		learnset: {
			attract: ["1L1"],
			beatup: ["1L1"],
			bind: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			cut: ["1L1"],
			darkpulse: ["1L1"],
			doubleteam: ["1L1"],
			dragontail: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			followme: ["1L1"],
			foulplay: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			glare: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			gravapple: ["1L1"],
			haze: ["1L1"],
			healbell: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			irontail: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			leafblade: ["1L1"],
			leer: ["1L1"],
			nastyplot: ["1L1"],
			naturepower: ["1L1"],
			partingshot: ["1L1"],
			payback: ["1L1"],
			poisontail: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			punishment: ["1L1"],
			pursuit: ["1L1"],
			rapidspin: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			seedbomb: ["1L1"],
			skittersmack: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			spikyshield: ["1L1"],
			spite: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			suckerpunch: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			throatchop: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uturn: ["1L1"],
			vinewhip: ["1L1"],
			weatherball: ["1L1"],
			wildcharge: ["1L1"],
			worryseed: ["1L1"],
			wrap: ["1L1"],
			wringout: ["1L1"],
		},
	},
	cawdet: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			block: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bulletpunch: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			detect: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			drillpeck: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			growl: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			metronome: ["1L1"],
			mirrormove: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			pursuit: ["1L1"],
			quickattack: ["1L1"],
			quickguard: ["1L1"],
			raindance: ["1L1"],
			razorwind: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			shockwave: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			steelwing: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			waterpulse: ["1L1"],
			watersport: ["1L1"],
			whirlpool: ["1L1"],
			wingattack: ["1L1"],
		},
	},
	cawmodore: {
		learnset: {
			acrobatics: ["1L1"],
			aerialace: ["1L1"],
			agility: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			belch: ["1L1"],
			bellydrum: ["1L1"],
			block: ["1L1"],
			brickbreak: ["1L1"],
			brine: ["1L1"],
			bulletpunch: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			detect: ["1L1"],
			doubleteam: ["1L1"],
			drainpunch: ["1L1"],
			dualwingbeat: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			leer: ["1L1"],
			megapunch: ["1L1"],
			metalclaw: ["1L1"],
			metronome: ["1L1"],
			peck: ["1L1"],
			pluck: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			shockwave: ["1L1"],
			skyattack: ["1L1"],
			skydrop: ["1L1"],
			sleeptalk: ["1L1"],
			smackdown: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			steelwing: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wingattack: ["1L1"],
		},
	},
	volkritter: {
		learnset: {
			absorb: ["1L1"],
			aquajet: ["1L1"],
			aquaring: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			bounce: ["1L1"],
			captivate: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			covet: ["1L1"],
			destinybond: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			incinerate: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			memento: ["1L1"],
			muddywater: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			pounce: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			reflecttype: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			tickle: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			willowisp: ["1L1"],
		},
	},
	volkraken: {
		learnset: {
			absorb: ["1L1"],
			aquaring: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			bite: ["1L1"],
			bounce: ["1L1"],
			burningjealousy: ["1L1"],
			confide: ["1L1"],
			constrict: ["1L1"],
			covet: ["1L1"],
			destinybond: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			extrasensory: ["1L1"],
			facade: ["1L1"],
			falseswipe: ["1L1"],
			fireblast: ["1L1"],
			firelash: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			fling: ["1L1"],
			flipturn: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			liquidation: ["1L1"],
			memento: ["1L1"],
			muddywater: ["1L1"],
			overheat: ["1L1"],
			payback: ["1L1"],
			pounce: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			quash: ["1L1"],
			raindance: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			scorchingsands: ["1L1"],
			secretpower: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uturn: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			willowisp: ["1L1"],
			wringout: ["1L1"],
		},
	},
	snugglow: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			block: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			crosspoison: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electrify: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			haze: ["1L1"],
			hiddenpower: ["1L1"],
			iondeluge: ["1L1"],
			irontail: ["1L1"],
			paraboliccharge: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterpulse: ["1L1"],
			wideguard: ["1L1"],
			wildcharge: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	plasmanta: {
		learnset: {
			acid: ["1L1"],
			acidspray: ["1L1"],
			aquatail: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			block: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			chargebeam: ["1L1"],
			chillingwater: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			corrosivegas: ["1L1"],
			crosspoison: ["1L1"],
			cut: ["1L1"],
			dazzlinggleam: ["1L1"],
			discharge: ["1L1"],
			doubleteam: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electrify: ["1L1"],
			electroball: ["1L1"],
			electroweb: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			haze: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			iondeluge: ["1L1"],
			irontail: ["1L1"],
			liquidation: ["1L1"],
			magnetrise: ["1L1"],
			paraboliccharge: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			poisontail: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			psywave: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			supersonic: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterpulse: ["1L1"],
			wildcharge: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	floatoy: {
		learnset: {
			attract: ["1L1"],
			bite: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			drillpeck: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			featherdance: ["1L1"],
			feint: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gust: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			metalclaw: ["1L1"],
			metronome: ["1L1"],
			muddywater: ["1L1"],
			peck: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			refresh: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			splash: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	caimanoe: {
		learnset: {
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			drillpeck: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gust: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			metronome: ["1L1"],
			muddywater: ["1L1"],
			peck: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			splash: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
		},
	},
	naviathan: {
		learnset: {
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brine: ["1L1"],
			brutalswing: ["1L1"],
			bubblebeam: ["1L1"],
			calmmind: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			crunch: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragondance: ["1L1"],
			dragonpulse: ["1L1"],
			drillpeck: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gust: ["1L1"],
			hail: ["1L1"],
			haze: ["1L1"],
			heavyslam: ["1L1"],
			hiddenpower: ["1L1"],
			hurricane: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			icebeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			iciclecrash: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			metalclaw: ["1L1"],
			metalsound: ["1L1"],
			metronome: ["1L1"],
			muddywater: ["1L1"],
			peck: ["1L1"],
			protect: ["1L1"],
			psychicfangs: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			rocksmash: ["1L1"],
			round: ["1L1"],
			scald: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			slackoff: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			splash: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			thunderpunch: ["1L1"],
			toxic: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
			wavecrash: ["1L1"],
			whirlpool: ["1L1"],
			wideguard: ["1L1"],
			wildcharge: ["1L1"],
		},
	},
	crucibelle: {
		learnset: {
			acidarmor: ["1L1"],
			acidspray: ["1L1"],
			assurance: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			coil: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			confusion: ["1L1"],
			crosspoison: ["1L1"],
			defensecurl: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gravity: ["1L1"],
			gunkshot: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			infestation: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			knockoff: ["1L1"],
			lightscreen: ["1L1"],
			magicroom: ["1L1"],
			meteorbeam: ["1L1"],
			metronome: ["1L1"],
			payback: ["1L1"],
			pinmissile: ["1L1"],
			poisonjab: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			psybeam: ["1L1"],
			psychic: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockblast: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocksmash: ["1L1"],
			rockthrow: ["1L1"],
			rocktomb: ["1L1"],
			rollout: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			secretpower: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			sludge: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			smackdown: ["1L1"],
			snatch: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelroller: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			terablast: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trick: ["1L1"],
			uturn: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			withdraw: ["1L1"],
			wonderroom: ["1L1"],
			woodhammer: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	pluffle: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			bodyslam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dreameater: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			featherdance: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			nightmare: ["1L1"],
			partingshot: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			quickguard: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			wakeupslap: ["1L1"],
			wideguard: ["1L1"],
			wish: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
	},
	kerfluffle: {
		learnset: {
			allyswitch: ["1L1"],
			attract: ["1L1"],
			aurasphere: ["1L1"],
			beatup: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			closecombat: ["1L1"],
			coaching: ["1L1"],
			confide: ["1L1"],
			crushclaw: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			drainpunch: ["1L1"],
			dreameater: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fairywind: ["1L1"],
			featherdance: ["1L1"],
			flashcannon: ["1L1"],
			fly: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			holdhands: ["1L1"],
			hyperbeam: ["1L1"],
			lowkick: ["1L1"],
			lowsweep: ["1L1"],
			magicroom: ["1L1"],
			megakick: ["1L1"],
			megapunch: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			nightmare: ["1L1"],
			partingshot: ["1L1"],
			playrough: ["1L1"],
			poweruppunch: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			return: ["1L1"],
			revenge: ["1L1"],
			reversal: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			scratch: ["1L1"],
			secretpower: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			speedswap: ["1L1"],
			strength: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			torment: ["1L1"],
			toxic: ["1L1"],
			uproar: ["1L1"],
			vacuumwave: ["1L1"],
			wakeupslap: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
		eventData: [
			{generation: 6, level: 16, abilities: ["1L1"], moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	pajantom: {
		learnset: {
			aerialace: ["1L1"],
			astonish: ["1L1"],
			attract: ["1L1"],
			bind: ["1L1"],
			block: ["1L1"],
			bravebird: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			crunch: ["1L1"],
			doubleteam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrage: ["1L1"],
			dragonrush: ["1L1"],
			dreameater: ["1L1"],
			drillrun: ["1L1"],
			dualchop: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fairylock: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gastroacid: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			growl: ["1L1"],
			haze: ["1L1"],
			healblock: ["1L1"],
			helpinghand: ["1L1"],
			hex: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			icepunch: ["1L1"],
			icywind: ["1L1"],
			imprison: ["1L1"],
			infestation: ["1L1"],
			irontail: ["1L1"],
			laserfocus: ["1L1"],
			leechlife: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			phantomforce: ["1L1"],
			poisonfang: ["1L1"],
			poisongas: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychicfangs: ["1L1"],
			psychup: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandtomb: ["1L1"],
			shadowball: ["1L1"],
			shadowclaw: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			spiritshackle: ["1L1"],
			spite: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			telekinesis: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trickroom: ["1L1"],
			venoshock: ["1L1"],
			whirlpool: ["1L1"],
			wrap: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	mumbao: {
		learnset: {
			attract: ["1L1"],
			bodyslam: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			dazzlinggleam: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flowershield: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			healingwish: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			ingrain: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			naturalgift: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			smellingsalts: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wish: ["1L1"],
			woodhammer: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	jumbao: {
		learnset: {
			armthrust: ["1L1"],
			attract: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletseed: ["1L1"],
			confide: ["1L1"],
			dazzlinggleam: ["1L1"],
			detect: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			fakeout: ["1L1"],
			flameburst: ["1L1"],
			flowershield: ["1L1"],
			focusblast: ["1L1"],
			focusenergy: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			gravity: ["1L1"],
			gyroball: ["1L1"],
			harden: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			ingrain: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			luckychant: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			naturalgift: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rototiller: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			seedbomb: ["1L1"],
			selfdestruct: ["1L1"],
			shadowball: ["1L1"],
			shoreup: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			wish: ["1L1"],
			wonderroom: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	fawnifer: {
		learnset: {
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulletseed: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			doubleedge: ["1L1"],
			doublekick: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			knockoff: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			naturalgift: ["1L1"],
			naturepower: ["1L1"],
			powerwhip: ["1L1"],
			present: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			rapidspin: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			seedbomb: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spark: ["1L1"],
			spotlight: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thundershock: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
		},
	},
	electrelk: {
		learnset: {
			attract: ["1L1"],
			bodyslam: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulletseed: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hypervoice: ["1L1"],
			knockoff: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			magnetrise: ["1L1"],
			naturepower: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			seedbomb: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zapcannon: ["1L1"],
		},
	},
	caribolt: {
		learnset: {
			attract: ["1L1"],
			bodyslam: ["1L1"],
			boomburst: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulletseed: ["1L1"],
			celebrate: ["1L1"],
			chargebeam: ["1L1"],
			charm: ["1L1"],
			confide: ["1L1"],
			confuseray: ["1L1"],
			doubleteam: ["1L1"],
			echoedvoice: ["1L1"],
			eerieimpulse: ["1L1"],
			electricterrain: ["1L1"],
			electroweb: ["1L1"],
			endeavor: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			flash: ["1L1"],
			flashcannon: ["1L1"],
			frenzyplant: ["1L1"],
			frustration: ["1L1"],
			gigadrain: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			grasspledge: ["1L1"],
			grassyglide: ["1L1"],
			grassyterrain: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hornleech: ["1L1"],
			hyperbeam: ["1L1"],
			hyperdrill: ["1L1"],
			hypervoice: ["1L1"],
			knockoff: ["1L1"],
			leafage: ["1L1"],
			leafstorm: ["1L1"],
			leechseed: ["1L1"],
			leer: ["1L1"],
			magnetrise: ["1L1"],
			metronome: ["1L1"],
			naturepower: ["1L1"],
			powerwhip: ["1L1"],
			protect: ["1L1"],
			quickattack: ["1L1"],
			razorleaf: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			risingvoltage: ["1L1"],
			round: ["1L1"],
			seedbomb: ["1L1"],
			shockwave: ["1L1"],
			signalbeam: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			solarblade: ["1L1"],
			spark: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			synthesis: ["1L1"],
			tackle: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			terrainpulse: ["1L1"],
			throatchop: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thundershock: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			voltswitch: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			worryseed: ["1L1"],
			zapcannon: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	smogecko: {
		learnset: {
			acidspray: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			bonerush: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			bulletpunch: ["1L1"],
			camouflage: ["1L1"],
			confide: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			forcepalm: ["1L1"],
			frustration: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lavaplume: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			mudshot: ["1L1"],
			overheat: ["1L1"],
			poisonfang: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swagger: ["1L1"],
			tailwhip: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venomdrench: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
	},
	smoguana: {
		learnset: {
			acidspray: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			camouflage: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			corrosivegas: ["1L1"],
			crosspoison: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			frustration: ["1L1"],
			gunkshot: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lavaplume: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			mudshot: ["1L1"],
			overheat: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tailwhip: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venomdrench: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
	},
	smokomodo: {
		learnset: {
			acidspray: ["1L1"],
			aerialace: ["1L1"],
			attract: ["1L1"],
			blastburn: ["1L1"],
			brickbreak: ["1L1"],
			bulkup: ["1L1"],
			bulldoze: ["1L1"],
			burningjealousy: ["1L1"],
			camouflage: ["1L1"],
			celebrate: ["1L1"],
			circlethrow: ["1L1"],
			clearsmog: ["1L1"],
			confide: ["1L1"],
			corrosivegas: ["1L1"],
			crosspoison: ["1L1"],
			defog: ["1L1"],
			dig: ["1L1"],
			doubleteam: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			ember: ["1L1"],
			endeavor: ["1L1"],
			eruption: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firepledge: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			fissure: ["1L1"],
			flameburst: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			focusblast: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			heatcrash: ["1L1"],
			heatwave: ["1L1"],
			hiddenpower: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			incinerate: ["1L1"],
			irontail: ["1L1"],
			lavaplume: ["1L1"],
			lick: ["1L1"],
			lowkick: ["1L1"],
			machpunch: ["1L1"],
			magnitude: ["1L1"],
			metalclaw: ["1L1"],
			morningsun: ["1L1"],
			mudshot: ["1L1"],
			mysticalfire: ["1L1"],
			overheat: ["1L1"],
			poisonjab: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			roar: ["1L1"],
			round: ["1L1"],
			sandtomb: ["1L1"],
			scaleshot: ["1L1"],
			scorchingsands: ["1L1"],
			scratch: ["1L1"],
			screech: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			stealthrock: ["1L1"],
			stompingtantrum: ["1L1"],
			stormthrow: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superpower: ["1L1"],
			swagger: ["1L1"],
			tailwhip: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trailblaze: ["1L1"],
			venomdrench: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	swirlpool: {
		learnset: {
			acidarmor: ["1L1"],
			allyswitch: ["1L1"],
			aquajet: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			growl: ["1L1"],
			guardswap: ["1L1"],
			hail: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			lifedew: ["1L1"],
			magiccoat: ["1L1"],
			metronome: ["1L1"],
			muddywater: ["1L1"],
			pinmissile: ["1L1"],
			pounce: ["1L1"],
			pound: ["1L1"],
			powder: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psychoshift: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			spikyshield: ["1L1"],
			spotlight: ["1L1"],
			stealthrock: ["1L1"],
			stickyweb: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			workup: ["1L1"],
		},
	},
	coribalis: {
		learnset: {
			allyswitch: ["1L1"],
			aquajet: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			growl: ["1L1"],
			guardswap: ["1L1"],
			hail: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydropump: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			muddywater: ["1L1"],
			pinmissile: ["1L1"],
			pounce: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stealthrock: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	snaelstrom: {
		learnset: {
			allyswitch: ["1L1"],
			aquajet: ["1L1"],
			aquaring: ["1L1"],
			attract: ["1L1"],
			blizzard: ["1L1"],
			block: ["1L1"],
			bodyslam: ["1L1"],
			brine: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			captivate: ["1L1"],
			celebrate: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			confide: ["1L1"],
			confusion: ["1L1"],
			dazzlinggleam: ["1L1"],
			dive: ["1L1"],
			doubleteam: ["1L1"],
			drainingkiss: ["1L1"],
			dualwingbeat: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			frustration: ["1L1"],
			futuresight: ["1L1"],
			gigaimpact: ["1L1"],
			growl: ["1L1"],
			guardswap: ["1L1"],
			hail: ["1L1"],
			healpulse: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hydrocannon: ["1L1"],
			hydropump: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icebeam: ["1L1"],
			iciclespear: ["1L1"],
			icywind: ["1L1"],
			infestation: ["1L1"],
			leechlife: ["1L1"],
			liquidation: ["1L1"],
			magiccoat: ["1L1"],
			magicroom: ["1L1"],
			metronome: ["1L1"],
			muddywater: ["1L1"],
			pinmissile: ["1L1"],
			pounce: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			rapidspin: ["1L1"],
			razorshell: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			signalbeam: ["1L1"],
			skillswap: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			snowscape: ["1L1"],
			stealthrock: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			swagger: ["1L1"],
			swift: ["1L1"],
			swordsdance: ["1L1"],
			terablast: ["1L1"],
			toxic: ["1L1"],
			trick: ["1L1"],
			trickroom: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			waterfall: ["1L1"],
			watergun: ["1L1"],
			waterpledge: ["1L1"],
			waterpulse: ["1L1"],
			whirlpool: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
		eventData: [
			{generation: 7, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	justyke: {
		learnset: {
			allyswitch: ["1L1"],
			aurasphere: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			destinybond: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gravity: ["1L1"],
			guardsplit: ["1L1"],
			gyroball: ["1L1"],
			healingwish: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			icespinner: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			magicroom: ["1L1"],
			magnetrise: ["1L1"],
			memento: ["1L1"],
			mindreader: ["1L1"],
			mirrorshot: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			painsplit: ["1L1"],
			pound: ["1L1"],
			powersplit: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quash: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			terablast: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
		},
	},
	equilibra: {
		learnset: {
			allyswitch: ["1L1"],
			aurasphere: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			confide: ["1L1"],
			destinybond: ["1L1"],
			doomdesire: ["1L1"],
			doubleteam: ["1L1"],
			drillrun: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			embargo: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			facade: ["1L1"],
			flashcannon: ["1L1"],
			frustration: ["1L1"],
			gigaimpact: ["1L1"],
			gravity: ["1L1"],
			guardsplit: ["1L1"],
			gyroball: ["1L1"],
			healingwish: ["1L1"],
			heavyslam: ["1L1"],
			helpinghand: ["1L1"],
			hiddenpower: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			magicroom: ["1L1"],
			magnetrise: ["1L1"],
			memento: ["1L1"],
			mindreader: ["1L1"],
			mirrorshot: ["1L1"],
			mudshot: ["1L1"],
			mudslap: ["1L1"],
			mudsport: ["1L1"],
			painsplit: ["1L1"],
			perishsong: ["1L1"],
			pound: ["1L1"],
			powersplit: ["1L1"],
			protect: ["1L1"],
			psychup: ["1L1"],
			quash: ["1L1"],
			rapidspin: ["1L1"],
			recycle: ["1L1"],
			rest: ["1L1"],
			return: ["1L1"],
			rockpolish: ["1L1"],
			rockslide: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sandstorm: ["1L1"],
			sleeptalk: ["1L1"],
			smartstrike: ["1L1"],
			snore: ["1L1"],
			steelbeam: ["1L1"],
			steelroller: ["1L1"],
			substitute: ["1L1"],
			swagger: ["1L1"],
			terablast: ["1L1"],
			trickroom: ["1L1"],
			wonderroom: ["1L1"],
			workup: ["1L1"],
		},
		eventData: [
			{generation: 9, level: 50, moves: ["1L1"], pokeball: "pokeball"},
		],
	},
	solotl: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			breakingswipe: ["1L1"],
			charm: ["1L1"],
			cosmicpower: ["1L1"],
			dazzlinggleam: ["1L1"],
			defog: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firelash: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			imprison: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			meteorbeam: ["1L1"],
			metronome: ["1L1"],
			mysticalfire: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			twister: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
			yawn: ["1L1"],
		},
	},
	astrolotl: {
		learnset: {
			acrobatics: ["1L1"],
			agility: ["1L1"],
			allyswitch: ["1L1"],
			attract: ["1L1"],
			batonpass: ["1L1"],
			breakingswipe: ["1L1"],
			bulldoze: ["1L1"],
			charm: ["1L1"],
			cosmicpower: ["1L1"],
			dazzlinggleam: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			ember: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firefang: ["1L1"],
			firelash: ["1L1"],
			firepunch: ["1L1"],
			firespin: ["1L1"],
			flamecharge: ["1L1"],
			flamethrower: ["1L1"],
			flamewheel: ["1L1"],
			flareblitz: ["1L1"],
			healbell: ["1L1"],
			healingwish: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			magiccoat: ["1L1"],
			meteorbeam: ["1L1"],
			metronome: ["1L1"],
			mysticalfire: ["1L1"],
			outrage: ["1L1"],
			overheat: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scorchingsands: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			stompingtantrum: ["1L1"],
			storedpower: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			swift: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			willowisp: ["1L1"],
			workup: ["1L1"],
		},
	},
	miasmite: {
		learnset: {
			agility: ["1L1"],
			aromatherapy: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			corrosivegas: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonpulse: ["1L1"],
			dragonrush: ["1L1"],
			dragontail: ["1L1"],
			earthpower: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			firstimpression: ["1L1"],
			flashcannon: ["1L1"],
			haze: ["1L1"],
			icefang: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			megahorn: ["1L1"],
			outrage: ["1L1"],
			pinmissile: ["1L1"],
			poisonfang: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderfang: ["1L1"],
			uproar: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	miasmaw: {
		learnset: {
			agility: ["1L1"],
			attract: ["1L1"],
			bite: ["1L1"],
			bodyslam: ["1L1"],
			breakingswipe: ["1L1"],
			brutalswing: ["1L1"],
			bugbite: ["1L1"],
			bugbuzz: ["1L1"],
			bulldoze: ["1L1"],
			closecombat: ["1L1"],
			corrosivegas: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			dracometeor: ["1L1"],
			dragonbreath: ["1L1"],
			dragonclaw: ["1L1"],
			dragonhammer: ["1L1"],
			dragonpulse: ["1L1"],
			dragontail: ["1L1"],
			dualwingbeat: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			firefang: ["1L1"],
			flashcannon: ["1L1"],
			focusblast: ["1L1"],
			gigaimpact: ["1L1"],
			gunkshot: ["1L1"],
			haze: ["1L1"],
			highhorsepower: ["1L1"],
			hyperbeam: ["1L1"],
			icefang: ["1L1"],
			ironhead: ["1L1"],
			irontail: ["1L1"],
			leechlife: ["1L1"],
			lunge: ["1L1"],
			megahorn: ["1L1"],
			nastyplot: ["1L1"],
			outrage: ["1L1"],
			pinmissile: ["1L1"],
			poisongas: ["1L1"],
			poisonjab: ["1L1"],
			pounce: ["1L1"],
			protect: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			round: ["1L1"],
			scaleshot: ["1L1"],
			scaryface: ["1L1"],
			screech: ["1L1"],
			skittersmack: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			smog: ["1L1"],
			smokescreen: ["1L1"],
			snore: ["1L1"],
			strugglebug: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			superfang: ["1L1"],
			superpower: ["1L1"],
			swordsdance: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			uproar: ["1L1"],
			uturn: ["1L1"],
			wildcharge: ["1L1"],
			workup: ["1L1"],
			xscissor: ["1L1"],
		},
	},
	chromera: {
		learnset: {
			acidspray: ["1L1"],
			aerialace: ["1L1"],
			aromatherapy: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			beatup: ["1L1"],
			belch: ["1L1"],
			blizzard: ["1L1"],
			bodyslam: ["1L1"],
			boomburst: ["1L1"],
			calmmind: ["1L1"],
			charm: ["1L1"],
			chillingwater: ["1L1"],
			crunch: ["1L1"],
			darkpulse: ["1L1"],
			decorate: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			faketears: ["1L1"],
			finalgambit: ["1L1"],
			firefang: ["1L1"],
			firstimpression: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			gunkshot: ["1L1"],
			hex: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			icefang: ["1L1"],
			imprison: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			metalclaw: ["1L1"],
			mudslap: ["1L1"],
			nobleroar: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			playrough: ["1L1"],
			protect: ["1L1"],
			recover: ["1L1"],
			reflect: ["1L1"],
			rest: ["1L1"],
			revenge: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scald: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snarl: ["1L1"],
			snore: ["1L1"],
			spite: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			switcheroo: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			thunderfang: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trailblaze: ["1L1"],
			uproar: ["1L1"],
			venomdrench: ["1L1"],
			wideguard: ["1L1"],
		},
		eventData: [
			{generation: 8, level: 50, moves: ["1L1"], pokeball: "cherishball"},
		],
	},
	venomicon: {
		learnset: {
			acidspray: ["1L1"],
			aircutter: ["1L1"],
			airslash: ["1L1"],
			assurance: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bravebird: ["1L1"],
			clearsmog: ["1L1"],
			coil: ["1L1"],
			confuseray: ["1L1"],
			darkpulse: ["1L1"],
			drillpeck: ["1L1"],
			dualwingbeat: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fly: ["1L1"],
			focusenergy: ["1L1"],
			foulplay: ["1L1"],
			gigaimpact: ["1L1"],
			guardswap: ["1L1"],
			gunkshot: ["1L1"],
			hex: ["1L1"],
			hurricane: ["1L1"],
			hyperbeam: ["1L1"],
			imprison: ["1L1"],
			irondefense: ["1L1"],
			knockoff: ["1L1"],
			lashout: ["1L1"],
			magicalleaf: ["1L1"],
			magicroom: ["1L1"],
			meanlook: ["1L1"],
			memento: ["1L1"],
			nastyplot: ["1L1"],
			payback: ["1L1"],
			peck: ["1L1"],
			phantomforce: ["1L1"],
			poisonjab: ["1L1"],
			poisonsting: ["1L1"],
			powerswap: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			rest: ["1L1"],
			retaliate: ["1L1"],
			roost: ["1L1"],
			round: ["1L1"],
			safeguard: ["1L1"],
			scaryface: ["1L1"],
			shadowball: ["1L1"],
			skillswap: ["1L1"],
			sleeptalk: ["1L1"],
			sludgebomb: ["1L1"],
			sludgewave: ["1L1"],
			snore: ["1L1"],
			stealthrock: ["1L1"],
			steelwing: ["1L1"],
			substitute: ["1L1"],
			swift: ["1L1"],
			tailwind: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			toxic: ["1L1"],
			toxicspikes: ["1L1"],
			trick: ["1L1"],
			uturn: ["1L1"],
			venomdrench: ["1L1"],
			venoshock: ["1L1"],
			withdraw: ["1L1"],
		},
	},
	saharascal: {
		learnset: {
			ancientpower: ["1L1"],
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			megakick: ["1L1"],
			mudshot: ["1L1"],
			painsplit: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			protect: ["1L1"],
			rapidspin: ["1L1"],
			rest: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			substitute: ["1L1"],
			swallow: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	saharaja: {
		learnset: {
			attract: ["1L1"],
			bodypress: ["1L1"],
			bodyslam: ["1L1"],
			bulldoze: ["1L1"],
			dazzlinggleam: ["1L1"],
			diamondstorm: ["1L1"],
			doubleedge: ["1L1"],
			earthpower: ["1L1"],
			earthquake: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			fissure: ["1L1"],
			flashcannon: ["1L1"],
			gigaimpact: ["1L1"],
			healbell: ["1L1"],
			heavyslam: ["1L1"],
			highhorsepower: ["1L1"],
			hornleech: ["1L1"],
			hyperbeam: ["1L1"],
			lashout: ["1L1"],
			megakick: ["1L1"],
			mudshot: ["1L1"],
			outrage: ["1L1"],
			payback: ["1L1"],
			payday: ["1L1"],
			powergem: ["1L1"],
			protect: ["1L1"],
			rest: ["1L1"],
			rocktomb: ["1L1"],
			round: ["1L1"],
			sandattack: ["1L1"],
			sandstorm: ["1L1"],
			sandtomb: ["1L1"],
			scorchingsands: ["1L1"],
			sleeptalk: ["1L1"],
			snore: ["1L1"],
			spitup: ["1L1"],
			stealthrock: ["1L1"],
			stockpile: ["1L1"],
			stomp: ["1L1"],
			stompingtantrum: ["1L1"],
			stoneedge: ["1L1"],
			substitute: ["1L1"],
			swallow: ["1L1"],
			swordsdance: ["1L1"],
			tackle: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thief: ["1L1"],
			watergun: ["1L1"],
			waterpulse: ["1L1"],
		},
	},
	ababo: {
		learnset: {
			bodyslam: ["1L1"],
			bulkup: ["1L1"],
			charm: ["1L1"],
			copycat: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disable: ["1L1"],
			disarmingvoice: ["1L1"],
			drainingkiss: ["1L1"],
			endure: ["1L1"],
			explosion: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			grassknot: ["1L1"],
			helpinghand: ["1L1"],
			hypervoice: ["1L1"],
			lashout: ["1L1"],
			lightscreen: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			sweetkiss: ["1L1"],
			takedown: ["1L1"],
			terablast: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			wildcharge: ["1L1"],
			wish: ["1L1"],
		},
	},
	scattervein: {
		learnset: {
			batonpass: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			charm: ["1L1"],
			copycat: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disable: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			explosion: ["1L1"],
			extremespeed: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			flamethrower: ["1L1"],
			fling: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			lashout: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			seismictoss: ["1L1"],
			shadowball: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			sweetkiss: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			tickle: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			wish: ["1L1"],
			wrap: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	hemogoblin: {
		learnset: {
			batonpass: ["1L1"],
			bitterblade: ["1L1"],
			bodyslam: ["1L1"],
			brutalswing: ["1L1"],
			bulkup: ["1L1"],
			burningjealousy: ["1L1"],
			charm: ["1L1"],
			copycat: ["1L1"],
			dazzlinggleam: ["1L1"],
			defensecurl: ["1L1"],
			disable: ["1L1"],
			disarmingvoice: ["1L1"],
			doubleedge: ["1L1"],
			drainingkiss: ["1L1"],
			echoedvoice: ["1L1"],
			endure: ["1L1"],
			energyball: ["1L1"],
			facade: ["1L1"],
			fireblast: ["1L1"],
			firelash: ["1L1"],
			flamethrower: ["1L1"],
			flareblitz: ["1L1"],
			fling: ["1L1"],
			gigaimpact: ["1L1"],
			grassknot: ["1L1"],
			heatwave: ["1L1"],
			helpinghand: ["1L1"],
			hyperbeam: ["1L1"],
			hypervoice: ["1L1"],
			imprison: ["1L1"],
			lashout: ["1L1"],
			lifedew: ["1L1"],
			lightscreen: ["1L1"],
			magicalleaf: ["1L1"],
			metronome: ["1L1"],
			mistyexplosion: ["1L1"],
			mistyterrain: ["1L1"],
			moonblast: ["1L1"],
			moonlight: ["1L1"],
			overheat: ["1L1"],
			playrough: ["1L1"],
			pound: ["1L1"],
			protect: ["1L1"],
			psychic: ["1L1"],
			psyshock: ["1L1"],
			raindance: ["1L1"],
			rest: ["1L1"],
			safeguard: ["1L1"],
			screech: ["1L1"],
			shadowball: ["1L1"],
			slam: ["1L1"],
			sleeptalk: ["1L1"],
			solarbeam: ["1L1"],
			spikes: ["1L1"],
			substitute: ["1L1"],
			sunnyday: ["1L1"],
			sweetkiss: ["1L1"],
			tailwhip: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunder: ["1L1"],
			thunderbolt: ["1L1"],
			tickle: ["1L1"],
			trailblaze: ["1L1"],
			trick: ["1L1"],
			wildcharge: ["1L1"],
			willowisp: ["1L1"],
			wrap: ["1L1"],
			zenheadbutt: ["1L1"],
		},
	},
	cresceidon: {
		learnset: {
			earthpower: ["1L1"],
			encore: ["1L1"],
			endure: ["1L1"],
			facade: ["1L1"],
			haze: ["1L1"],
			healingwish: ["1L1"],
			helpinghand: ["1L1"],
			hydropump: ["1L1"],
			moonblast: ["1L1"],
			protect: ["1L1"],
			recover: ["1L1"],
			rest: ["1L1"],
			scald: ["1L1"],
			sleeptalk: ["1L1"],
			substitute: ["1L1"],
			surf: ["1L1"],
			takedown: ["1L1"],
			taunt: ["1L1"],
			terablast: ["1L1"],
			thunderwave: ["1L1"],
			whirlpool: ["1L1"],
			wish: ["1L1"],
		},
	},
};